import $ from 'jquery';
window.jQuery = $;
window.$ = $;

var FLIPBOOK = FLIPBOOK || {};

/*! iScroll v5.2.0-snapshot ~ (c) 2008-2017 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
    var rAF = window.requestAnimationFrame	||
        window.webkitRequestAnimationFrame	||
        window.mozRequestAnimationFrame		||
        window.oRequestAnimationFrame		||
        window.msRequestAnimationFrame		||
        function (callback) { window.setTimeout(callback, 1000 / 60); };
    
    var utils = (function () {
        var me = {};
    
        var _elementStyle = document.createElement('div').style;
        var _vendor = (function () {
            var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                transform,
                i = 0,
                l = vendors.length;
    
            for ( ; i < l; i++ ) {
                transform = vendors[i] + 'ransform';
                if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
            }
    
            return false;
        })();
    
        function _prefixStyle (style) {
            if ( _vendor === false ) return false;
            if ( _vendor === '' ) return style;
            return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
        }
    
        me.getTime = Date.now || function getTime () { return new Date().getTime(); };
    
        me.extend = function (target, obj) {
            for ( var i in obj ) {
                target[i] = obj[i];
            }
        };
    
        me.addEvent = function (el, type, fn, capture) {
            el.addEventListener(type, fn, !!capture);
        };
    
        me.removeEvent = function (el, type, fn, capture) {
            el.removeEventListener(type, fn, !!capture);
        };
    
        me.prefixPointerEvent = function (pointerEvent) {
            return window.MSPointerEvent ?
                'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
                pointerEvent;
        };
    
        me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
            var distance = current - start,
                speed = Math.abs(distance) / time,
                destination,
                duration;
    
            deceleration = deceleration === undefined ? 0.0006 : deceleration;
    
            destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
            duration = speed / deceleration;
    
            if ( destination < lowerMargin ) {
                destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
                distance = Math.abs(destination - current);
                duration = distance / speed;
            } else if ( destination > 0 ) {
                destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
                distance = Math.abs(current) + destination;
                duration = distance / speed;
            }
    
            return {
                destination: Math.round(destination),
                duration: duration
            };
        };
    
        var _transform = _prefixStyle('transform');
    
        me.extend(me, {
            hasTransform: _transform !== false,
            hasPerspective: _prefixStyle('perspective') in _elementStyle,
            hasTouch: 'ontouchstart' in window,
            hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
            hasTransition: _prefixStyle('transition') in _elementStyle
        });
    
        /*
        This should find all Android browsers lower than build 535.19 (both stock browser and webview)
        - galaxy S2 is ok
        - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
        - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
       - galaxy S3 is badAndroid (stock brower, webview)
         `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
       - galaxy S4 is badAndroid (stock brower, webview)
         `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
       - galaxy S5 is OK
         `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
       - galaxy S6 is OK
         `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
      */
        me.isBadAndroid = (function() {
            var appVersion = window.navigator.appVersion;
            // Android browser is not a chrome browser.
            if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
                var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
                if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
                    return parseFloat(safariVersion[1]) < 535.19;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        })();
    
        me.extend(me.style = {}, {
            transform: _transform,
            transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
            transitionDuration: _prefixStyle('transitionDuration'),
            transitionDelay: _prefixStyle('transitionDelay'),
            transformOrigin: _prefixStyle('transformOrigin'),
            touchAction: _prefixStyle('touchAction')
        });
    
        me.hasClass = function (e, c) {
            var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
            return re.test(e.className);
        };
    
        me.addClass = function (e, c) {
            if ( me.hasClass(e, c) ) {
                return;
            }
    
            var newclass = e.className.split(' ');
            newclass.push(c);
            e.className = newclass.join(' ');
        };
    
        me.removeClass = function (e, c) {
            if ( !me.hasClass(e, c) ) {
                return;
            }
    
            var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
            e.className = e.className.replace(re, ' ');
        };
    
        me.offset = function (el) {
            var left = -el.offsetLeft,
                top = -el.offsetTop;
    
            // jshint -W084
            while (el = el.offsetParent) {
                left -= el.offsetLeft;
                top -= el.offsetTop;
            }
            // jshint +W084
    
    
            /*custom*/
            return {left:0,top:0};
            /*end*/
    
            return {
                left: left,
                top: top
            };
        };
    
        me.preventDefaultException = function (el, exceptions) {
            for ( var i in exceptions ) {
                if ( exceptions[i].test(el[i]) ) {
                    return true;
                }
            }
    
            return false;
        };
    
        me.extend(me.eventType = {}, {
            touchstart: 1,
            touchmove: 1,
            touchend: 1,
    
            mousedown: 2,
            mousemove: 2,
            mouseup: 2,
    
            pointerdown: 3,
            pointermove: 3,
            pointerup: 3,
    
            MSPointerDown: 3,
            MSPointerMove: 3,
            MSPointerUp: 3
        });
    
        me.extend(me.ease = {}, {
            quadratic: {
                style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                fn: function (k) {
                    return k * ( 2 - k );
                }
            },
            circular: {
                style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
                fn: function (k) {
                    return Math.sqrt( 1 - ( --k * k ) );
                }
            },
            back: {
                style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                fn: function (k) {
                    var b = 4;
                    return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
                }
            },
            bounce: {
                style: '',
                fn: function (k) {
                    if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
                        return 7.5625 * k * k;
                    } else if ( k < ( 2 / 2.75 ) ) {
                        return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
                    } else if ( k < ( 2.5 / 2.75 ) ) {
                        return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
                    } else {
                        return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
                    }
                }
            },
            elastic: {
                style: '',
                fn: function (k) {
                    var f = 0.22,
                        e = 0.4;
    
                    if ( k === 0 ) { return 0; }
                    if ( k == 1 ) { return 1; }
    
                    return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
                }
            }
        });
    
        me.tap = function (e, eventName) {
            var ev = document.createEvent('Event');
            ev.initEvent(eventName, true, true);
            ev.pageX = e.pageX;
            ev.pageY = e.pageY;
            e.target.dispatchEvent(ev);
        };
    
        me.click = function (e) {
            var target = e.target,
                ev;
    
            if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
                // initMouseEvent is deprecated.
                ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
                ev.initEvent('click', true, true);
                ev.view = e.view || window;
                ev.detail = 1;
                ev.screenX = target.screenX || 0;
                ev.screenY = target.screenY || 0;
                ev.clientX = target.clientX || 0;
                ev.clientY = target.clientY || 0;
                ev.ctrlKey = !!e.ctrlKey;
                ev.altKey = !!e.altKey;
                ev.shiftKey = !!e.shiftKey;
                ev.metaKey = !!e.metaKey;
                ev.button = 0;
                ev.relatedTarget = null;
                ev._constructed = true;
                target.dispatchEvent(ev);
            }
        };
    
        me.getTouchAction = function(eventPassthrough, addPinch) {
            var touchAction = 'none';
            if ( eventPassthrough === 'vertical' ) {
                touchAction = 'pan-y';
            } else if (eventPassthrough === 'horizontal' ) {
                touchAction = 'pan-x';
            }
            if (addPinch && touchAction != 'none') {
                // add pinch-zoom support if the browser supports it, but if not (eg. Chrome <55) do nothing
                touchAction += ' pinch-zoom';
            }
            return touchAction;
        };
    
        me.getRect = function(el) {
            if (el instanceof SVGElement) {
                var rect = el.getBoundingClientRect();
                return {
                    top : rect.top,
                    left : rect.left,
                    width : rect.width,
                    height : rect.height
                };
            } else {
                return {
                    top : el.offsetTop,
                    left : el.offsetLeft,
                    width : el.offsetWidth,
                    height : el.offsetHeight
                };
            }
        };
    
        return me;
    })();
    function IScroll (el, options) {
        this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
        this.scroller = this.wrapper.children[0];
        this.scrollerStyle = this.scroller.style;		// cache style for better performance
    
        this.options = {
    
            zoomMin: 1,
            zoomMax: 4, startZoom: 1,
    
            resizeScrollbars: true,
    
            mouseWheelSpeed: 20,
    
            snapThreshold: 0.334,
    
    // INSERT POINT: OPTIONS
            disablePointer : !utils.hasPointer,
            disableTouch : utils.hasPointer || !utils.hasTouch,
            disableMouse : utils.hasPointer || utils.hasTouch,
            startX: 0,
            startY: 0,
            scrollY: true,
            directionLockThreshold: 5,
            momentum: true,
    
            bounce: true,
            bounceTime: 600,
            bounceEasing: '',
    
            preventDefault: true,
            preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },
    
            HWCompositing: true,
            useTransition: true,
            useTransform: true,
            bindToWrapper: typeof window.onmousedown === "undefined"
        };
    
        for ( var i in options ) {
            this.options[i] = options[i];
        }
    
        // Normalize options
        this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
    
        this.options.useTransition = utils.hasTransition && this.options.useTransition;
        this.options.useTransform = utils.hasTransform && this.options.useTransform;
    
        this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
        this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
    
        // If you want eventPassthrough I have to lock one of the axes
        this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
        this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;
    
        // With eventPassthrough we also need lockDirection mechanism
        this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
        this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
    
        this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
    
        this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
    
        if ( this.options.tap === true ) {
            this.options.tap = 'tap';
        }
    
        // https://github.com/cubiq/iscroll/issues/1029
        if (!this.options.useTransition && !this.options.useTransform) {
            if(!(/relative|absolute/i).test(this.scrollerStyle.position)) {
                this.scrollerStyle.position = "relative";
            }
        }
    
        if ( this.options.shrinkScrollbars == 'scale' ) {
            this.options.useTransition = false;
        }
    
        this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;
    
    // INSERT POINT: NORMALIZATION
    
        // Some defaults
        this.x = 0;
        this.y = 0;
        this.directionX = 0;
        this.directionY = 0;
        this._events = {};
    
        this.scale = Math.min(Math.max(this.options.startZoom, this.options.zoomMin), this.options.zoomMax);
    
    // INSERT POINT: DEFAULTS
    
        this._init();
        this.refresh();
    
        this.scrollTo(this.options.startX, this.options.startY);
        this.enable();
    }
    window.IScroll = IScroll;
    
    IScroll.prototype = {
        version: '5.2.0-snapshot',
    
        _init: function () {
            this._initEvents();
    
            if ( this.options.zoom ) {
                this._initZoom();
            }
    
            if ( this.options.scrollbars || this.options.indicators ) {
                this._initIndicators();
            }
    
            if ( this.options.mouseWheel ) {
                this._initWheel();
            }
    
            if ( this.options.snap ) {
                this._initSnap();
            }
    
            if ( this.options.keyBindings ) {
                this._initKeys();
            }
    
    // INSERT POINT: _init
    
        },
    
        destroy: function () {
            this._initEvents(true);
            clearTimeout(this.resizeTimeout);
             this.resizeTimeout = null;
            this._execEvent('destroy');
        },
    
        _transitionEnd: function (e) {
            if ( e.target != this.scroller || !this.isInTransition ) {
                return;
            }
    
            this._transitionTime();
            if ( !this.resetPosition(this.options.bounceTime) ) {
                this.isInTransition = false;
                this._execEvent('scrollEnd');
            }
        },
    
        _start: function (e) {
    
            //ignore secondary touch
            if(e.type == "pointerdown" && !e.isPrimary){
                return
            }
            // React to left mouse button only
            if ( utils.eventType[e.type] != 1 ) {
              // for button property
              // http://unixpapa.com/js/mouse.html
              var button;
            if (!e.which) {
              /* IE case */
              button = (e.button < 2) ? 0 :
                       ((e.button == 4) ? 1 : 2);
            } else {
              /* All others */
              button = e.button;
            }
                if ( button !== 0 ) {
                    return;
                }
            }
    
            if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
                return;
            }
    
            if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
                e.preventDefault();
            }
    
            var point = e.touches ? e.touches[0] : e,
                pos;
    
            this.initiated	= utils.eventType[e.type];
            this.moved		= false;
            this.distX		= 0;
            this.distY		= 0;
            this.directionX = 0;
            this.directionY = 0;
            this.directionLocked = 0;
    
            this.startTime = utils.getTime();
    
            if ( this.options.useTransition && this.isInTransition ) {
                this._transitionTime();
                this.isInTransition = false;
                pos = this.getComputedPosition();
                this._translate(Math.round(pos.x), Math.round(pos.y));
                this._execEvent('scrollEnd');
            } else if ( !this.options.useTransition && this.isAnimating ) {
                this.isAnimating = false;
                this._execEvent('scrollEnd');
            }
    
            this.startX    = this.x;
            this.startY    = this.y;
            this.absStartX = this.x;
            this.absStartY = this.y;
            this.pointX    = point.pageX;
            this.pointY    = point.pageY;
    
            this._execEvent('beforeScrollStart');
        },
    
        _move: function (e) {
            if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
                return;
            }
    
            //ignore secondary touch
            if(e.type == "pointermove" && !e.isPrimary){
                return
            }
    
            if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
                e.preventDefault();
            }
    
            var point		= e.touches ? e.touches[0] : e,
                deltaX		= point.pageX - this.pointX,
                deltaY		= point.pageY - this.pointY,
                timestamp	= utils.getTime(),
                newX, newY,
                absDistX, absDistY;
    
            this.pointX		= point.pageX;
            this.pointY		= point.pageY;
    
            this.distX		+= deltaX;
            this.distY		+= deltaY;
            absDistX		= Math.abs(this.distX);
            absDistY		= Math.abs(this.distY);
    
            // We need to move at least 10 pixels for the scrolling to initiate
            if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
                return;
            }
    
            // If you are scrolling in one direction lock the other
            if ( !this.directionLocked && !this.options.freeScroll ) {
                if ( absDistX > absDistY + this.options.directionLockThreshold ) {
                    this.directionLocked = 'h';		// lock horizontally
                } else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
                    this.directionLocked = 'v';		// lock vertically
                } else {
                    this.directionLocked = 'n';		// no lock
                }
            }
    
            if ( this.directionLocked == 'h' ) {
                if ( this.options.eventPassthrough == 'vertical' ) {
                    e.preventDefault();
                } else if ( this.options.eventPassthrough == 'horizontal' ) {
                    this.initiated = false;
                    return;
                }
    
                deltaY = 0;
            } else if ( this.directionLocked == 'v' ) {
                if ( this.options.eventPassthrough == 'horizontal' ) {
                    e.preventDefault();
                } else if ( this.options.eventPassthrough == 'vertical' ) {
                    this.initiated = false;
                    return;
                }
    
                deltaX = 0;
            }
    
            deltaX = this.hasHorizontalScroll ? deltaX : 0;
            deltaY = this.hasVerticalScroll ? deltaY : 0;
    
            newX = this.x + deltaX;
            newY = this.y + deltaY;
    
            // Slow down if outside of the boundaries
            if ( newX > 0 || newX < this.maxScrollX ) {
                newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
            }
            if ( newY > 0 || newY < this.maxScrollY ) {
                newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
            }
    
            this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
            this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
    
            if ( !this.moved ) {
                this._execEvent('scrollStart');
            }
    
            this.moved = true;
    
            this._translate(newX, newY);
    
    /* REPLACE START: _move */
    
            if ( timestamp - this.startTime > 300 ) {
                this.startTime = timestamp;
                this.startX = this.x;
                this.startY = this.y;
            }
    
    /* REPLACE END: _move */
    
        },
    
        _end: function (e) {
            
            if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
                return;
            }
    
            //ignore secondary touch
            if(e.type == "pointerup" && !e.isPrimary){
                return
            }
    
            if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
                e.preventDefault();
            }
    
            var point = e.changedTouches ? e.changedTouches[0] : e,
                momentumX,
                momentumY,
                duration = utils.getTime() - this.startTime,
                newX = Math.round(this.x),
                newY = Math.round(this.y),
                distanceX = Math.abs(newX - this.startX),
                distanceY = Math.abs(newY - this.startY),
                time = 0,
                easing = '';
    
            this.isInTransition = 0;
            this.initiated = 0;
            this.endTime = utils.getTime();
    
            // reset if we are outside of the boundaries
            if ( this.resetPosition(this.options.bounceTime) ) {
                return;
            }
    
            this.scrollTo(newX, newY);	// ensures that the last position is rounded
    
            // we scrolled less than 10 pixels
            if ( !this.moved ) {
                if ( this.options.tap ) {
                    utils.tap(e, this.options.tap);
                }
    
                if ( this.options.click ) {
                    utils.click(e);
                }
    
                this._execEvent('scrollCancel');
                return;
            }
    
            if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
                this._execEvent('flick');
                return;
            }
    
            // start momentum animation if needed
            if ( this.options.momentum && duration < 300 ) {
                momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
                momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
                newX = momentumX.destination;
                newY = momentumY.destination;
                time = Math.max(momentumX.duration, momentumY.duration);
                this.isInTransition = 1;
            }
    
    
            if ( this.options.snap ) {
                var snap = this._nearestSnap(newX, newY);
                this.currentPage = snap;
                time = this.options.snapSpeed || Math.max(
                        Math.max(
                            Math.min(Math.abs(newX - snap.x), 1000),
                            Math.min(Math.abs(newY - snap.y), 1000)
                        ), 300);
                newX = snap.x;
                newY = snap.y;
    
                this.directionX = 0;
                this.directionY = 0;
                easing = this.options.bounceEasing;
            }
    
    // INSERT POINT: _end
    
            if ( newX != this.x || newY != this.y ) {
                // change easing function when scroller goes out of the boundaries
                if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
                    easing = utils.ease.quadratic;
                }
    
                this.scrollTo(newX, newY, time, easing);
    
                //custom
                this._execEvent('scrollToPage');
                return;
            }
    
            this._execEvent('scrollEnd');
        },
    
        _resize: function () {
            var that = this;
    
            clearTimeout(this.resizeTimeout);
    
            this.resizeTimeout = setTimeout(function () {
                that.refresh();
            }, this.options.resizePolling);
        },
    
        resetPosition: function (time) {
            var x = this.x,
                y = this.y;
    
            time = time || 0;
    
            if ( !this.hasHorizontalScroll || this.x > 0 ) {
                x = 0;
            } else if ( this.x < this.maxScrollX ) {
                x = this.maxScrollX;
            }
    
            if ( !this.hasVerticalScroll || this.y > 0 ) {
                y = 0;
            } else if ( this.y < this.maxScrollY ) {
                y = this.maxScrollY;
            }
    
            if ( x == this.x && y == this.y ) {
                return false;
            }
    
            this.scrollTo(x, y, time, this.options.bounceEasing);
    
            return true;
        },
    
        disable: function () {
            this.enabled = false;
        },
    
        enable: function () {
            this.enabled = true;
        },
    
        //custom
    
        setScrollerSize: function(w,h){
            this.scrollerW = w 
            this.scrollerH = h
        },
    
        setWrapperOffset: function(left,top){
            this.wrapperOffsetLeft = left
            this.wrapperOffsetTop = top
        },
    
        //custom end
    
        refresh: function () {
    
            utils.getRect(this.wrapper);		// Force reflow
    
            this.wrapperWidth	= this.wrapper.clientWidth;
            this.wrapperHeight	= this.wrapper.clientHeight;
    
            var rect = utils.getRect(this.scroller);
            if(this.scrollerW) rect.width = this.scrollerW 
            if(this.scrollerH) rect.height = this.scrollerH 
    /* REPLACE START: refresh */
        this.scrollerWidth	= Math.round(rect.width * this.scale);
        this.scrollerHeight	= Math.round(rect.height * this.scale);
    
        this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
        this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;
    /* REPLACE END: refresh */
    
            this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
            this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;
            
            if ( !this.hasHorizontalScroll ) {
                this.maxScrollX = 0;
                this.scrollerWidth = this.wrapperWidth;
            }
    
            if ( !this.hasVerticalScroll ) {
                this.maxScrollY = 0;
                this.scrollerHeight = this.wrapperHeight;
            }
    
            this.endTime = 0;
            this.directionX = 0;
            this.directionY = 0;
            
            if(utils.hasPointer && !this.options.disablePointer) {
                // The wrapper should have `touchAction` property for using pointerEvent.
                this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, true);
    
                // case. not support 'pinch-zoom'
                // https://github.com/cubiq/iscroll/issues/1118#issuecomment-270057583
                if (!this.wrapper.style[utils.style.touchAction]) {
                    this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, false);
                }
            }
            this.wrapperOffset = utils.offset(this.wrapper);
            if(this.wrapperOffsetLeft) 
                this.wrapperOffset.left = this.wrapperOffsetLeft
            if(this.wrapperOffsetTop) 
                this.wrapperOffset.top = this.wrapperOffsetTop
    
            this._execEvent('refresh');
    
            this.resetPosition();
    
    // INSERT POINT: _refresh
    
        },	
    
        on: function (type, fn) {
            if ( !this._events[type] ) {
                this._events[type] = [];
            }
    
            this._events[type].push(fn);
        },
    
        off: function (type, fn) {
            if ( !this._events[type] ) {
                return;
            }
    
            var index = this._events[type].indexOf(fn);
    
            if ( index > -1 ) {
                this._events[type].splice(index, 1);
            }
        },
    
        _execEvent: function (type) {
            if ( !this._events[type] ) {
                return;
            }
    
            var i = 0,
                l = this._events[type].length;
    
            if ( !l ) {
                return;
            }
    
            for ( ; i < l; i++ ) {
                this._events[type][i].apply(this, [].slice.call(arguments, 1));
            }
        },
    
        scrollBy: function (x, y, time, easing) {
            x = this.x + x;
            y = this.y + y;
            time = time || 0;
    
            this.scrollTo(x, y, time, easing);
        },
    
        //custom
    
        getScrollerWidth:function(){
            return this.scrollerW !== undefined ? this.scrollerW : this.scroller.offsetWidth 
        },
    
        getScrollerHeight:function(){
            return this.scrollerH !== undefined ? this.scrollerH : this.scroller.offsetHeight 
        },
    
        //end custom
    
        scrollTo: function (x, y, time, easing) {
    
            /*custom*/
            if(time){
    
                if(this.prevDisabled && x == 0){
                    this.goToPage(1,0,0)
                    return
                }
    
                if(this.nextDisabled && x == -(this.scrollerWidth - this.wrapperWidth)){
                    this.goToPage(1,0,0)
                    return
                }
    
            }
            
                
            if (this.options.keepInCenterH && this.getScrollerWidth() * this.scale < this.wrapperWidth)
                    x = this.wrapperWidth / 2 - this.getScrollerWidth() * this.scale / 2
    
                if (this.options.keepInCenterV && this.getScrollerHeight() * this.scale < this.wrapperHeight)
                    y = this.wrapperHeight / 2 - this.getScrollerHeight() * this.scale / 2
    /*end custom*/
    
            easing = easing || utils.ease.circular;
    
            this.isInTransition = this.options.useTransition && time > 0;
            var transitionType = this.options.useTransition && easing.style;
            if ( !time || transitionType ) {
                    if(transitionType) {
                        this._transitionTimingFunction(easing.style);
                        this._transitionTime(time);
                    }
                this._translate(x, y);
            } else {
                this._animate(x, y, time, easing.fn);
            }
        },
    
        scrollToElement: function (el, time, offsetX, offsetY, easing) {
            el = el.nodeType ? el : this.scroller.querySelector(el);
    
            if ( !el ) {
                return;
            }
    
            var pos = utils.offset(el);
    
            pos.left -= this.wrapperOffset.left;
            pos.top  -= this.wrapperOffset.top;
    
            // if offsetX/Y are true we center the element to the screen
            var elRect = utils.getRect(el);
            var wrapperRect = utils.getRect(this.wrapper);
            if ( offsetX === true ) {
                offsetX = Math.round(elRect.width / 2 - wrapperRect.width / 2);
            }
            if ( offsetY === true ) {
                offsetY = Math.round(elRect.height / 2 - wrapperRect.height / 2);
            }
    
            pos.left -= offsetX || 0;
            pos.top  -= offsetY || 0;
    
            pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
            pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;
    
            time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;
    
            this.scrollTo(pos.left, pos.top, time, easing);
        },
    
        _transitionTime: function (time) {
            if (!this.options.useTransition) {
                return;
            }
            time = time || 0;
            var durationProp = utils.style.transitionDuration;
            if(!durationProp) {
                return;
            }
    
            this.scrollerStyle[durationProp] = time + 'ms';
    
            if ( !time && utils.isBadAndroid ) {
                this.scrollerStyle[durationProp] = '0.0001ms';
                // remove 0.0001ms
                var self = this;
                rAF(function() {
                    if(self.scrollerStyle[durationProp] === '0.0001ms') {
                        self.scrollerStyle[durationProp] = '0s';
                    }
                });
            }
    
    
            if ( this.indicators ) {
                for ( var i = this.indicators.length; i--; ) {
                    this.indicators[i].transitionTime(time);
                }
            }
    
    
    // INSERT POINT: _transitionTime
    
        },
    
        _transitionTimingFunction: function (easing) {
            this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
    
    
            if ( this.indicators ) {
                for ( var i = this.indicators.length; i--; ) {
                    this.indicators[i].transitionTimingFunction(easing);
                }
            }
    
    
    // INSERT POINT: _transitionTimingFunction
    
        },
    
        _translate: function (x, y) {
    
            if ( this.options.useTransform ) {
    
    /* REPLACE START: _translate */			this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px) scale(' + this.scale + ') ' + this.translateZ;/* REPLACE END: _translate */
    
            } else {
                x = Math.round(x);
                y = Math.round(y);
                this.scrollerStyle.left = x + 'px';
                this.scrollerStyle.top = y + 'px';
            }
    
            this.x = x;
            this.y = y;
    
    
        if ( this.indicators ) {
            for ( var i = this.indicators.length; i--; ) {
                this.indicators[i].updatePosition();
            }
        }
    
    
    // INSERT POINT: _translate
    
        },
    
        _initEvents: function (remove) {
            var eventType = remove ? utils.removeEvent : utils.addEvent,
                target = this.options.bindToWrapper ? this.wrapper : window;
    
            eventType(window, 'orientationchange', this);
            eventType(window, 'resize', this);
    
            if ( this.options.click ) {
                eventType(this.wrapper, 'click', this, true);
            }
    
            if ( !this.options.disableMouse ) {
                eventType(this.wrapper, 'mousedown', this);
                eventType(target, 'mousemove', this);
                eventType(target, 'mousecancel', this);
                eventType(target, 'mouseup', this);
            }
    
            if ( utils.hasPointer && !this.options.disablePointer ) {
                eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
                eventType(target, utils.prefixPointerEvent('pointermove'), this);
                eventType(target, utils.prefixPointerEvent('pointercancel'), this);
                eventType(target, utils.prefixPointerEvent('pointerup'), this);
            }
    
            if ( utils.hasTouch && !this.options.disableTouch ) {
                eventType(this.wrapper, 'touchstart', this);
                eventType(target, 'touchmove', this);
                eventType(target, 'touchcancel', this);
                eventType(target, 'touchend', this);
            }
    
            eventType(this.scroller, 'transitionend', this);
            eventType(this.scroller, 'webkitTransitionEnd', this);
            eventType(this.scroller, 'oTransitionEnd', this);
            eventType(this.scroller, 'MSTransitionEnd', this);
        },
    
        getComputedPosition: function () {
            var matrix = window.getComputedStyle(this.scroller, null),
                x, y;
    
            if ( this.options.useTransform ) {
                matrix = matrix[utils.style.transform].split(')')[0].split(', ');
                x = +(matrix[12] || matrix[4]);
                y = +(matrix[13] || matrix[5]);
            } else {
                x = +matrix.left.replace(/[^-\d.]/g, '');
                y = +matrix.top.replace(/[^-\d.]/g, '');
            }
    
            return { x: x, y: y };
        },
        _initIndicators: function () {
            var interactive = this.options.interactiveScrollbars,
                customStyle = typeof this.options.scrollbars != 'string',
                indicators = [],
                indicator;
    
            var that = this;
    
            this.indicators = [];
    
            if ( this.options.scrollbars ) {
                // Vertical scrollbar
                if ( this.options.scrollY ) {
                    indicator = {
                        el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenX: false
                    };
    
                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }
    
                // Horizontal scrollbar
                if ( this.options.scrollX ) {
                    indicator = {
                        el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenY: false
                    };
    
                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }
            }
    
            if ( this.options.indicators ) {
                // TODO: check concat compatibility
                indicators = indicators.concat(this.options.indicators);
            }
    
            for ( var i = indicators.length; i--; ) {
                this.indicators.push( new Indicator(this, indicators[i]) );
            }
    
            // TODO: check if we can use array.map (wide compatibility and performance issues)
            function _indicatorsMap (fn) {
                if (that.indicators) {
                    for ( var i = that.indicators.length; i--; ) {
                        fn.call(that.indicators[i]);
                    }
                }
            }
    
            if ( this.options.fadeScrollbars ) {
                this.on('scrollEnd', function () {
                    _indicatorsMap(function () {
                        this.fade();
                    });
                });
    
                this.on('scrollCancel', function () {
                    _indicatorsMap(function () {
                        this.fade();
                    });
                });
    
                this.on('scrollStart', function () {
                    _indicatorsMap(function () {
                        this.fade(1);
                    });
                });
    
                this.on('beforeScrollStart', function () {
                    _indicatorsMap(function () {
                        this.fade(1, true);
                    });
                });
            }
    
    
            this.on('refresh', function () {
                _indicatorsMap(function () {
                    this.refresh();
                });
            });
    
            this.on('destroy', function () {
                _indicatorsMap(function () {
                    this.destroy();
                });
    
                delete this.indicators;
            });
        },
    
        _initZoom: function () {
            this.scrollerStyle[utils.style.transformOrigin] = '0 0';
        },
    
        _zoomStart: function (e) {
            var c1 = Math.abs( e.touches[0].pageX - e.touches[1].pageX ),
                c2 = Math.abs( e.touches[0].pageY - e.touches[1].pageY );
    
            this.touchesDistanceStart = Math.sqrt(c1 * c1 + c2 * c2);
            this.startScale = this.scale;
    
            this.originX = Math.abs(e.touches[0].pageX + e.touches[1].pageX) / 2 + this.wrapperOffset.left - this.x;
            this.originY = Math.abs(e.touches[0].pageY + e.touches[1].pageY) / 2 + this.wrapperOffset.top - this.y;
    
            this._execEvent('zoomStart');
        },
    
        _zoom: function (e) {
            if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
                return;
            }
    
            if ( this.options.preventDefault ) {
                e.preventDefault();
            }
    
            var c1 = Math.abs( e.touches[0].pageX - e.touches[1].pageX ),
                c2 = Math.abs( e.touches[0].pageY - e.touches[1].pageY ),
                distance = Math.sqrt( c1 * c1 + c2 * c2 ),
                scale = 1 / this.touchesDistanceStart * distance * this.startScale,
                lastScale,
                x, y;
    
            this.scaled = true;
    
            if ( scale < this.options.zoomMin ) {
                scale = 0.5 * this.options.zoomMin * Math.pow(2.0, scale / this.options.zoomMin);
            } else if ( scale > this.options.zoomMax ) {
                scale = 2.0 * this.options.zoomMax * Math.pow(0.5, this.options.zoomMax / scale);
            }
    
            lastScale = scale / this.startScale;
            x = this.originX - this.originX * lastScale + this.startX;
            y = this.originY - this.originY * lastScale + this.startY;
    
            this.scale = scale;
    
            this.scrollTo(x, y, 0);
        },
    
        _zoomEnd: function (e) {
            if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
                return;
            }
    
            if ( this.options.preventDefault ) {
                e.preventDefault();
            }
    
            var newX, newY,
                lastScale;
    
            this.isInTransition = 0;
            this.initiated = 0;
    
            if ( this.scale > this.options.zoomMax ) {
                this.scale = this.options.zoomMax;
            } else if ( this.scale < this.options.zoomMin ) {
                this.scale = this.options.zoomMin;
            }
    
            // Update boundaries
            this.refresh();
    
            lastScale = this.scale / this.startScale;
    
            newX = this.originX - this.originX * lastScale + this.startX;
            newY = this.originY - this.originY * lastScale + this.startY;
    
            if ( newX > 0 ) {
                newX = 0;
            } else if ( newX < this.maxScrollX ) {
                newX = this.maxScrollX;
            }
    
            if ( newY > 0 ) {
                newY = 0;
            } else if ( newY < this.maxScrollY ) {
                newY = this.maxScrollY;
            }
    
            if ( this.x != newX || this.y != newY ) {
                this.scrollTo(newX, newY, this.options.bounceTime);
            }
    
            this.scaled = false;
    
            this._execEvent('zoomEnd');
        },
    
        zoom: function (scale, x, y, time) {
            
            if ( scale < this.options.zoomMin ) {
                scale = this.options.zoomMin;
            } else if ( scale > this.options.zoomMax ) {
                scale = this.options.zoomMax;
            }
    
            if ( scale == this.scale ) {
                return;
            }
    
            var relScale = scale / this.scale;
    
            /*custom*/
            var that = this
            if(relScale != 1){
                clearTimeout(this.zoomStartTimeout);
                this.zoomStartTimeout = setTimeout(function () {
                    that._execEvent('zoomStart');
                }, 0);
    
                // Execute the zoomEnd event after 400ms the wheel stopped scrolling
                clearTimeout(this.wheelTimeout);
                this.wheelTimeout = setTimeout(function () {
                    that._execEvent('zoomEnd');
                }, Number(time + 100));
    
            
            }
    
            /*custom end*/
    
            x = x === undefined ? this.wrapperWidth / 2 : x;
            y = y === undefined ? this.wrapperHeight / 2 : y;
            time = time === undefined ? 300 : time;
    
            x = x + this.wrapperOffset.left - this.x;
            y = y + this.wrapperOffset.top - this.y;
    
            x = x - x * relScale + this.x;
            y = y - y * relScale + this.y;
    
            this.scale = scale;
    
            this.refresh();		// update boundaries
    
            if ( x > 0 ) {
                x = 0;
            } else if ( x < this.maxScrollX ) {
                x = this.maxScrollX;
            }
    
            if ( y > 0 ) {
                y = 0;
            } else if ( y < this.maxScrollY ) {
                y = this.maxScrollY;
            }
    
            this.scrollTo(x, y, time);
        },
    
        _wheelZoom: function (e) {
            var wheelDeltaY,
                deltaScale,
                that = this;
    
            /*custom - moved to function zoom() 
    
            // Execute the zoomEnd event after 400ms the wheel stopped scrolling
            clearTimeout(this.wheelTimeout);
            this.wheelTimeout = setTimeout(function () {
                that._execEvent('zoomEnd');
            }, 400);
    
            custom end*/
    
            if ( 'deltaX' in e ) {
                wheelDeltaY = -e.deltaY / Math.abs(e.deltaY);
            } else if ('wheelDeltaX' in e) {
                wheelDeltaY = e.wheelDeltaY / Math.abs(e.wheelDeltaY);
            } else if('wheelDelta' in e) {
                wheelDeltaY = e.wheelDelta / Math.abs(e.wheelDelta);
            } else if ('detail' in e) {
                wheelDeltaY = -e.detail / Math.abs(e.wheelDelta);
            } else {
                return;
            }
    
            deltaScale = this.scale + wheelDeltaY / 5;
    
            this.zoom(deltaScale, e.pageX, e.pageY, 0);
        },
    
        _initWheel: function () {
            utils.addEvent(this.wrapper, 'wheel', this);
            utils.addEvent(this.wrapper, 'mousewheel', this);
            utils.addEvent(this.wrapper, 'DOMMouseScroll', this);
    
            this.on('destroy', function () {
                clearTimeout(this.wheelTimeout);
                this.wheelTimeout = null;
                utils.removeEvent(this.wrapper, 'wheel', this);
                utils.removeEvent(this.wrapper, 'mousewheel', this);
                utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
            });
        },
    
        _wheel: function (e) {
            if ( !this.enabled ) {
                return;
            }
    
            e.preventDefault();
    
            var wheelDeltaX, wheelDeltaY,
                newX, newY,
                that = this;
    
            if ( this.wheelTimeout === undefined ) {
                that._execEvent('scrollStart');
            }
    
            // Execute the scrollEnd event after 400ms the wheel stopped scrolling
            clearTimeout(this.wheelTimeout);
            this.wheelTimeout = setTimeout(function () {
                if(!that.options.snap) {
                    that._execEvent('scrollEnd');
                }
                that.wheelTimeout = undefined;
            }, 400);
    
            if ( 'deltaX' in e ) {
                if (e.deltaMode === 1) {
                    wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
                    wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
                } else {
                    wheelDeltaX = -e.deltaX;
                    wheelDeltaY = -e.deltaY;
                }
            } else if ( 'wheelDeltaX' in e ) {
                wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
                wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
            } else if ( 'wheelDelta' in e ) {
                wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
            } else if ( 'detail' in e ) {
                wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
            } else {
                return;
            }
    
            wheelDeltaX *= this.options.invertWheelDirection;
            wheelDeltaY *= this.options.invertWheelDirection;
    
            if ( !this.hasVerticalScroll ) {
                wheelDeltaX = wheelDeltaY;
                wheelDeltaY = 0;
            }
    
            if ( this.options.snap ) {
                newX = this.currentPage.pageX;
                newY = this.currentPage.pageY;
    
                if ( wheelDeltaX > 0 ) {
                    newX--;
                } else if ( wheelDeltaX < 0 ) {
                    newX++;
                }
    
                if ( wheelDeltaY > 0 ) {
                    newY--;
                } else if ( wheelDeltaY < 0 ) {
                    newY++;
                }
    
                this.goToPage(newX, newY);
    
                return;
            }
    
            newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
            newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);
    
            this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
            this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;
    
            if ( newX > 0 ) {
                newX = 0;
            } else if ( newX < this.maxScrollX ) {
                newX = this.maxScrollX;
            }
    
            if ( newY > 0 ) {
                newY = 0;
            } else if ( newY < this.maxScrollY ) {
                newY = this.maxScrollY;
            }
    
            this.scrollTo(newX, newY, 0);
    
    // INSERT POINT: _wheel
        },
    
        _initSnap: function () {
            this.currentPage = {};
    
            if ( typeof this.options.snap == 'string' ) {
                this.options.snap = this.scroller.querySelectorAll(this.options.snap);
            }
    
            this.on('refresh', function () {
                var i = 0, l,
                    m = 0, n,
                    cx, cy,
                    x = 0, y,
                    stepX = this.options.snapStepX || this.wrapperWidth,
                    stepY = this.options.snapStepY || this.wrapperHeight,
                    el,
                    rect;
    
                this.pages = [];
    
                if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
                    return;
                }
    
                if ( this.options.snap === true ) {
                    cx = Math.round( stepX / 2 );
                    cy = Math.round( stepY / 2 );
    
                    while ( x > -this.scrollerWidth ) {
                        this.pages[i] = [];
                        l = 0;
                        y = 0;
    
                        while ( y > -this.scrollerHeight ) {
                            this.pages[i][l] = {
                                x: Math.max(x, this.maxScrollX),
                                y: Math.max(y, this.maxScrollY),
                                width: stepX,
                                height: stepY,
                                cx: x - cx,
                                cy: y - cy
                            };
    
                            y -= stepY;
                            l++;
                        }
    
                        x -= stepX;
                        i++;
                    }
                } else {
                    el = this.options.snap;
                    l = el.length;
                    n = -1;
    
                    for ( ; i < l; i++ ) {
                        rect = utils.getRect(el[i]);
                        if ( i === 0 || rect.left <= utils.getRect(el[i-1]).left ) {
                            m = 0;
                            n++;
                        }
    
                        if ( !this.pages[m] ) {
                            this.pages[m] = [];
                        }
    
                        x = Math.max(-rect.left, this.maxScrollX);
                        y = Math.max(-rect.top, this.maxScrollY);
                        cx = x - Math.round(rect.width / 2);
                        cy = y - Math.round(rect.height / 2);
    
                        this.pages[m][n] = {
                            x: x,
                            y: y,
                            width: rect.width,
                            height: rect.height,
                            cx: cx,
                            cy: cy
                        };
    
                        if ( x > this.maxScrollX ) {
                            m++;
                        }
                    }
                }
    
                this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);
    
                // Update snap threshold if needed
                if ( this.options.snapThreshold % 1 === 0 ) {
                    this.snapThresholdX = this.options.snapThreshold;
                    this.snapThresholdY = this.options.snapThreshold;
                } else {
                    this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
                    this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
                }
            });
    
            this.on('flick', function () {
                var time = this.options.snapSpeed || Math.max(
                        Math.max(
                            Math.min(Math.abs(this.x - this.startX), 1000),
                            Math.min(Math.abs(this.y - this.startY), 1000)
                        ), 300);
    
                this.goToPage(
                    this.currentPage.pageX + this.directionX,
                    this.currentPage.pageY + this.directionY,
                    time
                );
            });
        },
    
        _nearestSnap: function (x, y) {
            if ( !this.pages.length ) {
                return { x: 0, y: 0, pageX: 0, pageY: 0 };
            }
    
            var i = 0,
                l = this.pages.length,
                m = 0;
    
            // Check if we exceeded the snap threshold
            if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
                Math.abs(y - this.absStartY) < this.snapThresholdY ) {
                return this.currentPage;
            }
    
            if ( x > 0 ) {
                x = 0;
            } else if ( x < this.maxScrollX ) {
                x = this.maxScrollX;
            }
    
            if ( y > 0 ) {
                y = 0;
            } else if ( y < this.maxScrollY ) {
                y = this.maxScrollY;
            }
    
            for ( ; i < l; i++ ) {
                if ( x >= this.pages[i][0].cx ) {
                    x = this.pages[i][0].x;
                    break;
                }
            }
    
            l = this.pages[i].length;
    
            for ( ; m < l; m++ ) {
                if ( y >= this.pages[0][m].cy ) {
                    y = this.pages[0][m].y;
                    break;
                }
            }
    
            if ( i == this.currentPage.pageX ) {
                i += this.directionX;
    
                if ( i < 0 ) {
                    i = 0;
                } else if ( i >= this.pages.length ) {
                    i = this.pages.length - 1;
                }
    
                x = this.pages[i][0].x;
            }
    
            if ( m == this.currentPage.pageY ) {
                m += this.directionY;
    
                if ( m < 0 ) {
                    m = 0;
                } else if ( m >= this.pages[0].length ) {
                    m = this.pages[0].length - 1;
                }
    
                y = this.pages[0][m].y;
            }
    
            return {
                x: x,
                y: y,
                pageX: i,
                pageY: m
            };
        },
    
        goToPage: function (x, y, time, easing) {
            easing = easing || this.options.bounceEasing;
    
            if ( x >= this.pages.length ) {
                x = this.pages.length - 1;
            } else if ( x < 0 ) {
                x = 0;
            }
    
            if ( y >= this.pages[x].length ) {
                y = this.pages[x].length - 1;
            } else if ( y < 0 ) {
                y = 0;
            }
    
            var posX = this.pages[x][y].x,
                posY = this.pages[x][y].y;
    
            time = time === undefined ? this.options.snapSpeed || Math.max(
                Math.max(
                    Math.min(Math.abs(posX - this.x), 1000),
                    Math.min(Math.abs(posY - this.y), 1000)
                ), 300) : time;
    
            this.currentPage = {
                x: posX,
                y: posY,
                pageX: x,
                pageY: y
            };
    
            this.scrollTo(posX, posY, time, easing);
        },
    
        next: function (time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;
    
            x++;
    
            if ( x >= this.pages.length && this.hasVerticalScroll ) {
                x = 0;
                y++;
            }
    
            this.goToPage(x, y, time, easing);
        },
    
        prev: function (time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;
    
            x--;
    
            if ( x < 0 && this.hasVerticalScroll ) {
                x = 0;
                y--;
            }
    
            this.goToPage(x, y, time, easing);
        },
    
        _initKeys: function (e) {
            // default key bindings
            var keys = {
                pageUp: 33,
                pageDown: 34,
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40
            };
            var i;
    
            // if you give me characters I give you keycode
            if ( typeof this.options.keyBindings == 'object' ) {
                for ( i in this.options.keyBindings ) {
                    if ( typeof this.options.keyBindings[i] == 'string' ) {
                        this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
                    }
                }
            } else {
                this.options.keyBindings = {};
            }
    
            for ( i in keys ) {
                this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
            }
    
            utils.addEvent(window, 'keydown', this);
    
            this.on('destroy', function () {
                utils.removeEvent(window, 'keydown', this);
            });
        },
    
        _key: function (e) {
            if ( !this.enabled ) {
                return;
            }
    
            var snap = this.options.snap,	// we are using this alot, better to cache it
                newX = snap ? this.currentPage.pageX : this.x,
                newY = snap ? this.currentPage.pageY : this.y,
                now = utils.getTime(),
                prevTime = this.keyTime || 0,
                acceleration = 0.250,
                pos;
    
            if ( this.options.useTransition && this.isInTransition ) {
                pos = this.getComputedPosition();
    
                this._translate(Math.round(pos.x), Math.round(pos.y));
                this.isInTransition = false;
            }
    
            this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;
    
            switch ( e.keyCode ) {
                case this.options.keyBindings.pageUp:
                    if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
                        newX += snap ? 1 : this.wrapperWidth;
                    } else {
                        newY += snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.pageDown:
                    if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
                        newX -= snap ? 1 : this.wrapperWidth;
                    } else {
                        newY -= snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.end:
                    newX = snap ? this.pages.length-1 : this.maxScrollX;
                    newY = snap ? this.pages[0].length-1 : this.maxScrollY;
                    break;
                case this.options.keyBindings.home:
                    newX = 0;
                    newY = 0;
                    break;
                case this.options.keyBindings.left:
                    newX += snap ? -1 : 5 + this.keyAcceleration>>0;
                    break;
                case this.options.keyBindings.up:
                    newY += snap ? 1 : 5 + this.keyAcceleration>>0;
                    break;
                case this.options.keyBindings.right:
                    newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
                    break;
                case this.options.keyBindings.down:
                    newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
                    break;
                default:
                    return;
            }
    
            if ( snap ) {
                this.goToPage(newX, newY);
                return;
            }
    
            if ( newX > 0 ) {
                newX = 0;
                this.keyAcceleration = 0;
            } else if ( newX < this.maxScrollX ) {
                newX = this.maxScrollX;
                this.keyAcceleration = 0;
            }
    
            if ( newY > 0 ) {
                newY = 0;
                this.keyAcceleration = 0;
            } else if ( newY < this.maxScrollY ) {
                newY = this.maxScrollY;
                this.keyAcceleration = 0;
            }
    
            this.scrollTo(newX, newY, 0);
    
            this.keyTime = now;
        },
    
        _animate: function (destX, destY, duration, easingFn) {
            var that = this,
                startX = this.x,
                startY = this.y,
                startTime = utils.getTime(),
                destTime = startTime + duration;
    
            function step () {
                var now = utils.getTime(),
                    newX, newY,
                    easing;
    
                if ( now >= destTime ) {
                    that.isAnimating = false;
                    that._translate(destX, destY);
    
                    if ( !that.resetPosition(that.options.bounceTime) ) {
                        that._execEvent('scrollEnd');
                    }
    
                    return;
                }
    
                now = ( now - startTime ) / duration;
                easing = easingFn(now);
                newX = ( destX - startX ) * easing + startX;
                newY = ( destY - startY ) * easing + startY;
                that._translate(newX, newY);
    
                if ( that.isAnimating ) {
                    rAF(step);
                }
            }
    
            this.isAnimating = true;
            step();
        },
        handleEvent: function (e) {
            switch ( e.type ) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
    
                    if ( this.options.zoom && e.touches && e.touches.length > 1 ) {
                        this._zoomStart(e);
                    }
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    if ( this.options.zoom && e.touches && e.touches[1] ) {
                        this._zoom(e);
                        return;
                    }
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    if ( this.scaled ) {
                        this._zoomEnd(e);
                        return;
                    }
                    this._end(e);
                    break;
                case 'orientationchange':
                case 'resize':
                    this._resize();
                    break;
                case 'transitionend':
                case 'webkitTransitionEnd':
                case 'oTransitionEnd':
                case 'MSTransitionEnd':
                    this._transitionEnd(e);
                    break;
                case 'wheel':
                case 'DOMMouseScroll':
                case 'mousewheel':
                    if ( this.options.wheelAction == 'zoom' ) {
                        this._wheelZoom(e);
                        return;	
                    }
                    this._wheel(e);
                    break;
                case 'keydown':
                    this._key(e);
                    break;
            }
        }
    
    };
    function createDefaultScrollbar (direction, interactive, type) {
        var scrollbar = document.createElement('div'),
            indicator = document.createElement('div');
    
        if ( type === true ) {
            scrollbar.style.cssText = 'position:absolute;z-index:9999';
            indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
        }
    
        indicator.className = 'iScrollIndicator';
    
        if ( direction == 'h' ) {
            if ( type === true ) {
                scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
                indicator.style.height = '100%';
            }
            scrollbar.className = 'iScrollHorizontalScrollbar';
        } else {
            if ( type === true ) {
                scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
                indicator.style.width = '100%';
            }
            scrollbar.className = 'iScrollVerticalScrollbar';
        }
    
        scrollbar.style.cssText += ';overflow:hidden';
    
        if ( !interactive ) {
            scrollbar.style.pointerEvents = 'none';
        }
    
        scrollbar.appendChild(indicator);
    
        return scrollbar;
    }
    
    function Indicator (scroller, options) {
        this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
        this.wrapperStyle = this.wrapper.style;
        this.indicator = this.wrapper.children[0];
        this.indicatorStyle = this.indicator.style;
        this.scroller = scroller;
    
        this.options = {
            listenX: true,
            listenY: true,
            interactive: false,
            resize: true,
            defaultScrollbars: false,
            shrink: false,
            fade: false,
            speedRatioX: 0,
            speedRatioY: 0
        };
    
        for ( var i in options ) {
            this.options[i] = options[i];
        }
    
        this.sizeRatioX = 1;
        this.sizeRatioY = 1;
        this.maxPosX = 0;
        this.maxPosY = 0;
    
        if ( this.options.interactive ) {
            if ( !this.options.disableTouch ) {
                utils.addEvent(this.indicator, 'touchstart', this);
                utils.addEvent(window, 'touchend', this);
            }
            if ( !this.options.disablePointer ) {
                utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
            }
            if ( !this.options.disableMouse ) {
                utils.addEvent(this.indicator, 'mousedown', this);
                utils.addEvent(window, 'mouseup', this);
            }
        }
    
        if ( this.options.fade ) {
            this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
            var durationProp = utils.style.transitionDuration;
            if(!durationProp) {
                return;
            }
            this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
            // remove 0.0001ms
            var self = this;
            if(utils.isBadAndroid) {
                rAF(function() {
                    if(self.wrapperStyle[durationProp] === '0.0001ms') {
                        self.wrapperStyle[durationProp] = '0s';
                    }
                });
            }
            this.wrapperStyle.opacity = '0';
        }
    }
    
    Indicator.prototype = {
        handleEvent: function (e) {
            switch ( e.type ) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    this._end(e);
                    break;
            }
        },
    
        destroy: function () {
            if ( this.options.fadeScrollbars ) {
                clearTimeout(this.fadeTimeout);
                this.fadeTimeout = null;
            }
            if ( this.options.interactive ) {
                utils.removeEvent(this.indicator, 'touchstart', this);
                utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.removeEvent(this.indicator, 'mousedown', this);
    
                utils.removeEvent(window, 'touchmove', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
                utils.removeEvent(window, 'mousemove', this);
    
                utils.removeEvent(window, 'touchend', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
                utils.removeEvent(window, 'mouseup', this);
            }
    
            if ( this.options.defaultScrollbars && this.wrapper.parentNode ) {
                this.wrapper.parentNode.removeChild(this.wrapper);
            }
        },
    
        _start: function (e) {
            var point = e.touches ? e.touches[0] : e;
    
            e.preventDefault();
            e.stopPropagation();
    
            this.transitionTime();
    
            this.initiated = true;
            this.moved = false;
            this.lastPointX	= point.pageX;
            this.lastPointY	= point.pageY;
    
            this.startTime	= utils.getTime();
    
            if ( !this.options.disableTouch ) {
                utils.addEvent(window, 'touchmove', this);
            }
            if ( !this.options.disablePointer ) {
                utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
            }
            if ( !this.options.disableMouse ) {
                utils.addEvent(window, 'mousemove', this);
            }
    
            this.scroller._execEvent('beforeScrollStart');
        },
    
        _move: function (e) {
            var point = e.touches ? e.touches[0] : e,
                deltaX, deltaY,
                newX, newY,
                timestamp = utils.getTime();
    
            if ( !this.moved ) {
                this.scroller._execEvent('scrollStart');
            }
    
            this.moved = true;
    
            deltaX = point.pageX - this.lastPointX;
            this.lastPointX = point.pageX;
    
            deltaY = point.pageY - this.lastPointY;
            this.lastPointY = point.pageY;
    
            newX = this.x + deltaX;
            newY = this.y + deltaY;
    
            this._pos(newX, newY);
    
    // INSERT POINT: indicator._move
    
            e.preventDefault();
            e.stopPropagation();
        },
    
        _end: function (e) {
            if ( !this.initiated ) {
                return;
            }
    
            this.initiated = false;
    
            e.preventDefault();
            e.stopPropagation();
    
            utils.removeEvent(window, 'touchmove', this);
            utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
            utils.removeEvent(window, 'mousemove', this);
    
            if ( this.scroller.options.snap ) {
                var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);
    
                var time = this.options.snapSpeed || Math.max(
                        Math.max(
                            Math.min(Math.abs(this.scroller.x - snap.x), 1000),
                            Math.min(Math.abs(this.scroller.y - snap.y), 1000)
                        ), 300);
    
                if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
                    this.scroller.directionX = 0;
                    this.scroller.directionY = 0;
                    this.scroller.currentPage = snap;
                    this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
                }
            }
    
            if ( this.moved ) {
                this.scroller._execEvent('scrollEnd');
            }
        },
    
        transitionTime: function (time) {
            time = time || 0;
            var durationProp = utils.style.transitionDuration;
            if(!durationProp) {
                return;
            }
    
            this.indicatorStyle[durationProp] = time + 'ms';
    
            if ( !time && utils.isBadAndroid ) {
                this.indicatorStyle[durationProp] = '0.0001ms';
                // remove 0.0001ms
                var self = this;
                rAF(function() {
                    if(self.indicatorStyle[durationProp] === '0.0001ms') {
                        self.indicatorStyle[durationProp] = '0s';
                    }
                });
            }
        },
    
        transitionTimingFunction: function (easing) {
            this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
        },
    
        refresh: function () {
            this.transitionTime();
    
            if ( this.options.listenX && !this.options.listenY ) {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
            } else if ( this.options.listenY && !this.options.listenX ) {
                this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
            } else {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
            }
    
            if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
                utils.addClass(this.wrapper, 'iScrollBothScrollbars');
                utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');
    
                if ( this.options.defaultScrollbars && this.options.customStyle ) {
                    if ( this.options.listenX ) {
                        this.wrapper.style.right = '8px';
                    } else {
                        this.wrapper.style.bottom = '8px';
                    }
                }
            } else {
                utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
                utils.addClass(this.wrapper, 'iScrollLoneScrollbar');
    
                if ( this.options.defaultScrollbars && this.options.customStyle ) {
                    if ( this.options.listenX ) {
                        this.wrapper.style.right = '2px';
                    } else {
                        this.wrapper.style.bottom = '2px';
                    }
                }
            }
    
            utils.getRect(this.wrapper);	// force refresh
    
            if ( this.options.listenX ) {
                this.wrapperWidth = this.wrapper.clientWidth;
                if ( this.options.resize ) {
                    this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
                    this.indicatorStyle.width = this.indicatorWidth + 'px';
                } else {
                    this.indicatorWidth = this.indicator.clientWidth;
                }
    
                this.maxPosX = this.wrapperWidth - this.indicatorWidth;
    
                if ( this.options.shrink == 'clip' ) {
                    this.minBoundaryX = -this.indicatorWidth + 8;
                    this.maxBoundaryX = this.wrapperWidth - 8;
                } else {
                    this.minBoundaryX = 0;
                    this.maxBoundaryX = this.maxPosX;
                }
    
                this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
            }
    
            if ( this.options.listenY ) {
                this.wrapperHeight = this.wrapper.clientHeight;
                if ( this.options.resize ) {
                    this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
                    this.indicatorStyle.height = this.indicatorHeight + 'px';
                } else {
                    this.indicatorHeight = this.indicator.clientHeight;
                }
    
                this.maxPosY = this.wrapperHeight - this.indicatorHeight;
    
                if ( this.options.shrink == 'clip' ) {
                    this.minBoundaryY = -this.indicatorHeight + 8;
                    this.maxBoundaryY = this.wrapperHeight - 8;
                } else {
                    this.minBoundaryY = 0;
                    this.maxBoundaryY = this.maxPosY;
                }
    
                this.maxPosY = this.wrapperHeight - this.indicatorHeight;
                this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
            }
    
            this.updatePosition();
        },
    
        updatePosition: function () {
            var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
                y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;
    
            if ( !this.options.ignoreBoundaries ) {
                if ( x < this.minBoundaryX ) {
                    if ( this.options.shrink == 'scale' ) {
                        this.width = Math.max(this.indicatorWidth + x, 8);
                        this.indicatorStyle.width = this.width + 'px';
                    }
                    x = this.minBoundaryX;
                } else if ( x > this.maxBoundaryX ) {
                    if ( this.options.shrink == 'scale' ) {
                        this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
                        this.indicatorStyle.width = this.width + 'px';
                        x = this.maxPosX + this.indicatorWidth - this.width;
                    } else {
                        x = this.maxBoundaryX;
                    }
                } else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
                    this.width = this.indicatorWidth;
                    this.indicatorStyle.width = this.width + 'px';
                }
    
                if ( y < this.minBoundaryY ) {
                    if ( this.options.shrink == 'scale' ) {
                        this.height = Math.max(this.indicatorHeight + y * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                    }
                    y = this.minBoundaryY;
                } else if ( y > this.maxBoundaryY ) {
                    if ( this.options.shrink == 'scale' ) {
                        this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                        y = this.maxPosY + this.indicatorHeight - this.height;
                    } else {
                        y = this.maxBoundaryY;
                    }
                } else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
                    this.height = this.indicatorHeight;
                    this.indicatorStyle.height = this.height + 'px';
                }
            }
    
            this.x = x;
            this.y = y;
    
            if ( this.scroller.options.useTransform ) {
                this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
            } else {
                this.indicatorStyle.left = x + 'px';
                this.indicatorStyle.top = y + 'px';
            }
        },
    
        _pos: function (x, y) {
            if ( x < 0 ) {
                x = 0;
            } else if ( x > this.maxPosX ) {
                x = this.maxPosX;
            }
    
            if ( y < 0 ) {
                y = 0;
            } else if ( y > this.maxPosY ) {
                y = this.maxPosY;
            }
    
            x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
            y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;
    
            this.scroller.scrollTo(x, y);
    
            
        },
    
        fade: function (val, hold) {
            if ( hold && !this.visible ) {
                return;
            }
    
            clearTimeout(this.fadeTimeout);
            this.fadeTimeout = null;
    
            var time = val ? 250 : 500,
                delay = val ? 0 : 300;
    
            val = val ? '1' : '0';
    
            this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';
    
            this.fadeTimeout = setTimeout((function (val) {
                this.wrapperStyle.opacity = val;
                this.visible = +val;
            }).bind(this, val), delay);
        }
    };
    
    IScroll.utils = utils;
    
    if ( typeof module != 'undefined' && module.exports ) {
        module.exports = IScroll;
    } else if ( typeof define == 'function' && define.amd ) {
            define( function () { return IScroll; } );
    } else {
        window.IScroll = IScroll;
    }
    
    FLIPBOOK.IScroll = IScroll
    
    window.PointerEvent = undefined
    
    
    // var oldEPD = Event.prototype.preventDefault;
    // Event.prototype.preventDefault = function() {
    //     debugger;
    //     oldEPD.call(this);
    // };
    
    
    
    })(window, document, Math);

FLIPBOOK.BookSwipe = function(el, wrapper, model, options) {

    this.options = options
    this.singlePage = options.singlePageMode
    this.pageWidth = this.options.pageWidth
    this.pageHeight = this.options.pageHeight
    this.slides = []
    this.pagesArr = []
    this.leftPage = 0
    this.rightPage = 0
    this.rotation = 0

    this.prevPageEnabled = false

    this.setRightIndex(options.rightToLeft ? options.pages.length : 0)
    this.currentSlide = 0
    this.flipping = false;

    // this.watch("rightIndex",function(){
    //     debugger
    // });

    this.wrapper = wrapper

    this.$wrapper = jQuery(wrapper)

    //debug

    // this.$wrapper.css('overflow', "visible")
    // this.$wrapper.parent().css('overflow', "visible")

    // debug end

    this.scroller = el
    this.$scroller = jQuery(this.scroller).removeClass('book').addClass('flipbook-carousel-scroller')

    this.iscroll = new IScroll(this.wrapper, {

        // momentum: true,
        snap: true,
        snapSpeed: 200 * this.options.pageFlipDuration,
        // snapSpeed: 500,
        // keyBindings: false,
        // hScrollbar: false
        // zoom: true,
        // mouseWheel: true,
        // wheelAction: 'zoom',

        freeScroll: true,

        scrollX: true,
        scrollY: false,

        // preventDefault: true,
        preventDefault: false,

        disableTouch:true,
        eventPassthrough  : 'vertical'

        // HWCompositing:false,

        // mouseWheel: true,
        // wheelAction: 'zoom',
        // scrollbars: true
    });


    for (var i = 0; i < 3; i++) {

        var $slide = jQuery('<div class="flipbook-carousel-slide"><div class="slide-inner"/></div>"').appendTo(this.$scroller)
        this.slides.push($slide)

    }

    this.slides[0].iscroll = new IScroll(this.slides[0][0], {
          // scrollbars: true,
        zoom: true,
        scrollX: true,
        scrollY: true,
        freeScroll: true,
        keepInCenterV: true,
        keepInCenterH: true,
        preventDefault: false,
    })

    // this.slides[0].iscroll.refresh()

    this.slides[2].iscroll = new IScroll(this.slides[2][0], {
          // scrollbars: true,
        zoom: true,
        scrollX: true,
        scrollY: true,
        freeScroll: true,
        keepInCenterV: true,
        keepInCenterH: true,
        preventDefault: false,
    })

    // this.slides[2].iscroll.refresh()


    this.slides[1].iscroll = new IScroll(this.slides[1][0], {
        // scrollbars: true,
        zoom: true,
        scrollX: true,
        scrollY: true,
        freeScroll: true,
        keepInCenterV: true,
        keepInCenterH: true,
        // scrollbars: false,
        preventDefault: false,
        // preventDefault: true,
        // HWCompositing:false,
    })

    // this.slides[1].iscroll.refresh()

    for (var i = 0; i < 3; i++) {

        this.slides[i].iscroll.on("zoomEnd", function() {

            var scale = options.main.zoom
            this.options.eventPassthrough = scale > 1 ? '' : 'vertical'
            this.options.freeScroll = scale > 1
            this.refresh()

        })

    }
    



    this.slides[1].iscroll.on("zoomStart", function() {

        // debugger

        // this.options.preventDefault = true
        // this.refresh()

        // self.disableFlip()
    })

    // this.slides[0].iscroll.disable()
    // this.slides[1].iscroll.disable()
    // this.slides[2].iscroll.disable()

    this.resizeInnerSlides()

    var page

    var pageOptions = {
        rightToLeft: options.rightToLeft,
        numPages: options.numPages,
        pdfMode: options.pdfMode
    }

    for (var i = 0; i < options.numPages; i++) {

        page = new FLIPBOOK.PageSwipe(options, i, options.pages[i].src, options.pages[i].htmlContent)

        this.pagesArr.push(page)

        if (options.loadAllPages)
            page.load()
    }

    var self = this

    this.iscroll.on("scrollStart", function() {

        return

        self.disablePan()
    })

    this.iscroll.on("scrollEnd", function() {

        var sliderPage = this.currentPage.pageX

        if(self.currentSlide == sliderPage)
            return

        //self.enablePan()

        // console.log("")
        // console.log("scrollEnd")
        // console.log("sliderPage:", sliderPage)

        /*if (sliderPage == 1) {
            self.flipping = false;
            self.updateVisiblePages()
            return
        }*/

        if (self.singlePage) {

            if (sliderPage > self.currentSlide)

                self.setRightIndex(self.rightIndex + 1);

            else if (sliderPage < self.currentSlide)

                self.setRightIndex(self.rightIndex - 1);

        } else {

            if (sliderPage > self.currentSlide)

                self.setRightIndex(self.rightIndex + 2);

            else if (sliderPage < self.currentSlide)

                self.setRightIndex(self.rightIndex - 2);
        }

        self.currentSlide = sliderPage

        self.updateVisiblePages()

        self.flipping = false;

    })

    this.flipEnabled = true

    this.nextEnabled = true
    this.prevEnabled = true

    model.on("toolMove", function() {
        self.updateTool()
    })

    model.on("toolSelect", function() {
        self.updateTool()
    })

}


FLIPBOOK.BookSwipe.prototype.constructor = FLIPBOOK.BookSwipe;

FLIPBOOK.BookSwipe.prototype = {

    goToPage: function(value, instant) {

        if (!this.enabled)
            return

        // console.log("    ##### gotopage "+value)
        // debugger

        if (!this.flipEnabled) return

        if (this.singlePage || value % 2 != 0) 
            value--;

        if (isNaN(value) || value < 0)
            value = 0

        if (value > this.options.pages.length)
            value = this.options.pages.length

        this.resetZoom()

        if (instant) {
            this.setRightIndex(value)
            this.updateVisiblePages()
            return
        }


        if (this.singlePage) {

            if (this.options.rightToLeft && this.options.oddPages && value < 1)
                value = 1

            if (value > this.rightIndex) {

                this.setSlidePages(this.currentSlide + 1, [value])
                this.setRightIndex(value - 1)
                this.nextPage(instant);

            } else if (value < this.rightIndex) {

                this.setSlidePages(this.currentSlide - 1, [value])
                this.setRightIndex(value + 1)
                this.prevPage(instant);

            }

        } else {

            if (this.options.rightToLeft && this.options.oddPages && value < 2)
                value = 2

            if (value > this.rightIndex) {

                if (value >= this.pagesArr.length) {

                    this.setSlidePages(2, [value - 1, value])
                    this.setRightIndex(value - 2)
                    this.goToSlide(2, instant)

                } else {

                    this.setSlidePages(this.currentSlide + 1, [value - 1, value])
                    this.setRightIndex(value - 2)
                    this.nextPage(instant);

                }

            } else if (value < this.rightIndex) {

                if (value == 0) {

                    this.setRightIndex(value + 2)
                    this.setSlidePages(0, [value])
                    this.goToSlide(0, instant)

                } else {

                    this.setRightIndex(value + 2)
                    this.setSlidePages(this.currentSlide - 1, [value - 1, value])
                    this.prevPage(instant);

                }

            }
        }

    },

    setRightIndex: function(value) {

        this.rightIndex = value

    },

    nextPage: function(instant) {

       // if (!this.flipEnabled) return

        /*if (this.flipping) 
            return;*/

        if (this.currentSlide == 2)
            return

        this.flipping = true;

        this.goToSlide(this.currentSlide + 1, instant)

        /*if(this.mode == 1)
            this.rightIndex++;*/

    },

    prevPage: function(instant) {

      //  if (!this.flipEnabled) return

        /*if (this.flipping) 
            return;*/

        if (this.currentSlide == 0)
            return;

        this.flipping = true;

        this.goToSlide(this.currentSlide - 1, instant)

        /*if(this.mode == 1)
            this.rightIndex--;*/

    },

    enablePrev: function(val) {

        this.prevEnabled = val

    },

    enableNext: function(val) {

        this.nextEnabled = val

    },

    // onPageUnloaded:function(index,size){

    //     var pageIndex = index

    //     if (this.options.rightToLeft)
    //         pageIndex = this.options.pages.length - index - 1

    //     this.pagesArr[pageIndex].unload()

    // },

    resetZoom: function() {

        return
        /* for (var i = 0; i < this.slides.length; i++) {
             if (this.slides[i].iscroll.scale !== 1)
                 this.slides[i].iscroll.zoom(1, 0, 0, 0)
             this.slides[i].iscroll.refresh()
             // this.slides[i].iscroll.refresh()
         }*/

        if (this.slides[1].iscroll.scale !== 1)
            this.slides[1].iscroll.zoom(1, 0, 0, 0)
        this.slides[1].iscroll.refresh()
        // this.slides[i].iscroll.refresh()


        this.enableFlip()
    },

    setSlidePages: function(slide, pages) {

        try {
            var arr = []
            for (var i = 0; i < pages.length; i++) {
                arr.push(pages[i].index)
            }
    
           // console.log(slide,pages)
    
            if (this.slides[slide].pages) {
    
                if (arr.join("") === this.slides[slide].pages.join("")){
                    // console.log(arr)
                    // console.log(this.slides[slide].pages)
                    return
                }
    
            }
    
            /*if(this.slides[slide].pages && (this.slides[slide].pages.join("") == pages.join(""))) 
                return;*/
    
            this.clearSlidePages(slide)
    
            var slideInner = this.slides[slide].find('.slide-inner')
    
            // slideInner.width(2 * this.options.pageTextureSize * this.options.pageWidth / this.options.pageHeight)
    
            for (var i = 0; i < pages.length; i++) {
    
                var pageIndex = pages[i].index
    
                // console.log("setSlidePages slide:"+slide+" pageIndex:"+pageIndex)
    
                if (this.pagesArr[pageIndex]) {
    
                    slideInner.append(this.pagesArr[pageIndex].$wrapper)
                    this.slides[slide].pages.push(pageIndex)
    
                }
    
            }
    
            this.resizeInnerSlides()
    
            if (this.slides[slide].iscroll)
                this.slides[slide].iscroll.refresh()
    
            // this.zoomTo(.25)
            // this.slides[slide].iscroll.refresh()
    
            // this.slides[slide].iscroll.zoom(.1, 0, 0, 0);
    
            // this.slides[slide].show()
        } catch(e) {console.log(e);}

    },

    updateTool: function() {

        switch (this.options.main.tool) {

            case "toolSelect":
                this.disableFlip()
                this.disablePan()
                jQuery(".flipbook-textLayer").css("pointer-events", "auto").removeClass(".flipbook-noselect")
                break;

            case "toolMove":
                this.onZoom(this.options.main.zoom)
                jQuery(".flipbook-textLayer").css("pointer-events", "none").addClass(".flipbook-noselect")
                break;
        }

    },

    clearSlidePages: function(slide) {

        this.slides[slide].find('.slide-inner').empty()
        this.slides[slide].pages = []

        // var test = jQuery("<p>SLIDE</p>")

        // this.slides[slide].find('.slide-inner').append(test)
        // this.slides[slide].hide()

    },

    setZoomPages: function(pages) {

        if (this.$zoomScroller.pages && (this.$zoomScroller.pages.join("") == pages.join("")))
            return;

        this.$zoomScroller.empty()
        this.$zoomScroller.pages = []

        for (var i = 0; i < pages.length; i++) {

            var pageIndex = pages[i]

            if (this.pagesArr[pageIndex]) {

                this.$zoomScroller.append(this.pagesArr[pageIndex].$wrapper)
                this.$zoomScroller.pages.push(pageIndex)

            }

        }
    },

    resizeZoomPages: function(pages, scale) {

        var h = this.$wrapper.height() * scale
        var pdfSize = parseInt(h / 500) * 500 + 500
        if (pdfSize < 500) pdfSize = 500
        if (pdfSize > 2000) pdfSize = 2000

        // this.options.pageTextureSize = pdfSize

        for (var i = 0; i < pages.length; i++) {

            var pageIndex = pages[i]

            if (this.pagesArr[pageIndex]) {
                /*this.pagesArr[pageIndex].$wrapper.height(this.zoomScroll.scrollerHeight)
                this.pagesArr[pageIndex].$wrapper.width(this.zoomScroll.scrollerWidth/2)*/
                //this.pagesArr[pageIndex].pageTextureSize = pdfSize
                this.pagesArr[pageIndex].load()

            }

        }
    },

    getCurrentSlidePages: function() {

        if (this.singlePage)

            return [this.rightIndex];

        else
            return [this.rightIndex - 1, this.rightIndex];


    },

    clearSlide: function(slide) {

        this.slides[slide].empty()

    },

    hasPage: function(slide, page) {


    },

    updateVisiblePages: function() {

        var self = this
        var toLoad
        var main = this.options.main

        var index = this.rightIndex

        if(this.options.rightToLeft && this.options.oddPages) index--;

        var right = this.pagesArr[index]
        var left = this.pagesArr[index - 1]
        var next = this.pagesArr[index + 1]
        var afterNext = this.pagesArr[index + 2]
        var prev = this.pagesArr[index - 2]
        var beforePrev = this.pagesArr[index - 3]

        if (this.singlePage) {

           if(!left){
                //cover
                this.setSlidePages(0, [right])
      
                if(next)
                    this.setSlidePages(1, [next])
                else
                    this.clearSlidePages(1)
                this.goToSlide(0,true)

                this.clearSlidePages(2)

            }else{

               if(next){

                    this.setSlidePages(1, [right])
                    this.setSlidePages(0, [left])
                    this.setSlidePages(2, [next])
                    this.goToSlide(1,true)

               }else{

                    this.setSlidePages(2, [right])
                    this.setSlidePages(1, [left])
                    this.goToSlide(2,true)

                    this.clearSlidePages(0)

               }
                
            }

            right.load(function() {

                main.setLoadingProgress(1)
                if (left) left.load()
                if (next) next.load()

            })

        } else {

            if(!left){
                //cover
                this.setSlidePages(0, [right])

                if(afterNext)
                    this.setSlidePages(1, [next, afterNext])
                else
                    this.setSlidePages(1, [next])

                this.goToSlide(0,true)

                this.clearSlidePages(2)

            }else{

                if(right){

                    //L R

                    if(!next){

                        this.setSlidePages(2, [left, right])

                        if(beforePrev)
                            this.setSlidePages(1, [beforePrev, prev])
                        else
                            this.setSlidePages(1, [prev])

                        this.clearSlidePages(0)

                    }else{

                        if(prev){

                            this.setSlidePages(1, [left, right])

                            if(beforePrev)
                                this.setSlidePages(0, [beforePrev, prev])
                            else
                                this.setSlidePages(0, [prev])

                            this.goToSlide(1,true)

                        }


                        if(afterNext)
                            this.setSlidePages(2, [next, afterNext])
                        else
                            this.setSlidePages(2, [next])


                    }
                    
                }else{
                    this.setSlidePages(2, [left])

                    if(beforePrev)
                        this.setSlidePages(1, [beforePrev, prev])
                    else
                        this.setSlidePages(1, [prev])

                    this.goToSlide(2,true)
                    this.clearSlidePages(0)

                }
            }

            if (left) {

                left.load(function() {

                    if (right) {
                        right.load(function() {

                            main.setLoadingProgress(1)
                            if (prev) prev.load()
                            if (beforePrev) beforePrev.load()
                            if (next) next.load()
                            if (afterNext) afterNext.load()

                        })
                    } else {

                        main.setLoadingProgress(1)
                        if (prev) prev.load()

                        if (beforePrev) beforePrev.load()
                    }

                })
            } else {

                if (right) {

                    right.load(function() {

                        main.setLoadingProgress(1)
                        if (next) next.load()
                        if (afterNext) afterNext.load()

                    })
                }

            }

        }

        this.options.main.turnPageComplete()

    },

    loadPage: function(index) {

        if (this.pagesArr[index])
            this.pagesArr[index].load()

    },

    hidePage: function(index) {

    },

    showPage: function(index) {

    },

    disable: function() {

        this.enabled = false

    },

    enable: function() {

        this.enabled = true
        this.onResize()

    },

    resize: function() {

    },

    onResize: function() {

        var w = this.$wrapper.width()
        var h = this.$wrapper.height()
        this.w = w
        this.h = h

        if (w == 0 || h == 0) return;

        var pw = this.pageWidth
        var ph = this.pageHeight

        var portrait = 2 * this.options.zoomMin * pw / ph > w / h
        var doublePage = !this.options.singlePageMode && (!this.options.responsiveView || (w > this.options.responsiveViewTreshold || !portrait))
         //console.log("doublePage:", doublePage)
        var bw = doublePage ? 2*pw : pw
        var bh = ph
        this.bw = bw
        this.bh = bh

        var scale
        if (h / w > bh / bw) {
            //fit to width
            scale = (bh / bw) * w / this.options.pageTextureSize
        } else {
            scale = h / this.options.pageTextureSize
        }

        var spaceBetweenSlides = 0

        for (var i = 0; i < this.slides.length; i++) {

            this.slides[i].width(w + spaceBetweenSlides).height(h)

            if (this.slides[i].iscroll) {

                this.slides[i].iscroll.options.zoomMin = this.options.zoomMin * scale
                this.slides[i].iscroll.options.zoomMax = this.options.zoomMax * scale
                this.slides[i].iscroll.refresh()
            }

        }

        this.$scroller.width(this.$scroller.children().length * (w+spaceBetweenSlides))
        this.iscroll.refresh()

        //var portrait = bw / bh > w / h && w < this.options.responsiveViewTreshold && this.options.responsiveView
        // var portrait = 2 * this.options.zoomMin * this.pageWidth / this.pageHeight > w / h
        // var pw, ph

        // if (portrait) {
        //     pw = w
        //     ph = parseInt(w * this.pageHeight / this.pageWidth)
        // } else {
        //     ph = h
        //     pw = parseInt(h * this.pageWidth / this.pageHeight)
        // }

        if ((!doublePage || this.options.singlePageMode) && !this.singlePage) {

            // console.log("single page mode")

            if (this.rightIndex % 2 == 0 && this.rightIndex > 0)
                this.setRightIndex(this.rightIndex - 1);

            this.singlePage = true

            this.resizeInnerSlides()

        } else if (doublePage && !this.options.singlePageMode && this.singlePage) {

            // console.log("double page mode")


            if (this.rightIndex % 2 != 0)
                this.setRightIndex(this.rightIndex + 1);

            this.singlePage = false

            this.resizeInnerSlides()

        }

        this.updateVisiblePages()


    },

    resizeInnerSlides: function() {
        var pw = this.options.pageTextureSize * this.pageWidth / this.pageHeight

        if(this.rotation == 90 || this.rotation == 270)
            pw = this.options.pageTextureSize * this.pageHeight / this.pageWidth

        var sw = this.singlePage ? pw : 2 * pw

        // debugger
        for (var i = 0; i < 3; i++) {
            sw = this.slides[i].pages && this.slides[i].pages.length == 1 ? pw : 2 * pw
            this.slides[i].find(".slide-inner").width(sw)
        }
    },

    resizeInnerSlide: function(slide) {

        var pw = this.options.pageTextureSize * this.pageWidth / this.pageHeight

        if (this.slides[slide].pages.length == 1)
            this.slides[slide].find(".slide-inner").width(pw)
        else
            this.slides[slide].find(".slide-inner").width(pw)

    },


    goToSlide: function(slide, instant) {

        // console.log("gotoslide "+slide)

        var time = instant ? 0 : 300 * this.options.pageFlipDuration
        // var time = instant ? 0 : 500 * this.options.pageFlipDuration
        // time = 10

        if (this.iscroll.pages.length > 0)
            this.iscroll.goToPage(slide, 0, time)

        if (instant)
            this.currentSlide = slide

        this.zoomTo(this.options.zoomMin)

    },

    getCurrentSlide: function() {

        return this.currentSlide

    },

    zoomIn: function(value, time, e) {

        if (e && e.type === 'mousewheel')
            return
        this.zoomTo(value)

    },

    zoomTo: function(zoom, time, x, y) {

        if (!this.enabled)
            return

        var x = x || 0
        var y = y || 0
        var time = time || 0

        if (zoom > 1) {
            this.disableFlip()
        }

        if (w == 0 || h == 0) return;

        var w = this.w
        var h = this.h
        var pw = this.pageWidth
        var ph = this.pageHeight
        var bw = this.bw 
        var bh = this.bh

        var scale
        if (h / w > bh / bw) {
            //fit to width
            scale = (bh / bw) * zoom * w / this.options.pageTextureSize
        } else {
            scale = zoom * h / this.options.pageTextureSize
        }

        //var scale = zoom * this.$wrapper.height() / this.options.pageTextureSize

        // console.log(zoom)

        for (var i = 0; i < 3; i++) {

            if (this.slides[i].iscroll)

                this.slides[i].iscroll.zoom(scale, x, y, time);

        }

        this.onZoom(zoom)

        // if (this.slides[this.currentSlide].iscroll)
        //     this.slides[this.currentSlide].iscroll.zoom(zoom, x, y, time);


    },

    zoomOut: function(value) {

        this.zoomTo(value)

    },

    onZoom: function(zoom) {
        // debugger
        // console.log("on zoom : ",zoom)
        if(this.options.main.tool == "toolSelect"){
            this.disableFlip()
            this.disablePan()
        } else if (zoom > 1) {
            this.disableFlip()
            this.enablePan()
        } else {
            this.enableFlip()
            // this.disablePan()
        }

        this.options.main.onZoom(zoom)

    },

    rotateLeft:function(){

        this.rotation = (this.rotation + 360 - 90)%360

        for (var i = 0; i < this.pagesArr.length; i++) {
            var page = this.pagesArr[i]
            page.setRotation(this.rotation)
        }

        this.resizeInnerSlides()
        this.onResize()
        console.log(this.rotation)

    },

    rotateRight:function(){

        this.rotation = (this.rotation + 360 + 90)%360

        for (var i = 0; i < this.pagesArr.length; i++) {
            var page = this.pagesArr[i]
            page.setRotation(this.rotation)
        }

        this.resizeInnerSlides()
        this.onResize()
        console.log(this.rotation)

    },

    enableAutoplay: function(val) {

        // this.main.enableAutoplay(val)

    },

    updateCurrentPage: function(val) {


    },

    enable: function() {
        this.enabled = true
    },

    disable: function() {
        this.enabled = false
    },

    onSwipe: function(event, phase, direction, distance, duration, fingerCount, fingerData) {
        //console.log(event, phase, direction, distance, duration, fingerCount, fingerData)
        /*if(e.type == 'touchend' && !direction)
            this.main.toggleMenu()*/

        if (phase == 'start')
            return;
        if (direction == 'up' || direction == 'down')
            return


        // if(fingerCount > 1){
        //     this.disablePan()
        // }
    },

    onPageLoaded: function(i, size) {

        var index = this.options.rightToLeft ? this.options.numPages - i - 1 : i;

        this.pagesArr[index].onPageLoaded(size, this.options.pages[i].canvas[size], this.options.pages[i].htmlContent)

        this.updateTool()
    },

    onPageUnloaded: function(i, size) {

        var index = this.options.rightToLeft ? this.options.numPages - i - 1 : i;

        // this.pagesArr[index].onPageUnloaded(size)
        this.pagesArr[index].unload()
    },

    disableFlip: function() {
        
        this.flipEnabled = false
        this.iscroll.disable()
    },

    enableFlip: function() {

        if(this.options.numPages == 1){
            this.disableFlip()
            return
        }
            
        
        this.flipEnabled = true
        this.iscroll.enable()
        // this.iscroll.disable()
        // this.slides[1].iscroll.options.preventDefault = false
        // this.slides[1].iscroll.refresh()
    },

    enablePan: function() {
        
        // this.slides[1].iscroll.options.preventDefault = true
        if (this.slides[0].iscroll)
            this.slides[0].iscroll.enable()
        if (this.slides[1].iscroll)
            this.slides[1].iscroll.enable()
        if (this.slides[2].iscroll)
            this.slides[2].iscroll.enable()
            // this.slides[1].iscroll.disable()
    },

    disablePan: function() {
        
        // this.slides[1].iscroll.options.preventDefault = false
        if (this.slides[0].iscroll)
            this.slides[0].iscroll.disable()
        if (this.slides[1].iscroll)
            this.slides[1].iscroll.disable()
        if (this.slides[2].iscroll)
            this.slides[2].iscroll.disable()
    }

}

FLIPBOOK.PageSwipe = function(options, index, texture, html) {

    this.rotation = 0
    this.index = index
    this.options = options
    this.texture = texture
    this.html = html
    this.index = index
    this.$wrapper = jQuery('<div>').addClass('flipbook-carousel-page')
    this.wrapper = this.$wrapper[0]

    this.$inner = jQuery('<div>').appendTo(this.$wrapper).addClass('flipbook-carousel-page-inner')
    this.$img = jQuery('<img>')

    if(options.pagePreloader)
        this.$preloader = jQuery('<img src="' + options.pagePreloader + '" class="flipbook-page-preloader-image">').appendTo(this.$inner)
    else
        this.$preloader = jQuery('<img src="' + options.assets.spinner + '" class="flipbook-page-preloader">').appendTo(this.$inner)

    this.setSize(this.pw, this.ph)

    // jQuery('<div class="cssload-container"><div class="cssload-speeding-wheel"></div></div>').appendTo(this.$wrapper)

}

FLIPBOOK.PageSwipe.prototype = {

    load: function(callback) {

        if (this.loaded) {
            if (callback) callback.call(this)
            return
        }

        this.loaded = true

        var index = this.options.rightToLeft ? this.options.numPages - this.index - 1 : this.index

        if (this.options.pdfMode) {

            if (this.pageSize != this.options.pageTextureSize) {

                this.options.main.loadPage(index, this.options.pageTextureSize, callback)
                // this.options.main.loadPage(index, 200, callback)

            } else {

                if (callback) callback.call(this)

            }

        } else {

            var self = this

            this.options.main.loadPage(index, this.options.pageTextureSize, function(page) {

                var img = document.createElement('img')
                img.src = page.image.src

                self.$img = jQuery(img).addClass("page-carousel-img")

                // self.$img = jQuery("<div>").addClass("page-carousel-img").css("background","url('"+page.image.src+"')")

                var imgW = page.image.naturalHeight
                var imgH = page.image.naturalHeight
                var pw = self.options.pageWidth
                var ph = self.options.pageHeight
                var scaleY = ph / imgH
                var translateX = 0

                self.$img.appendTo(self.$inner)

                if (self.options.doublePage && self.index > 0 && self.index % 2 == 0) {

                    self.$img.css('left', '-100%')

                }

                if (self.options.doublePage) {

                    if (self.index == 0 || (self.index == (self.options.pages.length - 1) && !self.options.oddPages))
                        self.$img.css('width', '100%')
                    else
                        self.$img.css('width', '200%')

                } else
                    self.$img.css('width', '100%')

    

                if (page.htmlContent) {

                    self.htmlContent = page.htmlContent[0]
                    page.htmlContent.appendTo(self.$inner)

                    self.updateHtmlContentSize()

                }

                // self.$wrapper.css('background', 'none')

                self.setRotation()


                if (callback) callback.call(self)

            })


        }
    },

    unload: function() {
        this.loaded = false
        this.pageSize = 0

        this.$preloader.appendTo(this.$inner)


        // console.log("page ",this.index," unloaded")
    },

    onPageLoaded: function(size, canvas, htmlContent) {

        if (this.pageSize != size) {

            //console.log('---> update page '+i+' size : '+size)

            this.pageSize = size
            var self = this

            ///test
            // var test = true
            // if(test){
            //     setTimeout(function(){
            //     self.$inner.empty();
            //     jQuery(canvas).appendTo(self.$inner)
            //     jQuery(htmlContent).appendTo(self.$inner)
            // },1000)

            // }else{
                this.$inner.empty();
                jQuery(canvas).appendTo(this.$inner)
                jQuery(htmlContent).appendTo(this.$inner)
            // }
            
            this.htmlContent = htmlContent

            this.updateHtmlContentSize()

        }

    },

    dispose: function() {

        if (this.pageSize) {

            this.pageSize = null
            this.$inner.empty();

            // console.log('disposing page ' + this.index)

        }

    },

    setSize: function() {

        var h = this.options.pageTextureSize, w;

        if(this.rotation == 0 || this.rotation == 180){
            w = h * this.options.pageWidth / this.options.pageHeight
        }
        else{
            this.$wrapper.width(h).height(w)
            w = h * this.options.pageHeight / this.options.pageWidth
        }
        this.$wrapper.width(w).height(h)
        this.updateHtmlContentSize()

    },

    setRotation: function(val) {

        if(typeof val != 'undefined')
            this.rotation = val
        this.setSize()
        this.$img.css('transform', 'rotate('+ this.rotation + 'deg) translateZ(0)')
        if(this.rotation == 90 || this.rotation == 270)
            this.$img.width(this.$wrapper.height()).height(this.$wrapper.width())
        else
            this.$img.width(this.$wrapper.width()).height(this.$wrapper.height())
    },

    updateHtmlContentSize: function() {

        var scale = this.height / 1000

        // console.log(this.height)

        // console.log('updateHtmlContentSize()')
        // console.log(this.htmlContent.style)

        if (this.htmlContent && this.htmlContent.style) {
            // this.htmlContent.style.transform = 'scale(' + scale + ')'
            this.htmlContent.style.transform = 'scale(' + scale + ') translateZ(0)'

            if (this.options.doublePage) {

                // if (this.index == 0 || (this.index == (this.options.pages.length - 1) && !this.options.oddPages))
                //     this.htmlContent.style.left = '0'
                // else
                //     this.htmlContent.style.left = '-100%'

                if (this.index % 2 == 0 && this.index > 0)
                    this.htmlContent.style.left = '-100%'
                else
                    this.htmlContent.style.left = '0'

            }

        }

    }

}

FLIPBOOK.PdfService = function(pdfDocument, model, options) {

    var self = this
    this.pdfDocument = pdfDocument
    this.pdfInfo = pdfDocument._pdfInfo
    this.numPages = this.pdfInfo.numPages
    this.webgl = options.viewMode == 'webgl'
    this.options = options
    this.main = options.main

    this.pages = []
    this.thumbs = []
    this.canvasBuffer = []
    this.viewports = []
    this.textContents = []

    this.pdfPages = []
    this.pdfPagesRendering = []
    this.pdfPagesRendered = []
    this.bookPagesRendered = []
    this.pdfAnnotations = []

    this.eventBus = new EventBus()

    var canvasBufferSize = options.isMobile ? 40 : 200

    for (var i = 0; i < canvasBufferSize; i++) {
        var c = document.createElement('canvas')
        c.width = 10
        c.height = 10
        c._name = i
        c.available = true
        c.pageIndex = -100
        c.pdfPageIndex = -1
        this.canvasBuffer.push(c)
    }




    this._events = {}

    this.on = function(type, fn) {
        if (!this._events[type]) {
            this._events[type] = [];
        }

        this._events[type].push(fn);
    }

    this.off = function(type, fn) {
        if (!this._events[type]) {
            return;
        }

        var index = this._events[type].indexOf(fn);

        if (index > -1) {
            this._events[type].splice(index, 1);
        }
    }

    this.trigger = function(type) {
        if (!this._events[type]) {
            return;
        }

        var i = 0,
            l = this._events[type].length;

        if (!l) {
            return;
        }

        for (; i < l; i++) {
            this._events[type][i].apply(this, [].slice.call(arguments, 1));
        }
    }




    this.getCanvas = function() {

        var i, c

        for (i = 0; i < this.canvasBuffer.length; i++) {
            c = this.canvasBuffer[i]
            if (c.available) {
                c.available = false
                c.double = false
                // c.getContext('2d').clearRect(0, 0, c.width, c.height)
                // console.log('rendering : ',c.rendering)
                break;

            }

        }

        this.canvasBuffer.splice(i, 1);
        this.canvasBuffer.push(c)
        return c

    }

    this.setRightIndex = function(ri) {

        // console.log('setRightIndex: ', ri)

        var self = this
        var unloadedPages = []
        var d = this.options.isMobile ? 4 : 20

        this.canvasBuffer.forEach(function(c) {
            c.available = ((ri - c.pageIndex) > (3 + d)) || ((ri - c.pageIndex) < (-2 - d))
            if (c.available && c.pageIndex > -1) {
                self.pdfPagesRendered[c.pdfPageIndex][c.size] = false
                delete self.pages[c.pdfPageIndex].canvas[c.size]
                self.pages[c.pdfPageIndex].rendering = false

                // if(self.pages[c.pdfPageIndex]){
                self.pages[c.pdfPageIndex].cleanup()
                // delete self.pages[c.pdfPageIndex]      
                // }

                unloadedPages.push({ index: c.pageIndex, size: c.size })
                if (c.double)
                    unloadedPages.push({ index: c.pageIndex - 1, size: c.size })
                c.pageIndex = -100
                c.getContext('2d').clearRect(0, 0, c.width, c.height)
            }
        })

        if (unloadedPages.length > 0)
            this.trigger('pageUnloaded', {unloadedPages:unloadedPages})
    }

    window.s = function() {

        var outer = document.createElement('div')

        document.body.appendChild(outer)

        self.canvasBuffer.forEach(function(c) {
            var inner = document.createElement('span')
            inner.style.margin = '2px'
            inner.style.background = '#ccc'
            inner.style.display = 'inline-block'
            outer.appendChild(inner)
            var dataurl = c.toDataURL()
            var image = new Image()
            image.src = dataurl
            image.style.border = c.available ? '1px solid #0F0' : '1px solid #F00'
            inner.appendChild(image)
            image.height = 100

            var info = document.createElement('span')
            info.style.display = 'block'
            inner.appendChild(info)
            info.innerText = c.pageIndex + ';' + c.pdfPageIndex + ";" + c.size
        })
    }

    this.loadThumbs = function(convertToBlob, callback) {

        var self = this

        this.thumbLoading = this.thumbLoading || 0

        if (this.thumbLoading >= this.pdfInfo.numPages)

            callback.call(self)

        else

            this.loadThumb(this.thumbLoading, function(c) {
                self.options.thumbLoaded(c)
                self.thumbLoading++
                    self.loadThumbs(convertToBlob, callback)
            })

    }

    this.loadThumb = function(index, callback) {

        var self = this

        // console.log('loading thumb ',index)

        this.getViewport(index, function() {

            var page = self.pages[index]

            var scale = 100 / page.getViewport(1).height

            var viewport = page.getViewport(scale);

            var c = document.createElement('canvas')
            c.index = index
            var context = c.getContext('2d');
            c.height = viewport.height;
            c.width = viewport.width;

            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.cleanupAfterRender = true
            page.render(renderContext).then(function() {

                // console.log('thumb ',index, ' loaded')
                page.cleanup()

                if (callback) callback.call(self, c)

            })

        })
    }

    this.getBookPage = function(index, size) {

    }

    this.init = function(loadOutline, backCover) {

        if(loadOutline){
            this.pdfDocument.getOutline().then(function(outline){
                self.outline = outline
                self.init()
            })
            return
        }

        self.getViewport(0, function(viewport) {

                self.r1 = viewport.width / viewport.height

                if (self.pdfInfo.numPages == 1) {
                    self.double = false
                    self.trigger("init")
                } else {
                    self.getViewport(1, function(viewport) {
                        self.r2 = viewport.width / viewport.height
                        self.double = self.r2 / self.r1 > 1.5

                        //last page index 
                        self.double = false
                        self.backCover = backCover || true
                        self.trigger("init")

                        // out - caused entire pdf to be downloaded before displaying 
                        
                        /*self.getViewport(self.pdfInfo.numPages - 1, function(viewport) {
                            self.r3 = viewport.width / viewport.height
                            self.backCover = self.r3 / self.r1 < 1.5
                            self.trigger("init")
                        })*/

                    })

                }

            })
    }

    this.startLoadingText = function(){

        this.loadingText = true

    }

    this.stopLoadingText = function(){

        this.loadingText = false
        
    }

    this.getViewport = function(index, callback) {
        if (index >= self.pdfInfo.numPages)
            return
        if (!self.pages[index]) {
            // console.log('getViewport ',index)
            pdfDocument.getPage(index + 1).then(function(page) {
                self.pages[page.pageIndex] = page
                // self.viewports[index] = page.getViewport(1);
                // callback.call(self, self.viewports[index]);

                self.getViewport(page.pageIndex, callback)
            })
        } else {
            self.viewports[index] = self.pages[index].getViewport(1);
            callback.call(self, self.viewports[index]);
        }
    }

    this.getAllViewports = function(callback) {

    }

    this.getText = function(index, callback) {
        var self = this
        this.getViewport(index, function(viewport) {
            var page = self.pages[index]

            self.getTextContent(page, function() {
                // console.log(page)
                callback.call(self, page)

            })

        })
    }

    this.getTextAllPages = function(callback) {

        var self = this

        this.loadingTextFromPage = this.loadingTextFromPage || 0

        this.getText(this.loadingTextFromPage, function() {

            if (self.loadingTextFromPage == (self.numPages - 1)){
                if (callback)
                    callback.call(self)
            } else {
                self.loadingTextFromPage++
                    self.getTextAllPages(callback)
            }

        })

    }

    this.findInPage = function(str, index, callback) {

        //console.log("find ", str, index)
        var self = this
        this.findInPageCallbacks = this.findInPageCallbacks || []
        this.findInPageCallbacks[index] = callback
        this.searchingString = str

        if(this.pages[index] && this.pages[index].textContent){
            self.findInPageTextContentAvailable(this.pages[index],index)
        }else{
            this.getText(index, function(page) {
                self.findInPageTextContentAvailable(page,index)
            })
        }

    }

    this.findInPageTextContentAvailable = function(page,index){
         //console.log("page text ready ", index)
            var arr = page.textContent.items
            var matches = 0
            for (var i = 0; i < arr.length; i++) {
                var s = arr[i].str
                if (s.includes(this.searchingString))
                    matches++
                    if (s.toUpperCase().includes(this.searchingString.toUpperCase()))
                        matches++
            }

            var callback = this.findInPageCallbacks[index]
            if(callback) 
                callback.call(this, matches, page.htmlContent)
            this.findInPageCallbacks[index] = null
    }

    this.getThumb = function(index, size, callback) {

        this.getViewport(index, function(viewport) {
            var page = self.pages[index]
            if (page.thumb)
                callback.call(self, page.thumb)
            else {
                //render thumb first
                var scale = size / self.viewports[index].height
                var viewport = page.getViewport(scale);
                var c = document.createElement('canvas')
                page.thumb = c
                var context = c.getContext('2d');
                c.height = viewport.height;
                c.width = viewport.width;

                var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                page.cleanupAfterRender = true
                page.render(renderContext).then(function() {
                    page.cleanup()
                    callback.call(self, page.thumb)

                })

            }

        })
    }

    this.getPage = function(index, callback) {

        var self = this;
        var pdfPageIndex = self.double ? Math.round(index / 2) + 1 : index + 1
        if (pdfPageIndex > this.pdfInfo.numPages)
            return;
        // if (self.pages[pdfPageIndex])
        //     self.renderPage(self.pages[pdfPageIndex], callback)
        // else {
        pdfDocument.getPage(index).then(function(p) {
            // self.pages[index] = p
            self.renderPage(p, callback)
        });
        // }
    }

    this.renderPage = function(page, size, callback) {

        var self = this
        page.canvas = page.canvas || {}

        if (page.canvas[size]) {
            callback.call(self, page)
            return
        }

        if (page.rendering) {
            
            setTimeout(function() {
                self.renderPage(page, size, callback)
                return
            }, 300)
        }
        page.rendering = true

        //page.htmlContent = document.createElement('p')

        this.getTextContent(page, function() {

            /*ar scale = 2048 / self.viewports[1].height,
                v = page.getViewport(1),
                d = Math.max(v.width, v.height),
                scale = 2048 / d,
                viewport = page.getViewport(scale),
                canvas = document.createElement('canvas');*/

            var v = page.getViewport(1)
            //var scale = self.options.pageTextureSize / v.height
            var portrait = v.width <= v.height
            var scale = portrait || !self.webgl ? size / v.height : size / v.width
            var viewport = page.getViewport(scale)

            // var canvas = document.createElement('canvas');
            var canvas = self.getCanvas()
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.rendering = true

            if (self.webgl) {

                if (portrait) {
                    canvas.height = size;
                    canvas.width = viewport.width > size ? viewport.width : size;
                    canvas.scaleX = viewport.width / size
                    canvas.scaleY = 1
                } else {
                    canvas.width = size
                    canvas.height = viewport.height > size ? viewport.height : size
                    canvas.scaleY = viewport.height / size
                    canvas.scaleX = 1
                }
            }

            var ctx = canvas.getContext('2d');
            ctx.fillStyle = '#FFFFFF';
            ctx.fillStyle = '#000000';

            var renderContext = {
                canvasContext: ctx,
                viewport: viewport,
                //renderInteractiveForms: false
                //textLayer: textLayer
            };

            //page.canvas[size] = canvas
            page.scale = scale
            page.canvas[size] = canvas
            page.canvas[size].ratio = viewport.width / viewport.height

            page.cleanupAfterRender = true



            var renderTask = page.render(renderContext);
            renderTask.promise.then(function() {
                renderContext = null
                if (callback)
                    callback.call(self, page)
            });

        })
    }

    this.renderPageFromPdf = function(pageIndex, size, callback) {

        var self = this

        if (pageIndex >= this.pdfInfo.numPages)
            callback.call(self)

        if (!this.pages[pageIndex]) {
            this.getViewport(pageIndex, function(viewport) {
                self.renderPageFromPdf(pageIndex, size, callback)
            });
            return
        }

        var pi = pageIndex,
            page = this.pages[pageIndex],
            v = page.getViewport(1),
            d = Math.max(v.width, v.height),
            d = v.height,
            scale = size / d

        if (self.pdfPagesRendering[pi] && self.pdfPagesRendering[pi][size]){

            setTimeout(function(){
                self.renderPageFromPdf(pageIndex, size, callback)
                }, 100)
            return

        }
            

        if (self.pdfPagesRendered[pi] && self.pdfPagesRendered[pi][size]) {

            self.onPdfPageRendered(self.pages[pi], size, callback)

        } else {

            self.pdfPagesRendered[pi] = self.pdfPagesRendered[pi] || {}

            self.pdfPagesRendering[pi] = self.pdfPagesRendering[pi] || {}

            self.pdfPagesRendering[pi][size] = true

            this.renderPage(page, size, function(page) {

                self.pdfPagesRendering[pi][size] = false
                self.pdfPagesRendered[pi][size] = true
                self.onPdfPageRendered(page, size, callback)
            })

        }
    }

    this.onBookPageRendered = function(page, canvas, index, size) {

        this.bookPagesRendered.push({ index: index, pdfPageIndex: page.pageIndex, size: size })

        //console.log("page loaded")

        this.trigger('pageLoaded', {index:index, size:size, canvas:canvas})

    }

    this.onPdfPageRendered = function(page, size, callback) {

        var self = this

        if (!page.canvas) return;
        if (!page.canvas[size]) return;

        // console.log(page.canvas)

        var c = page.canvas[size],
            h = page.htmlContent,
            pdfPageIndex = page.pageIndex;

        c.pdfPageIndex = pdfPageIndex
        c.rendering = false

        if (typeof c == 'undefined') return;

        if (options.pageMode == 'doubleWithCover') {

            if (pdfPageIndex == 0) {

                initializeHtmlContent(h, pdfPageIndex)
                c.pageIndex = 0
                c.size = size
                self.onBookPageRendered(page, c, 0, size)
                //self.options.pages[0].htmlContent = h


            } else if (pdfPageIndex == options.pages.length / 2) {

                initializeHtmlContent(h, options.numPages - 1)
                c.pageIndex = options.numPages - 1
                c.size = size
                self.onBookPageRendered(page, c, options.numPages - 1, size)
                //self.options.pages[self.options.pages.length - 1].htmlContent = h

            } else {

                h.style.transformOrigin = '0 0'

                //  if( !options.pages[2 * pdfPageIndex].canvas || !options.pages[2 * pdfPageIndex].canvas[size]){ 

                //     options.pages[2 * pdfPageIndex].canvas = options.pages[2 * pdfPageIndex].canvas || {}


                if (self.webgl) {

                    c.double = true

                    c.scaleX = (c.width / 2) / size
                    c.scaleY = c.scaleY

                    var h2 = h.cloneNode(true);

                    initializeHtmlContent(h, 2 * pdfPageIndex - 1)

                    initializeHtmlContent(h2, 2 * pdfPageIndex)

                    self.onBookPageRendered(page, c, 2 * pdfPageIndex, size)

                    self.onBookPageRendered(page, c, 2 * pdfPageIndex - 1, size)
                    c.pageIndex = 2 * pdfPageIndex
                    c.size = size

                } else {

                    var rCanvas = self.getCanvas()
                    var rcontext = rCanvas.getContext('2d');
                    rCanvas.rendering = true

                    rCanvas.width = c.width / 2;
                    rCanvas.height = c.height;

                    rcontext.fillStyle = '#FFFFFF';

                    rcontext.drawImage(c, c.width / 2, 0, c.width / 2, c.height, 0, 0, c.width / 2, c.height);
                    rCanvas.rendering = false

                    var loadedIndexR = self.options.rightToLeft ? 2 * pdfPageIndex - 1 : 2 * pdfPageIndex

                    rCanvas.pageIndex = loadedIndexR
                    rCanvas.pdfPageIndex = pdfPageIndex
                    rCanvas.size = size


                    var lCanvas = self.getCanvas()
                    var lcontext = lCanvas.getContext('2d');


                    //set dimensions
                    lCanvas.width = c.width / 2;
                    lCanvas.height = c.height;
                    lCanvas.rendering = true

                    lcontext.fillStyle = '#FFFFFF';

                    lcontext.drawImage(c, 0, 0);
                    lCanvas.rendering = false

                    var loadedIndexL = self.options.rightToLeft ? 2 * pdfPageIndex : 2 * pdfPageIndex - 1

                    lCanvas.pageIndex = loadedIndexL
                    lCanvas.pdfPageIndex = pdfPageIndex
                    lCanvas.size = size

                    var h2 = h.cloneNode(true);

                    initializeHtmlContent(h, 2 * pdfPageIndex - 1)

                    initializeHtmlContent(h2, 2 * pdfPageIndex)

                    self.onBookPageRendered(page, rCanvas, loadedIndexR, size)
                    self.onBookPageRendered(page, lCanvas, loadedIndexL, size)

                    c.available = true

                    c.getContext('2d').clearRect(0, 0, c.width, c.height)

                    c.pageIndex = -100
                    c.size = size

                }

            }

        } else {

            initializeHtmlContent(h, pdfPageIndex)
            c.pageIndex = pdfPageIndex
            c.size = size
            self.onBookPageRendered(page, c, pdfPageIndex, size)
            //self.options.pages[pdfPageIndex].htmlContent = h;

        }

        function initializeHtmlContent(h, pi) {
            /* if (options.rightToLeft)
                 pi = options.pages.length - pi - 1*/
            var page = options.pages[pi]
            if (!page.htmlContentInitialized) {
                if (page.htmlContent)
                    jQuery(h).append(jQuery(page.htmlContent))
                page.htmlContentInitialized = true
                page.htmlContent = h
            }
        }

        if (callback)
            callback.call(self, { canvas: c, size: size, pdfPageIndex: pdfPageIndex });

    }

    this.getTextContent = function(page, callback) {

        if (page.htmlContent)
            callback(page)
        else
            page.getTextContent().then(function(textContent) {
                page.textContent = textContent


                var htmlContentDiv = document.createElement('div');
                htmlContentDiv.classList.add('flipbook-page-htmlContent')

                var defaultPageHeight = 1000;

                //text layer

                if (self.options.textLayer) {

                    var textLayerDiv = document.createElement('div');
                    textLayerDiv.className = 'flipbook-textLayer';

                    var scale = 1000 / page.getViewport(1).height

                    textLayerDiv.style.width = String(1000 * page.getViewport(1).width / page.getViewport(1).height) + "px"
                    textLayerDiv.style.height = "1000px";

                    var textLayer = new TextLayerBuilder({
                        eventBus : self.eventBus,
                        textLayerDiv: textLayerDiv,
                        pageIndex: page.pageIndex,
                        viewport: page.getViewport(scale)
                    });
                    //the page. It is set to page.number - 1.
                    textLayer.setTextContent(textContent);
                    textLayer.render(TEXT_LAYER_RENDER_DELAY);
                    htmlContentDiv.appendChild(textLayerDiv)

                }

                //annotations (links) layer

                var linkService = new PDFLinkService({
                        eventBus : self.eventBus,
                    });
                
                linkService.setViewer(self.main)
                linkService.setDocument(pdfDocument)

//                 var annotationsDiv = document.createElement('div')
//                 annotationsDiv.className = 'flipbook-annotations';

//                 annotationsDiv.style.width = String(1000 * page.getViewport(1).width / page.getViewport(1).height) + "px"
//                 annotationsDiv.style.height = "1000px";
//                 annotationsDiv.style.position = 'absolute'

                var annotationLayerBuilder = new AnnotationLayerBuilder({
                    pageDiv: htmlContentDiv,
                    pdfPage: page,
                    linkService: linkService
                });

                
                annotationLayerBuilder.render(page.getViewport(1000/page.getViewport(1).height), 'display');

//                 htmlContentDiv.appendChild(annotationsDiv)
                page.htmlContent = htmlContentDiv

                callback(page)
            })
    }


    //////////////////napravi sa drawimage
    /*function cloneCanvas(c) {
        var data = c.getContext("2d").getImageData(0, 0, c.width, c.height)
        var c2 = document.createElement('canvas');
        c2.width = c.width;
        c2.height = c.height;
        var ctx2 = c2.getContext('2d');
        ctx2.putImageData(data, 0, 0);
        c.duplicate = c2
        return c2
    }*/

    this.getCanvasByHeight = function(index, height, onComplete) {

    }

    // this.getThumb = function(index, complete) {

    // }

}

FLIPBOOK.PdfService.prototype = {

    

}


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// var _dom_events = __webpack_require__(14);

// var _pdfjsLib = __webpack_require__(7);

// var _ui_utils = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var EventBus = function () {
  function EventBus() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$dispatchToDOM = _ref7.dispatchToDOM,
        dispatchToDOM = _ref7$dispatchToDOM === undefined ? false : _ref7$dispatchToDOM;

    _classCallCheck(this, EventBus);

    this._listeners = Object.create(null);
    this._dispatchToDOM = dispatchToDOM === true;
  }

  _createClass(EventBus, [{
    key: 'on',
    value: function on(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners) {
        eventListeners = [];
        this._listeners[eventName] = eventListeners;
      }
      eventListeners.push(listener);
    }
  }, {
    key: 'off',
    value: function off(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      var i = void 0;
      if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
        return;
      }
      eventListeners.splice(i, 1);
    }
  }, {
    key: 'dispatch',
    value: function dispatch(eventName) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners || eventListeners.length === 0) {
        if (this._dispatchToDOM) {
          var _args5 = Array.prototype.slice.call(arguments, 1);
          this._dispatchDOMEvent(eventName, _args5);
        }
        return;
      }
      var args = Array.prototype.slice.call(arguments, 1);
      eventListeners.slice(0).forEach(function (listener) {
        listener.apply(null, args);
      });
      if (this._dispatchToDOM) {
        this._dispatchDOMEvent(eventName, args);
      }
    }
  }, {
    key: '_dispatchDOMEvent',
    value: function _dispatchDOMEvent(eventName) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this._dispatchToDOM) {
        return;
      }
      var details = Object.create(null);
      if (args && args.length > 0) {
        var obj = args[0];
        for (var key in obj) {
          var value = obj[key];
          if (key === 'source') {
            if (value === window || value === document) {
              return;
            }
            continue;
          }
          details[key] = value;
        }
      }
      var event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, true, details);
      document.dispatchEvent(event);
    }
  }]);

  return EventBus;
}();





var EXPAND_DIVS_TIMEOUT = 300;
var MATCH_SCROLL_OFFSET_TOP = -50;
var MATCH_SCROLL_OFFSET_LEFT = -400;

var TextLayerBuilder = function () {
  function TextLayerBuilder(_ref) {
    var textLayerDiv = _ref.textLayerDiv,
        eventBus = _ref.eventBus,
        pageIndex = _ref.pageIndex,
        viewport = _ref.viewport,
        _ref$findController = _ref.findController,
        findController = _ref$findController === undefined ? null : _ref$findController,
        _ref$enhanceTextSelec = _ref.enhanceTextSelection,
        enhanceTextSelection = _ref$enhanceTextSelec === undefined ? false : _ref$enhanceTextSelec;

    _classCallCheck(this, TextLayerBuilder);

    this.textLayerDiv = textLayerDiv;
    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.textContent = null;
    this.textContentItemsStr = [];
    this.textContentStream = null;
    this.renderingDone = false;
    this.pageIdx = pageIndex;
    this.pageNumber = this.pageIdx + 1;
    this.matches = [];
    this.viewport = viewport;
    this.textDivs = [];
    this.findController = findController;
    this.textLayerRenderTask = null;
    this.enhanceTextSelection = enhanceTextSelection;
    this._boundEvents = Object.create(null);
    this._bindEvents();
    this._bindMouse();
  }

  _createClass(TextLayerBuilder, [{
    key: '_finishRendering',
    value: function _finishRendering() {
      this.renderingDone = true;
      if (!this.enhanceTextSelection) {
        var endOfContent = document.createElement('div');
        endOfContent.className = 'endOfContent';
        this.textLayerDiv.appendChild(endOfContent);
      }
      this.eventBus.dispatch('textlayerrendered', {
        source: this,
        pageNumber: this.pageNumber,
        numTextDivs: this.textDivs.length
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!(this.textContent || this.textContentStream) || this.renderingDone) {
        return;
      }
      this.cancel();
      this.textDivs = [];
      var textLayerFrag = document.createDocumentFragment();
      this.textLayerRenderTask = (0, pdfjsLib.renderTextLayer)({
        textContent: this.textContent,
        textContentStream: this.textContentStream,
        container: textLayerFrag,
        viewport: this.viewport,
        textDivs: this.textDivs,
        textContentItemsStr: this.textContentItemsStr,
        timeout: timeout,
        enhanceTextSelection: this.enhanceTextSelection
      });
      this.textLayerRenderTask.promise.then(function () {
        _this.textLayerDiv.appendChild(textLayerFrag);
        _this._finishRendering();
        _this.updateMatches();
      }, function (reason) {});
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      if (this.textLayerRenderTask) {
        this.textLayerRenderTask.cancel();
        this.textLayerRenderTask = null;
      }
    }
  }, {
    key: 'setTextContentStream',
    value: function setTextContentStream(readableStream) {
      this.cancel();
      this.textContentStream = readableStream;
    }
  }, {
    key: 'setTextContent',
    value: function setTextContent(textContent) {
      this.cancel();
      this.textContent = textContent;
    }
  }, {
    key: 'convertMatches',
    value: function convertMatches(matches, matchesLength) {
      var i = 0;
      var iIndex = 0;
      var textContentItemsStr = this.textContentItemsStr;
      var end = textContentItemsStr.length - 1;
      var queryLen = this.findController === null ? 0 : this.findController.state.query.length;
      var ret = [];
      if (!matches) {
        return ret;
      }
      for (var m = 0, len = matches.length; m < len; m++) {
        var matchIdx = matches[m];
        while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        if (i === textContentItemsStr.length) {
          console.error('Could not find a matching mapping');
        }
        var match = {
          begin: {
            divIdx: i,
            offset: matchIdx - iIndex
          }
        };
        if (matchesLength) {
          matchIdx += matchesLength[m];
        } else {
          matchIdx += queryLen;
        }
        while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        match.end = {
          divIdx: i,
          offset: matchIdx - iIndex
        };
        ret.push(match);
      }
      return ret;
    }
  }, {
    key: 'renderMatches',
    value: function renderMatches(matches) {
      if (matches.length === 0) {
        return;
      }
      var textContentItemsStr = this.textContentItemsStr;
      var textDivs = this.textDivs;
      var prevEnd = null;
      var pageIdx = this.pageIdx;
      var isSelectedPage = this.findController === null ? false : pageIdx === this.findController.selected.pageIdx;
      var selectedMatchIdx = this.findController === null ? -1 : this.findController.selected.matchIdx;
      var highlightAll = this.findController === null ? false : this.findController.state.highlightAll;
      var infinity = {
        divIdx: -1,
        offset: undefined
      };
      function beginText(begin, className) {
        var divIdx = begin.divIdx;
        textDivs[divIdx].textContent = '';
        appendTextToDiv(divIdx, 0, begin.offset, className);
      }
      function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
        var div = textDivs[divIdx];
        var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
        var node = document.createTextNode(content);
        if (className) {
          var span = document.createElement('span');
          span.className = className;
          span.appendChild(node);
          div.appendChild(span);
          return;
        }
        div.appendChild(node);
      }
      var i0 = selectedMatchIdx,
          i1 = i0 + 1;
      if (highlightAll) {
        i0 = 0;
        i1 = matches.length;
      } else if (!isSelectedPage) {
        return;
      }
      for (var i = i0; i < i1; i++) {
        var match = matches[i];
        var begin = match.begin;
        var end = match.end;
        var isSelected = isSelectedPage && i === selectedMatchIdx;
        var highlightSuffix = isSelected ? ' selected' : '';
        if (this.findController) {
          if (this.findController.selected.matchIdx === i && this.findController.selected.pageIdx === pageIdx) {
            var spot = {
              top: MATCH_SCROLL_OFFSET_TOP,
              left: MATCH_SCROLL_OFFSET_LEFT
            };
            (0, _ui_utils.scrollIntoView)(textDivs[begin.divIdx], spot, true);
          }
        }
        if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
          if (prevEnd !== null) {
            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
          }
          beginText(begin);
        } else {
          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
        }
        if (begin.divIdx === end.divIdx) {
          appendTextToDiv(begin.divIdx, begin.offset, end.offset, 'highlight' + highlightSuffix);
        } else {
          appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, 'highlight begin' + highlightSuffix);
          for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
            textDivs[n0].className = 'highlight middle' + highlightSuffix;
          }
          beginText(end, 'highlight end' + highlightSuffix);
        }
        prevEnd = end;
      }
      if (prevEnd) {
        appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
      }
    }
  }, {
    key: 'updateMatches',
    value: function updateMatches() {
      if (!this.renderingDone) {
        return;
      }
      var matches = this.matches;
      var textDivs = this.textDivs;
      var textContentItemsStr = this.textContentItemsStr;
      var clearedUntilDivIdx = -1;
      for (var i = 0, len = matches.length; i < len; i++) {
        var match = matches[i];
        var begin = Math.max(clearedUntilDivIdx, match.begin.divIdx);
        for (var n = begin, end = match.end.divIdx; n <= end; n++) {
          var div = textDivs[n];
          div.textContent = textContentItemsStr[n];
          div.className = '';
        }
        clearedUntilDivIdx = match.end.divIdx + 1;
      }
      if (!this.findController || !this.findController.highlightMatches) {
        return;
      }
      var pageMatches = void 0,
          pageMatchesLength = void 0;
      if (this.findController !== null) {
        pageMatches = this.findController.pageMatches[this.pageIdx] || null;
        pageMatchesLength = this.findController.pageMatchesLength ? this.findController.pageMatchesLength[this.pageIdx] || null : null;
      }
      this.matches = this.convertMatches(pageMatches, pageMatchesLength);
      this.renderMatches(this.matches);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      var _this2 = this;

      var eventBus = this.eventBus,
          _boundEvents = this._boundEvents;

      _boundEvents.pageCancelled = function (evt) {
        if (evt.pageNumber !== _this2.pageNumber) {
          return;
        }
        if (_this2.textLayerRenderTask) {
          console.error('TextLayerBuilder._bindEvents: `this.cancel()` should ' + 'have been called when the page was reset, or rendering cancelled.');
          return;
        }
        for (var name in _boundEvents) {
          eventBus.off(name.toLowerCase(), _boundEvents[name]);
          delete _boundEvents[name];
        }
      };
      _boundEvents.updateTextLayerMatches = function (evt) {
        if (evt.pageIndex !== _this2.pageIdx && evt.pageIndex !== -1) {
          return;
        }
        _this2.updateMatches();
      };
      eventBus.on('pagecancelled', _boundEvents.pageCancelled);
      eventBus.on('updatetextlayermatches', _boundEvents.updateTextLayerMatches);
    }
  }, {
    key: '_bindMouse',
    value: function _bindMouse() {
      var _this3 = this;

      var div = this.textLayerDiv;
      var expandDivsTimer = null;
      div.addEventListener('mousedown', function (evt) {
        if (_this3.enhanceTextSelection && _this3.textLayerRenderTask) {
          _this3.textLayerRenderTask.expandTextDivs(true);
          if (expandDivsTimer) {
            clearTimeout(expandDivsTimer);
            expandDivsTimer = null;
          }
          return;
        }
        var end = div.querySelector('.endOfContent');
        if (!end) {
          return;
        }
        var adjustTop = evt.target !== div;
        adjustTop = adjustTop && window.getComputedStyle(end).getPropertyValue('-moz-user-select') !== 'none';
        if (adjustTop) {
          var divBounds = div.getBoundingClientRect();
          var r = Math.max(0, (evt.pageY - divBounds.top) / divBounds.height);
          end.style.top = (r * 100).toFixed(2) + '%';
        }
        end.classList.add('active');
      });
      div.addEventListener('mouseup', function () {
        if (_this3.enhanceTextSelection && _this3.textLayerRenderTask) {
          expandDivsTimer = setTimeout(function () {
            if (_this3.textLayerRenderTask) {
              _this3.textLayerRenderTask.expandTextDivs(false);
            }
            expandDivsTimer = null;
          }, EXPAND_DIVS_TIMEOUT);
          return;
        }
        var end = div.querySelector('.endOfContent');
        if (!end) {
          return;
        }
        end.style.top = '';
        end.classList.remove('active');
      });
    }
  }]);

  return TextLayerBuilder;
}();

var DefaultTextLayerFactory = function () {
  function DefaultTextLayerFactory() {
    _classCallCheck(this, DefaultTextLayerFactory);
  }

  _createClass(DefaultTextLayerFactory, [{
    key: 'createTextLayerBuilder',
    value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
      var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      return new TextLayerBuilder({
        textLayerDiv: textLayerDiv,
        pageIndex: pageIndex,
        viewport: viewport,
        enhanceTextSelection: enhanceTextSelection
      });
    }
  }]);

  return DefaultTextLayerFactory;
}();


var PDFLinkService = function () {
  function PDFLinkService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        eventBus = _ref.eventBus,
        _ref$externalLinkTarg = _ref.externalLinkTarget,
        externalLinkTarget = _ref$externalLinkTarg === undefined ? null : _ref$externalLinkTarg,
        _ref$externalLinkRel = _ref.externalLinkRel,
        externalLinkRel = _ref$externalLinkRel === undefined ? null : _ref$externalLinkRel;

    _classCallCheck(this, PDFLinkService);

    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.externalLinkTarget = externalLinkTarget;
    this.externalLinkRel = externalLinkRel;
    this.baseUrl = null;
    this.pdfDocument = null;
    this.pdfViewer = null;
    this.pdfHistory = null;
    this._pagesRefCache = null;
  }

  _createClass(PDFLinkService, [{
    key: 'setDocument',
    value: function setDocument(pdfDocument) {
      var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.baseUrl = baseUrl;
      this.pdfDocument = pdfDocument;
      this._pagesRefCache = Object.create(null);
    }
  }, {
    key: 'setViewer',
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: 'setHistory',
    value: function setHistory(pdfHistory) {
      this.pdfHistory = pdfHistory;
    }
  }, {
    key: 'navigateTo',
    value: function navigateTo(dest) {
      var _this = this;

      var goToDestination = function goToDestination(_ref2) {
        var namedDest = _ref2.namedDest,
            explicitDest = _ref2.explicitDest;

        var destRef = explicitDest[0],
            pageNumber = void 0;
        if (destRef instanceof Object) {
          pageNumber = _this._cachedPageNumber(destRef);
          if (pageNumber === null) {
            _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
              _this.cachePageRef(pageIndex + 1, destRef);
              goToDestination({
                namedDest: namedDest,
                explicitDest: explicitDest
              });
            }).catch(function () {
              console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid page reference, for dest="' + dest + '".'));
            });
            return;
          }
        } else if (Number.isInteger(destRef)) {
          pageNumber = destRef + 1;
        } else {
          console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid destination reference, for dest="' + dest + '".'));
          return;
        }
        if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
          console.error('PDFLinkService.navigateTo: "' + pageNumber + '" is not ' + ('a valid page number, for dest="' + dest + '".'));
          return;
        }
        if (_this.pdfHistory) {
          _this.pdfHistory.pushCurrentPosition();
          _this.pdfHistory.push({
            namedDest: namedDest,
            explicitDest: explicitDest,
            pageNumber: pageNumber
          });
        }
        _this.pdfViewer.scrollPageIntoView({
          pageNumber: pageNumber,
          destArray: explicitDest
        });
      };
      new Promise(function (resolve, reject) {
        if (typeof dest === 'string') {
          _this.pdfDocument.getDestination(dest).then(function (destArray) {
            resolve({
              namedDest: dest,
              explicitDest: destArray
            });
          });
          return;
        }
        resolve({
          namedDest: '',
          explicitDest: dest
        });
      }).then(function (data) {
        if (!Array.isArray(data.explicitDest)) {
          console.error('PDFLinkService.navigateTo: "' + data.explicitDest + '" is' + (' not a valid destination array, for dest="' + dest + '".'));
          return;
        }
        goToDestination(data);
      });
    }
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      if (typeof dest === 'string') {
        return this.getAnchorUrl('#' + escape(dest));
      }
      if (Array.isArray(dest)) {
        var str = JSON.stringify(dest);
        return this.getAnchorUrl('#' + escape(str));
      }
      return this.getAnchorUrl('');
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(anchor) {
      return (this.baseUrl || '') + anchor;
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {
      var pageNumber = void 0,
          dest = void 0;
      if (hash.includes('=')) {
        var params = (0, _ui_utils.parseQueryString)(hash);
        if ('search' in params) {
          this.eventBus.dispatch('findfromurlhash', {
            source: this,
            query: params['search'].replace(/"/g, ''),
            phraseSearch: params['phrase'] === 'true'
          });
        }
        if ('nameddest' in params) {
          this.navigateTo(params.nameddest);
          return;
        }
        if ('page' in params) {
          pageNumber = params.page | 0 || 1;
        }
        if ('zoom' in params) {
          var zoomArgs = params.zoom.split(',');
          var zoomArg = zoomArgs[0];
          var zoomArgNumber = parseFloat(zoomArg);
          if (!zoomArg.includes('Fit')) {
            dest = [null, { name: 'XYZ' }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
          } else {
            if (zoomArg === 'Fit' || zoomArg === 'FitB') {
              dest = [null, { name: zoomArg }];
            } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
              dest = [null, { name: zoomArg }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
            } else if (zoomArg === 'FitR') {
              if (zoomArgs.length !== 5) {
                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
              } else {
                dest = [null, { name: zoomArg }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
              }
            } else {
              console.error('PDFLinkService.setHash: "' + zoomArg + '" is not ' + 'a valid zoom value.');
            }
          }
        }
        if (dest) {
          this.pdfViewer.scrollPageIntoView({
            pageNumber: pageNumber || this.page,
            destArray: dest,
            allowNegativeOffset: true
          });
        } else if (pageNumber) {
          this.page = pageNumber;
        }
        if ('pagemode' in params) {
          this.eventBus.dispatch('pagemode', {
            source: this,
            mode: params.pagemode
          });
        }
      } else {
        dest = unescape(hash);
        try {
          dest = JSON.parse(dest);
          if (!Array.isArray(dest)) {
            dest = dest.toString();
          }
        } catch (ex) {}
        if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
          this.navigateTo(dest);
          return;
        }
        console.error('PDFLinkService.setHash: "' + unescape(hash) + '" is not ' + 'a valid destination.');
      }
    }
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {
      switch (action) {
        case 'GoBack':
          if (this.pdfHistory) {
            this.pdfHistory.back();
          }
          break;
        case 'GoForward':
          if (this.pdfHistory) {
            this.pdfHistory.forward();
          }
          break;
        case 'NextPage':
          if (this.page < this.pagesCount) {
            this.page++;
          }
          break;
        case 'PrevPage':
          if (this.page > 1) {
            this.page--;
          }
          break;
        case 'LastPage':
          this.page = this.pagesCount;
          break;
        case 'FirstPage':
          this.page = 1;
          break;
        default:
          break;
      }
      this.eventBus.dispatch('namedaction', {
        source: this,
        action: action
      });
    }
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {
      if (!pageRef) {
        return;
      }
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      this._pagesRefCache[refStr] = pageNum;
    }
  }, {
    key: '_cachedPageNumber',
    value: function _cachedPageNumber(pageRef) {
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      return this._pagesRefCache && this._pagesRefCache[refStr] || null;
    }
  }, {
    key: 'pagesCount',
    get: function get() {
      return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
  }, {
    key: 'page',
    get: function get() {
      return this.pdfViewer.currentPageNumber;
    },
    set: function set(value) {
      this.pdfViewer.currentPageNumber = value;
    }
  }, {
    key: 'rotation',
    get: function get() {
      return this.pdfViewer.pagesRotation;
    },
    set: function set(value) {
      this.pdfViewer.pagesRotation = value;
    }
  }]);

  return PDFLinkService;
}();

function isValidExplicitDestination(dest) {
  if (!Array.isArray(dest)) {
    return false;
  }
  var destLength = dest.length,
      allowNull = true;
  if (destLength < 2) {
    return false;
  }
  var page = dest[0];
  if (!((typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' && Number.isInteger(page.num) && Number.isInteger(page.gen)) && !(Number.isInteger(page) && page >= 0)) {
    return false;
  }
  var zoom = dest[1];
  if (!((typeof zoom === 'undefined' ? 'undefined' : _typeof(zoom)) === 'object' && typeof zoom.name === 'string')) {
    return false;
  }
  switch (zoom.name) {
    case 'XYZ':
      if (destLength !== 5) {
        return false;
      }
      break;
    case 'Fit':
    case 'FitB':
      return destLength === 2;
    case 'FitH':
    case 'FitBH':
    case 'FitV':
    case 'FitBV':
      if (destLength !== 3) {
        return false;
      }
      break;
    case 'FitR':
      if (destLength !== 6) {
        return false;
      }
      allowNull = false;
      break;
    default:
      return false;
  }
  for (var i = 2; i < destLength; i++) {
    var param = dest[i];
    if (!(typeof param === 'number' || allowNull && param === null)) {
      return false;
    }
  }
  return true;
}

var SimpleLinkService = function () {
  function SimpleLinkService() {
    _classCallCheck(this, SimpleLinkService);

    this.externalLinkTarget = null;
    this.externalLinkRel = null;
  }

  _createClass(SimpleLinkService, [{
    key: 'navigateTo',
    value: function navigateTo(dest) {}
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      return '#';
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(hash) {
      return '#';
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {}
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {}
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {}
  }, {
    key: 'pagesCount',
    get: function get() {
      return 0;
    }
  }, {
    key: 'page',
    get: function get() {
      return 0;
    },
    set: function set(value) {}
  }, {
    key: 'rotation',
    get: function get() {
      return 0;
    },
    set: function set(value) {}
  }]);

  return SimpleLinkService;
}();


var AnnotationLayerBuilder = function () {
  function AnnotationLayerBuilder(_ref) {
    var pageDiv = _ref.pageDiv,
        pdfPage = _ref.pdfPage,
        linkService = _ref.linkService,
        downloadManager = _ref.downloadManager,
        _ref$imageResourcesPa = _ref.imageResourcesPath,
        imageResourcesPath = _ref$imageResourcesPa === undefined ? '' : _ref$imageResourcesPa,
        _ref$renderInteractiv = _ref.renderInteractiveForms,
        renderInteractiveForms = _ref$renderInteractiv === undefined ? false : _ref$renderInteractiv;
        // _ref$l10n = _ref.l10n,
        // l10n = _ref$l10n === undefined ? _ui_utils.NullL10n : _ref$l10n;

    _classCallCheck(this, AnnotationLayerBuilder);

    this.pageDiv = pageDiv;
    this.pdfPage = pdfPage;
    this.linkService = linkService;
    this.downloadManager = downloadManager;
    this.imageResourcesPath = imageResourcesPath;
    this.renderInteractiveForms = renderInteractiveForms;
    // this.l10n = l10n;
    this.div = null;
    this._cancelled = false;
  }

  _createClass(AnnotationLayerBuilder, [{
    key: 'render',
    value: function render(viewport) {
      var _this = this;

      var intent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'display';

      this.pdfPage.getAnnotations({ intent: intent }).then(function (annotations) {
        if (_this._cancelled) {
          return;
        }
        var parameters = {
          viewport: viewport.clone({ dontFlip: true }),
          div: _this.div,
          annotations: annotations,
          page: _this.pdfPage,
          imageResourcesPath: _this.imageResourcesPath,
          renderInteractiveForms: _this.renderInteractiveForms,
          linkService: _this.linkService,
          downloadManager: _this.downloadManager
        };
        if (_this.div) {
          pdfjsLib.AnnotationLayer.update(parameters);
        } else {
          if (annotations.length === 0) {
            return;
          }
          _this.div = document.createElement('div');
          _this.div.className = 'annotationLayer';
          _this.pageDiv.appendChild(_this.div);
          parameters.div = _this.div;
          pdfjsLib.AnnotationLayer.render(parameters);
          // _this.l10n.translate(_this.div);
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this._cancelled = true;
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.div) {
        return;
      }
      this.div.setAttribute('hidden', 'true');
    }
  }]);

  return AnnotationLayerBuilder;
}();

var DefaultAnnotationLayerFactory = function () {
  function DefaultAnnotationLayerFactory() {
    _classCallCheck(this, DefaultAnnotationLayerFactory);
  }

  _createClass(DefaultAnnotationLayerFactory, [{
    key: 'createAnnotationLayerBuilder',
    value: function createAnnotationLayerBuilder(pageDiv, pdfPage) {
      var imageResourcesPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var renderInteractiveForms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      // var l10n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _ui_utils.NullL10n;

      return new AnnotationLayerBuilder({
        pageDiv: pageDiv,
        pdfPage: pdfPage,
        imageResourcesPath: imageResourcesPath,
        renderInteractiveForms: renderInteractiveForms,
        linkService: new SimpleLinkService(),
        // l10n: l10n
      });
    }
  }]);

  return DefaultAnnotationLayerFactory;
}();





var TEXT_LAYER_RENDER_DELAY = 200; // ms

var MAX_TEXT_DIVS_TO_RENDER = 100000;

var NonWhitespaceRegexp = /\S/;

{ /* Main */
    (function init(jQuery, window, document, undefined) {

        jQuery.fn.flipBook = function(options) {
            return new FLIPBOOK.Main(options, this);
        };

        jQuery.fn.swipeBook = function(options) {
            options.viewMode = "swipe"
            return new FLIPBOOK.Main(options, this);
        };

        // DEFAULT OPTIONS
        jQuery.fn.flipBook.options = {

            name: "",

            /*array of page objects - this must be passed to plugin constructor
            {
                src:"page url",
                thumb:"page thumb url",
                title:"page title",
                htmlContent:"page html content"
            }*/
            pages: [],

            /*array of table_of_content objects
            {
                title:"Cover",
                page:"1",
            }*/
            tableOfContent: [],

            tableOfContentCloseOnClick: true,
            thumbsCloseOnClick:true,

            deeplinkingEnabled: false,
            deeplinkingPrefix: '',

            assets: {
                preloader: "images/preloader.jpg",
                overlay: "images/overlay.png",
                flipMp3: "mp3/turnPage.mp3",
                spinner: "images/spinner.gif"
            },

            //pdf file
            pdfUrl: null,
            pdfBrowserViewerIfMobile: false,
            pdfBrowserViewerIfIE: false,
            pdfBrowserViewerFullscreen: true,
            pdfBrowserViewerFullscreenTarget: "_blank",
            pdfPageScale: 2,

            htmlLayer: true,

            rightToLeft: false,

            //page that will be displayed when the book starts
            startPage: 0,

            //if the sound is enabled
            sound: true,

            backgroundColor: "rgb(81, 85, 88)",
            backgroundImage: "",
            backgroundPattern: "",
            backgroundTransparent: false,

            //book default settings
            thumbSize: 130,
            thumbQuality: 1,

            loadAllPages: false,
            loadPagesF: 2,
            loadPagesB: 1,

            //menu buttons
            currentPage: {
                enabled: true,
                title: "Current page"
            },
            btnNext: {
                enabled: true,
                title: "Next page",
                icon: "fa-angle-right",
                icon2: "navigate_next"
            },
            btnLast: {
                enabled: false,
                title: "Last page",
                icon: "fa-angle-double-right",
                icon2: "last_page"
            },
            btnPrev: {
                enabled: true,
                title: "Previous page",
                icon: "fa-angle-left",
                icon2: "navigate_before"
            },
            btnFirst: {
                enabled: false,
                title: "First page",
                icon: "fa-angle-double-left",
                icon2: "first_page"
            },
            btnZoomIn: {
                enabled: false,
                title: "Zoom in",
                icon: "fa-plus",
                icon2: "zoom_in"
            },
            btnZoomOut: {
                enabled: false,
                title: "Zoom out",
                icon: "fa-minus",
                icon2: "zoom_out"
            },
            btnRotateLeft: {
                enabled: true,
                title: "Rotate left",
                icon: "fas fa-undo"
            },
            btnRotateRight: {
                enabled: true,
                title: "Rotate right",
                icon: "fas fa-redo"
            },
            btnToc: {
                enabled: false,
                title: "Table of content",
                icon: "fa-list-ol",
                icon2: "toc",
            },
            btnThumbs: {
                enabled: false,
                title: "Pages",
                icon: "fa-th-large",
                icon2: "view_comfy"
            },
            btnShare: {
                enabled: false,
                title: "Share",
                icon: "fa-link",
                icon2: "share",
            },
            btnDownloadPages: {
                enabled: false,
                title: "Download pages",
                icon: "fa-download",
                icon2: "file_download",
                url: "images/pages.zip",
                name: "allPages.zip",
            },
            btnDownloadPdf: {
                forceDownload: false,
                enabled: false,
                title: "Download PDF",
                icon: "fa-file",
                icon2: "picture_as_pdf",
                url: null,
                openInNewWindow: true,
                name: "allPages.pdf",
            },
            btnSound: {
                enabled: false,
                title: "Volume",
                icon: "fa-volume-up",
                iconAlt: "fa-volume-off",
                icon2: "volume_up",
            },
            btnExpand: {
                enabled: false,
                title: "Toggle fullscreen",
                icon: "fa-expand",
                icon2: "fullscreen",
                iconAlt: "fa-compress",
                iconAlt2: "fullscreen_exit"
            },
            btnSlideshow: {
                enabled: false,
                title: "Toggle slideshow",
                icon: "fa-play",
                iconAlt: "fa-pause"
            },
            btnPrint: {
                enabled: false,
                title: "Print",
                icon: "fa-print",
                icon2: "print",
            },

            btnAutoplay: {
                enabled: false,
                title: "Autoplay",
                icon: "fa-play",
                iconAlt:"fa-pause"
            },

            btnSearch: {
                enabled: false,
                title: "Search",
                icon: "fas fa-search",
                icon2: "search"

            },

            btnBookmark: {
                enabled: false,
                title: "Bookmark",
                icon: "fas fa-bookmark",
                icon2: "fas fa-bookmark"

            },

            btnSelect: {
                enabled: false,
                title: "Select tool",
                icon: "fas fa-i-cursor",

            },

            autoplayOnStart: false,
            autoplayInterval: 3000,

            btnTocIfMobile: true,
            btnThumbsIfMobile: true,
            btnShareIfMobile: false,
            btnDownloadPagesIfMobile: true,
            btnDownloadPdfIfMobile: true,
            btnSoundIfMobile: false,
            btnExpandIfMobile: true,
            btnPrintIfMobile: false,

            sideNavigationButtons: true,
            hideMenu: false,

            //share

            google_plus: {
                enabled: true,
                url: null
            },
            twitter: {
                enabled: true,
                url: null,
                description: null
            },
            facebook: {
                enabled: true,
                load_sdk: true,
                url: null,
                app_id: null,
                title: null,
                caption: null,
                description: null,
                image: null
            },
            pinterest: {
                enabled: true,
                url: null,
                image: null,
                description: null
            },
            email: {
                enabled: true,
                title: null,
                description: null
            },

            pdf: {
                annotationLayer: false,
            },

            pageTextureSize: 2048, 
            pageTextureSizeSmall: 1024,
            pageTextureSizeTreshold:1400, //

            //flip animation type; can be "2d", "3d" , "webgl", "swipe"
            viewMode: 'webgl',
            singlePageMode: false,
            singlePageModeIfMobile: false,
            zoomMin: .85,
            // zoomLevels:[.85,1,2,3,4,5],
            zoomSize: null,
            zoomStep: 2,
            zoomTime:0,

            wheelDisabledNotFullscreen: false,
            arrowsDisabledNotFullscreen: false,

            responsiveView: true,
            responsiveViewTreshold: 768,
            minPixelRatio: 1.5, //between 1 and 2, 1.5 = best ratio performance FPS / image quality

            skin: "light", //"dark", "light", "grey"

            pageFlipDuration: 1,

            contentOnStart: false,
            thumbnailsOnStart: false,
            sideMenuOverBook:true,

            //lightbox settings
            lightBox: false,
            lightBoxOpened: false,
            lightBoxFullscreen: false,
            lightboxCloseOnClick: false,
            lightboxResetOnOpen: true,
            lightboxBackground: null, //css of flipbook background, rgba or hexadecimal color or bg image, for example 'rgba(0,0,0,.5)' or '#F0F0F0' or 'url("overlay.png" ) repeat'
            lightboxStartPage: null,
            lightboxMarginV: '0',
            lightboxMarginH: '0',
            lightboxCSS: '',
            lightboxPreload:false,

            // WebGL settings

            disableImageResize:true, //disable image resize to power of 2 (needed for anisotropic filtering)

            pan: 0,
            panMax: 10,
            panMax2: 2,
            panMin: -10,
            panMin2: -2,
            tilt: 0,
            tiltMax: 0,
            tiltMax2: 0,
            tiltMin: -20,
            tiltMin2: -5,

            rotateCameraOnMouseMove: false,
            rotateCameraOnMouseDrag: true,

            lights: true,
            lightColor: 0xFFFFFF,
            lightPositionX: 0,
            lightPositionZ: 1400,
            lightPositionY: 350,
            lightIntensity: .6,

            shadows: true,
            shadowMapSize: 1024,
            shadowOpacity: .2,
            shadowDistance: 15,

            pageRoughness: 1,
            pageMetalness: 0,

            pageHardness: 2,
            coverHardness: 2,
            pageSegmentsW: 5,
            pageSegmentsH: 1,

            pageMiddleShadowSize: 2,
            pageMiddleShadowColorL: "#999999",
            pageMiddleShadowColorR: "#777777",

            antialias: false,


            //UI settings

            menuMargin: 0,
            menuPadding: 0,
            menuAlignHorizontal: 'center', //'right', 'left', 'center'
            // menuAlignVertical:'bottom', //'top' or 'bottom'
            menuShadow: '',
            menuBackground: '',
            menuOverBook: false,

            btnSize: 16,
            btnRadius: 4,
            btnMargin: 4,
            btnPaddingV: 10,
            btnPaddingH: 10,
            btnShadow: '',
            btnTextShadow: '',
            btnBorder: '',
            btnColor: '',
            btnColorHover: "",
            btnBackground: '',
            btnBackgroundHover: '',

            sideBtnSize: 30,
            sideBtnRadius: 0,
            sideBtnMargin: 0,
            sideBtnPaddingV: 5,
            sideBtnPaddingH: 5,
            sideBtnShadow: '',
            sideBtnTextShadow: '',
            sideBtnBorder: '',
            sideBtnColor: '#FFF',
            sideBtnBackground: 'rgba(0,0,0,.3)',


            currentPagePositionV: 'top', //'top' or 'bottom'
            currentPagePositionH: 'left', // 'left' or 'right'
            currentPageMarginV: 5, // margin vertical in px
            currentPageMarginH: 5, // margin horizontal in px

            closeBtnSize: 20,
            closeBtnRadius: 0,
            closeBtnMargin: 0,
            closeBtnPadding: 10,
            closeBtnTextShadow: '',
            closeBtnColor: '#FFF',
            closeBtnBackground: 'rgba(0,0,0,.3)',
            closeBtnBorder: '',

            preloaderText: '',

            fillPreloader: {
                enabled: false,
                imgEmpty: "images/logo_light.png",
                imgFull: "images/logo_dark.png",
            },

            logoImg: '', //url of logo image
            logoUrl: '', // url target 
            logoCSS: 'position:absolute;',
            logoHideOnMobile: false,

            printMenu: true,
            downloadMenu: true,

            backCover: true,

            textLayer: false,

            googleAnalyticsTrackingCode:null,

            // loadExtraPages:5,

            strings: {

                print: "Print",
                printLeftPage: "Print left page",
                printRightPage: "Print right page",
                printCurrentPage: "Print current page",
                printAllPages: "Print all pages",

                download: "Download",
                downloadLeftPage: "Download left page",
                downloadRightPage: "Download right page",
                downloadCurrentPage: "Download current page",
                downloadAllPages: "Download all pages",

                bookmarks: "Bookmarks",
                bookmarkLeftPage: "Bookmark left page",
                bookmarkRightPage: "Bookmark right page",
                bookmarkCurrentPage: "Bookmark current page",

                search: "Search",
                findInDocument: "Find in document",
                pagesFoundContaining: "pages found containing",

                thumbnails: "Thumbnails",
                tableOfContent: "Table of content",
                share: "Share",

                pressEscToClose:"Press ESC to close"


            },

            //mobile devices settings - override any setting for mobile devices
            mobile: {

            }

        };

        FLIPBOOK.Main = function(options, elem) {
            var self = this;
            this.elem = elem;
            this.$elem = jQuery(elem);
            this.$body = jQuery("body")
            this.body = this.$body[0]
            this.$window = jQuery(window)

            this.bodyHasVerticalScrollbar = function() {
                return self.body.scrollHeight > window.innerHeight
            }
            this.isZoomed = function() {
                return self.zoom > 1
            }
            // console.log(this.fullscreenFlipbook)
            this.options = {};

            var model = {

                _events: {},

                on: function(type, fn) {
                    if (!this._events[type]) {
                        this._events[type] = [];
                    }

                    this._events[type].push(fn);
                },

                off: function(type, fn) {
                    if (!this._events[type]) {
                        return;
                    }

                    var index = this._events[type].indexOf(fn);

                    if (index > -1) {
                        this._events[type].splice(index, 1);
                    }
                },

                trigger: function(type) {
                    if (!this._events[type]) {
                        return;
                    }

                    var i = 0,
                        l = this._events[type].length;

                    if (!l) {
                        return;
                    }

                    for (; i < l; i++) {
                        this._events[type][i].apply(this, [].slice.call(arguments, 1));
                    }
                },
            }
            this.model = model

            var dummyStyle = document.createElement('div').style,
                vendor = (function() {
                    var vendors = 't,webkitT,MozT,msT,OT'.split(','),
                        t,
                        i = 0,
                        l = vendors.length;

                    for (; i < l; i++) {
                        t = vendors[i] + 'ransform';
                        if (t in dummyStyle) {
                            return vendors[i].substr(0, vendors[i].length - 1);
                        }
                    }
                    return false;
                })(),
                prefixStyle = function(style) {
                    if (vendor === '')
                        return style;

                    style = style.charAt(0).toUpperCase() + style.substr(1);
                    return vendor + style;
                },

                isAndroid = (/android/gi).test(navigator.appVersion),
                isIDevice = (/iphone|ipad/gi).test(navigator.appVersion),
                has3d = prefixStyle('perspective') in dummyStyle

            this.msie = window.navigator.userAgent.indexOf("MSIE ");

            self.isAndroid = isAndroid;
            self.has3d = has3d;

            //detect webgl


            function webgl_detect(return_context) {
                if (!!window.WebGLRenderingContext) {
                    var canvas = document.createElement("canvas"),
                        names = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
                        context = false;

                    for (var i = 0; i < 4; i++) {
                        try {
                            context = canvas.getContext(names[i]);
                            if (context && typeof context.getParameter == "function") {
                                // WebGL is enabled
                                if (return_context) {
                                    // return WebGL object if the function's argument is present
                                    return {
                                        name: names[i],
                                        gl: context
                                    };
                                }
                                // else, return just true
                                return true;
                            }
                        } catch (e) {}
                    }

                    // WebGL is supported, but disabled
                    //return true;
                    return false;
                }

                // WebGL not supported
                return false;
            }

            function getInternetExplorerVersion()
            {
              var rv = -1;
              if (navigator.appName == 'Microsoft Internet Explorer')
              {
                var ua = navigator.userAgent;
                var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                  rv = parseFloat( RegExp.$1 );
              }
              else if (navigator.appName == 'Netscape')
              {
                var ua = navigator.userAgent;
                var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                  rv = parseFloat( RegExp.$1 );
              }
              return rv;
            }

            self.hasWebGl = webgl_detect()

            var IEversion = getInternetExplorerVersion()
            if (IEversion > 0){
                self.hasWebGl = false
                self.options.isIE = true
            }

            self.thumbsShowing = false
            self.tocShowing = false
            self.menuShowing = true
            self.fullscreenActive = false

            self.model.on("toolSelect", function() {

                self.bookLayer.removeClass("flipbook-move")
                if(self.btnSelect)
                    self.btnSelect.addClass("flipbook-btn-active")

            })

            self.model.on("toolMove", function() {

                self.bookLayer.addClass("flipbook-move")
                if(self.btnSelect)
                    self.btnSelect.removeClass("flipbook-btn-active")

            })

            //default options are overridden by options object passed to plugin constructor
            self.options = jQuery.extend({}, jQuery.fn.flipBook.options, options);

            self.options.isMobile = jQuery.browser.mobile || isIDevice || isAndroid

            if (self.options.isMobile) {

                for (var key in self.options.mobile) {
                    self.options[key] = self.options.mobile[key]
                }

                // self.options.pageTextureSize = 1024

            }

            this.strings = this.options.strings

            self.options.pageShininess = self.options.pageShininess / 2;

            self.s = 0;

            if(this.options.googleAnalyticsTrackingCode){
                this.gaCode = this.options.googleAnalyticsTrackingCode
                if(!window.ga){
                    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
                }

                ga('create', this.gaCode, 'auto');
            }

            jQuery('head').append("<meta content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' name='viewport' />");



            if (self.options.isMobile) {

                self.options.singlePageMode = self.options.singlePageModeIfMobile ? true : self.options.singlePageMode

                if (self.options.viewModeMobile)
                    self.options.viewMode = self.options.viewModeMobile

                if (self.options.pageTextureSizeMobile)
                    self.options.pageTextureSize = self.options.pageTextureSizeMobile
            }

            if (self.options.viewMode == "3dSinglePage") {
                self.options.singlePageMode = true
            }
            if (self.options.viewMode == "2dSinglePage") {
                self.options.singlePageMode = true
                self.options.viewMode = "2d"
            }

            if (self.options.singlePageMode) {
                if (self.options.viewMode != '2d' 
                && self.options.viewMode != 'swipe'
                ) self.options.viewMode = '3d'
            }

            if (this.options.singlePageMode && self.options.viewMode == "3d")
                self.options.rightToLeft = false

            if(self.options.viewMode == "simple"){
                self.options.viewMode = "3d"
                self.options.instantFlip = true
            }

            function getAndroidVersion(ua) {
                ua = (ua || navigator.userAgent).toLowerCase();
                var match = ua.match(/android\s([0-9\.]*)/);
                return match ? match[1] : false;
            };

            if (self.options.viewMode == 'webgl') {
                if (!self.hasWebGl || ((parseFloat(getAndroidVersion()) < 4.4) && self.isAndroid))
                    self.options.viewMode = '3d'
            }
            if (self.options.viewMode == '3d' && !self.has3d)
                self.options.viewMode = '2d'

            self.webgl = self.options.viewMode == 'webgl'

            if (self.options.isMobile && options.pdfBrowserViewerIfMobile && self.options.pdfUrl) {

                // if( options.pdfBrowserViewerIfMobile && options.pdfUrl){  // TEST mobile = true

                if (self.options.lightBox && !self.options.lightBoxOpened) {
                    self.$elem.on("touched click", function() {
                        openPdfBrowserViewer()
                    }).css('cursor', 'pointer')
                } else {
                    openPdfBrowserViewer()
                }
                return;
            }

            if (self.options.isIE && options.pdfBrowserViewerIfIE && self.options.pdfUrl) {

                // if( options.pdfBrowserViewerIfMobile && options.pdfUrl){  // TEST mobile = true

                if (self.options.lightBox && !self.options.lightBoxOpened) {
                    self.$elem.on("touched click", function() {
                        openPdfBrowserViewer()
                    }).css('cursor', 'pointer')
                } else {
                    openPdfBrowserViewer()
                }
                return;
            }

            function openPdfBrowserViewer() {
                if (self.options.pdfBrowserViewerFullscreen) {
                    window.open(self.options.pdfUrl, self.options.pdfBrowserViewerFullscreenTarget)
                } else {
                    jQuery('<object type="application/pdf"/>').width("100%").height("100%").attr('data', self.options.pdfUrl).appendTo(self.$elem)
                    //<div> <object data="test.pdf" type="application/pdf" width="300" height="200"> alt : <a href="test.pdf">test.pdf</a> </object> </div>
                }
            }

            self.options.pdfMode = Boolean(self.options.pdfUrl && self.options.pdfUrl != "")

            var zl = self.options.zoomLevels
            if (zl) {
                if (typeof zl == 'string')
                    zl = zl.split(',')

                for (i = 0; i < zl.length; i++) {
                    zl[i] = Number(zl[i])
                }

                self.options.zoomLevels = zl;
                self.options.zoomMin = zl[0]
            }

            if (self.options.backgroundTransparent)
                self.options.backgroundColor = 'none'

            if (!self.options.deeplinking)
                self.options.deeplinking = {
                    enabled: self.options.deeplinkingEnabled,
                    prefix: self.options.deeplinkingPrefix
                }


            // self.onZoom(self.options.zoom)
            self.wrapper = jQuery(document.createElement('div'))
                .addClass('flipbook-main-wrapper')
            // .hide()

            if (self.options.backgroundColor != "")
                self.wrapper.css('background', self.options.backgroundColor);

            if (self.options.backgroundPattern != "")
                self.wrapper.css('background', 'url(' + self.options.backgroundPattern + ') repeat');

            if (self.options.backgroundImage != "") {
                self.wrapper.css('background', 'url(' + self.options.backgroundImage + ') no-repeat');
                self.wrapper.css('background-size', 'cover')
            }

            self.bookLayer = jQuery(document.createElement('div'))
                .addClass('flipbook-bookLayer')
                .appendTo(self.wrapper)

            /* self.zoomLayer = jQuery(document.createElement('div id="flipbook-zoomLayerWrapper"><div id="flipbook-zoomLayerScroller"></div></div>'))
                 .appendTo(self.wrapper)*/

            if (self.options.hideMenu){
                self.bookLayer.css('bottom', '0')
                self.options.menuOverBook = true
            }

            self.book = jQuery(document.createElement('div'))
                .addClass('book')
                .appendTo(self.bookLayer);

            //preloader
            // this.options.preloader = jQuery('<div class="cssload-container">'+
            //     '<i class="fa fa-spinner fa-spin" style="position:absolute;top:50%;margin-top:-20px;font-size:40px;color:rgba(255,255,255,1);opacity:.5;"></i>'+
            //     '<i class="fa fa-spinner fa-spin" style="position:absolute;top:50%;margin-top:-20px;font-size:40px;color:rgba(0,0,0,1);opacity:.5;"></i>'+
            //     '</div>')
            if (this.options.preloader)
                this.preloader = this.options.preloader
            else
                this.preloader = jQuery('<div class="cssload-container"><div class="cssload-speeding-wheel"/><div class="flipbook-loading-text">' + this.options.preloaderText + '</div><div class="flipbook-loading-bg"></div></div>')

            this.setLoadingProgress(0);


            //start page
            if (self.options.deeplinking.enabled) {

                if (typeof self.options.deeplinking.prefix == 'undefined')
                    self.options.deeplinking.prefix = ""

                jQuery(window).bind('hashchange', function(e) {
                    if (self.Book && self.Book.enabled) {
                        var targetPage = self.getPageFromHash()
                        targetPage = self.options.rightToLeft ? self.options.pages.length - targetPage + 1 : targetPage
                   //     if (self.options.singlePageMode) targetPage--;
                        if (targetPage >= 0) self.Book.goToPage(targetPage, true);
                    }
                })
                if (this.options.startPage <= 2) {
                    var p = this.getPageFromHash()
                    if (p > 1) this.options.lightBoxOpened = true
                    this.options.startPage = p
                }
            }

            // out - caused a bug in singlePageMode
            //this.options.startPage = this.options.singlePageMode ? this.options.startPage - 1 : this.options.startPage

            function preload(){
                if (typeof IScroll == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.iscrollSrc]) {
                    self.loadScript(FLIPBOOK.iscrollSrc, function() {})
                    }
                if(self.options.pdfMode){
                    if (typeof PDFJS == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.pdfjsSrc]) {
                    self.loadScript(FLIPBOOK.pdfjsSrc, function() {})
                    }
                    // if (!FLIPBOOK.scriptsAdded[FLIPBOOK.pdfjsworkerSrc]) {
                    //     self.loadScript(FLIPBOOK.pdfjsworkerSrc, function() {})
                    // }
                    if (typeof FLIPBOOK.PdfService == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.pdfServiceSrc]) {
                        self.loadScript(FLIPBOOK.pdfServiceSrc, function() {})
                    }

                    if (self.options.btnSearch.enabled){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.markSrc]) {
                            self.loadScript(FLIPBOOK.markSrc, function(){})
                        }
                    }


                }
                if(self.options.viewMode == "webgl"){
                    if (typeof THREE == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.threejsSrc]) {
                    self.loadScript(FLIPBOOK.threejsSrc, function() {})
                    }
                    // if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipbookWebGlSrc]) {
                    // self.loadScript(FLIPBOOK.flipbookWebGlSrc, function() {})
                    // }
                }
                
            }

            function init() {


                if (self.options.fillPreloader.enabled) {

                    self.$fillPreloader = jQuery("<div>").addClass("flipbook-fillPreloader")
                    var empty = new Image()
                    empty.src = self.options.fillPreloader.imgEmpty
                    empty.onload = function() {
                        var full = new Image()
                        full.src = self.options.fillPreloader.imgFull
                        full.onload = function() {
                            //fill preloder ready

                            jQuery(empty).appendTo(self.$fillPreloader)
                            self.$fillPreloaderImg = jQuery(full).appendTo(self.$fillPreloader)

                            self.$fillPreloader.appendTo(self.wrapper)

                            initBook()

                        }

                    }

                } else {

                    initBook()

                }


            }

            function initBook() {

                if (self.options.pdfMode) {
                    self.initPdf(self.options.btnSearch.enabled)
                }
                else {
                    self.options.btnSearch.enabled = false
                    self.initJpg()
                }

                self.setLoadingProgress(.1)

            }

            

            this.options.main = this

            if (this.options.lightBox) {

                this.lightbox = new FLIPBOOK.Lightbox(this, this.wrapper, this.options);
                this.lightboxStartedTimes = 0
                this.wrapper.css('background', 'none');
                this.bookLayer.css('background', 'none');
                this.book.css('background', 'none');

                this.preloader.appendTo(this.$body).css('position', 'fixed');


                this.$elem.css('cursor', 'pointer')

                    .bind('tap click', function(e) {

                        self.lightboxStartPage = jQuery(this).attr("data-page")

                        if (self.started) {

                            self.lightboxStart()

                            if (self.options.lightBoxFullscreen) {

                                setTimeout(function() {
                                    self.toggleExpand()
                                }, 0)

                            }

                        } else {

                            init()

                            if (self.options.lightBoxFullscreen) {

                                setTimeout(function() {
                                    self.toggleExpand()
                                }, 100)

                            }

                        }

                    });

                if (this.options.lightBoxOpened) {
                    init()
                    jQuery(this).trigger('lightboxLoadingStarted')
                }else if(this.options.lightboxPreload){
                    preload()
                }

                this.fullscreenElement = document.documentElement

            } else {

                this.preloader.appendTo(this.wrapper);

                this.wrapper.appendTo(this.$elem);

                this.fullscreenElement = this.$elem[0]

                init()

            }
        };

        FLIPBOOK.Main.prototype = {

            start: function() {

                if (this.options.dp) {
                    this.options.doublePage = true
                    this.options.pageMode = 'doubleWithCover'
                }

                if (this.started)
                    return;

                this.model.pageW = this.options.pageWidth
                this.model.bookW = 2 * this.options.pageWidth
                this.model.pageH = this.options.pageHeight
                this.model.bookH = this.options.pageHeight

                // if (this.options.numPages == 1) {
                //     this.options.viewMode = "3d"
                //     this.webgl = false
                // }

                if (this.options.numPages % 2 == 0) {
                    this.options.numSheets = (this.options.numPages + 2) / 2
                } else {
                    this.options.numSheets = (this.options.numPages + 1) / 2
                }

                // if(!this.options.backCover)
                //     this.options.numSheets++;

                this.started = true;

                if (this.options.lightBox) {
                    this.lightbox.openLightbox();
                    this.lightboxStart()

                }

                this.createBook();


            },

            lightboxStart: function() {

                var self = this;
                if (!this.started) this.start();

                if (typeof this.Book == 'undefined') {

                    setTimeout(function() {
                        self.lightboxStart()
                    }, 100);
                    return;

                }

                this.Book.enable();

                if (this.options.contentOnStart) this.toggleToc(true);

                if (this.options.thumbnailsOnStart) this.toggleThumbs(true);

                if(this.lightboxStartPage) this.Book.goToPage(this.lightboxStartPage, true);

                else if(this.options.lightboxStartPage) this.Book.goToPage(this.options.lightboxStartPage, true);

                this.lightboxStartedTimes ++

                if(this.gaCode){
                    ga('send', {
                       hitType: 'event',
                       eventCategory: 'Flipbook : '+this.options.name,
                       eventAction: 'lightbox open' ,
                       eventLabel: 'lightbox open',
                       eventValue: this.lightboxStartedTimes,
                       nonInteraction: true
                   });
                }

               // if (this.options.lightboxResetOnOpen && this.options.viewMode != "webgl") this.Book.goToPage(1, true)

                this.updateCurrentPage();
                this.initColors();
                this.resize();

                jQuery(this).trigger('lightboxOpened')

            },

            setHash: function(page) {

                if (page < 1) page = 1

                if (this.options.deeplinking.enabled && this.Book.enabled)
                    window.location.hash = "#" + this.options.deeplinking.prefix + String(page)

            },

            clearHash: function() {

                if (this.options.deeplinking.enabled)
                    window.location.hash = "";

            },

            getPageFromHash: function() {

                var res = parseInt(window.location.hash.replace(/#/g, '').replace(this.options.deeplinking.prefix, ""))
                if (isNaN(res)) res = 0;
                return res;
            },

            initColors: function() {

                this.wrapper.find(".skin-color-bg")
                    .removeClass("flipbook-bg-light")
                    .removeClass("flipbook-bg-dark")
                    .addClass("flipbook-bg-" + this.options.skin);

                this.wrapper.find(".skin-color")
                    .removeClass("flipbook-color-light")
                    .removeClass("flipbook-color-dark")
                    .addClass("flipbook-color-" + this.options.skin);
            },

            lightboxEnd: function() {

                if(screenfull.isFullscreen)

                    screenfull.exit();

                if (window.location.hash) {
                    // var urlWithoutHash = document.location.href.replace(location.hash , "" );
                    this.clearHash()
                }

                this.setLoadingProgress(1)

                this.Book.disable();

            },

            turnPageComplete: function() {

                this.animating = false;
                this.updateCurrentPage();

                //autoplay
                var rightIndex = this.Book.rightIndex || 0;
                /* if ((rightIndex > this.options.pages.length - 1) && this.autoplay) {
                     this.toggleAutoplay(false)
                 }*/

                if (this.options.rightToLeft)
                    rightIndex = this.options.pages.length - rightIndex
                if (this.pdfService)
                    this.pdfService.setRightIndex(rightIndex)

            },

            updateCurrentPage: function() {

                if (typeof this.currentPage === 'undefined')
                    return;

                var rtl = this.options.rightToLeft,
                total = this.options.numPages,
                rightIndex = this.Book.rightIndex || 0,
                s

                if (rtl) rightIndex = this.options.pages.length - rightIndex;

                if (this.options.singlePageMode || this.Book.singlePage) {

                    s = rightIndex + 1

                    this.currentPageNumber = rightIndex
                    this.setHash(rightIndex + 1)

                    this.cPage = [rightIndex]

                    
                }else{

                    if (rightIndex > total || (rightIndex == total && total % 2 == 0)) {
                        s = total
                        this.cPage = [total - 1]
                    } else if (rightIndex < 1) {
                        s = 1
                        this.cPage = [0]
                    } else {
                        s = String(rightIndex) + '-' + String(rightIndex + 1)
                        this.cPage = [rightIndex - 1, rightIndex]
                    }

                    this.setHash(rightIndex)

                }

                if(rtl){

                    this.enableNext(rightIndex > 0)
                    this.enablePrev(rightIndex < total - 1)

                }else{

                    this.enablePrev(rightIndex > 0)
                    this.enableNext(rightIndex < total - 1)
                }

                if (this.cPage.length == 2) {

                    this.wrapper.find(".c-l-p").show()
                    this.wrapper.find(".c-r-p").show()
                    this.wrapper.find(".c-p").hide()

                } else {

                    this.wrapper.find(".c-l-p").hide()
                    this.wrapper.find(".c-r-p").hide()
                    this.wrapper.find(".c-p").show()

                }

                this.s && this.options.pdfPageScale > 0 && this.Book.goToPage(0)


                if (s != this.currentPageValue){

                    this.currentPageValue = String(s)
                    this.currentPage.text(s + ' / ' + String(total))

                    // console.log(this.currentPageValue)

                    jQuery(this).trigger({
                        type: "pagechange",
                        page: this.currentPageValue,
                        name: this.options.name
                    });

                }


            },

            initJpg: function() {

                var self = this

                if (this.options.numPages == 1) {
                    this.options.viewMode = "swipe"
                    this.options.singlePageMode = true
                    this.webgl = false
                }

                this.loadPage(0, this.options.pageTextureSize, function() {

                    self.setLoadingProgress(.5)

                    try {

                        if(self.options.pages.length == 1){

                            var p1 = self.options.pages[0].img
    
                            self.options.pw = p1.width
                            self.options.ph = p1.height
    
                            self.options.pageWidth = p1.width
                            self.options.pageHeight = p1.height
    
                            self.options.pageMode = 'singlePage'
    
                            self.options.doublePage = false
    
                            self.options.zoomSize = self.options.zoomSize || p1.height
    
                            self.setLoadingProgress(.7)
    
                            self.start();
    
                        }else
                            self.loadPage(1, self.options.pageTextureSize, function() {
    
                                        var p1 = self.options.pages[0].img
                                        var p2 = self.options.pages[1].img
                                        var r1 = p1.width / p1.height
                                        var r2 = p2.width / p2.height
    
                                        self.options.pw = p1.width
                                        self.options.ph = p1.height
    
                                        self.options.pageWidth = p1.width
                                        self.options.pageHeight = p1.height
    
                                        self.options.pageMode = (r2 / r1 > 1.5) ? 'doubleWithCover' : 'singlePage'
    
                                        self.options.doublePage = (r2 / r1 > 1.5)
    
                                        self.options.zoomSize = self.options.zoomSize || p1.height
    
                                        self.setLoadingProgress(.7)
    
                                        self.start();
    
                            })
                    } catch(e) {
                        self.start();
                    }
                })

            },

            initPdf: function(loadAllPages) {

                if (this.started) return;

                if (this.options.viewMode == "swipe" || this.options.btnSearch.enabled)
                    this.options.textLayer = true

                var self = this;

                if(typeof PDFJS == 'undefined'){
                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.pdfjsSrc]) {
                        self.loadScript(FLIPBOOK.pdfjsSrc, function() {
                            self.initPdf(loadAllPages)
                        })
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.pdfjsSrc]) {
                        setTimeout(function(){
                            self.initPdf(loadAllPages)
                        },100)
                        return;
                    }
                }

                this.setLoadingProgress(.2)

                if(typeof FLIPBOOK.PdfService == 'undefined'){
                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.pdfServiceSrc]) {
                        self.loadScript(FLIPBOOK.pdfServiceSrc, function() {
                            self.initPdf(loadAllPages)
                        })
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.pdfServiceSrc]) {
                        setTimeout(function(){
                            self.initPdf(loadAllPages)
                        },100)
                        return;
                    }

                }

                this.setLoadingProgress(.3)

                //fix for IE10
                if(window.CanvasPixelArray) {
                    CanvasPixelArray.prototype.set = function(arr) {
                        var l=this.length, i=0;

                        for(;i<l;i++) {
                            this[i] = arr[i];
                        }
                    };
                }

                var PDFJS = pdfjsLib

                //PDFJS.disableWorker = this.options.disableWorker || false;
                PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK
                PDFJS.GlobalWorkerOptions.workerSrc = this.options.pdfjsworkerSrc || FLIPBOOK.pdfjsworkerSrc
                // PDFJS.disableAutoFetch = true;

                // PDFJS.disableStream = true;

                // PDFJS.cMapUrl = 'cmaps/';
                // PDFJS.cMapPacked = true;

                //match page protocol
                if(location.protocol == "https:"){
                    self.options.pdfUrl = self.options.pdfUrl.replace("http://","https://")
                }

                var params = {
                    cMapPacked: true,
                    cMapUrl: "cmaps/",
                    // disableAutoFetch: false,
                    // disableCreateObjectURL: false,
                    // disableFontFace: false,
                    // disableRange: false,
                    disableAutoFetch: true,
                    disableStream: true,
                    // isEvalSupported: true,
                    // maxImageSize: -1,
                    // pdfBug: false,
                    // postMessageTransfers: true,
                    url: self.options.pdfUrl,
                    // verbosity: 1
                }

                PDFJS.getDocument(
                    params
                ).then(function(pdf) {
                    self.pdfDocument = pdf

                    var numPages = pdf._pdfInfo.numPages
                    if (numPages == 1) {
                        self.options.viewMode = "swipe"
                        self.options.singlePageMode = true
                        self.webgl = false
                    }

                    self.pdfService = new FLIPBOOK.PdfService(pdf, self.model, self.options)

                    self.pdfService.on('pageLoaded', function(e){

                       // console.log("page loaded")
                       // console.log(self.options.name)
                       // console.log(e.index)

                        self.options.pages[e.index] = self.options.pages[e.index] || {}
                        self.options.pages[e.index].canvas = self.options.pages[e.index].canvas || {}
                        self.options.pages[e.index].canvas[e.size] = e.canvas

                        if (self.Book && self.Book.onPageLoaded)
                            self.Book.onPageLoaded(e.index, e.size)

                        if (self.searchingString)
                            self.mark(self.searchingString)

                    })

                    self.pdfService.on('pageUnloaded', function(e){

                        e.unloadedPages.forEach(function(elem) {
                            if (self.Book.onPageUnloaded)
                                self.Book.onPageUnloaded(elem.index, elem.size)
                        })

                    })

                    self.options.thumbLoaded = function(c) {
                        self.options.thumbs = self.options.thumbs || []
                        self.options.thumbs[c.index] = c
                    }

                    self.setLoadingProgress(.5)

                    var loadPdfOutline = !self.options.tableOfContent || self.options.tableOfContent.length == 0

                    var e = e

                    self.pdfService.on('init', function(){
                        
                        self.options.tableOfContent = this.outline || self.options.tableOfContent 

                        self.options.pageMode = this.double ? 'doubleWithCover' : 'singlePage'
                        self.options.doublePage = this.double

                        self.viewportOriginal = this.viewports[0]

                        self.options.firstPage = {
                            width: this.viewports[0].width,
                            height: this.viewports[0].height,
                            ratio: this.viewports[0].width / this.viewports[0].height
                        }

                        if (pdf._pdfInfo.numPages > 1)
                            self.options.secondPage = {
                                width: this.viewports[1].width,
                                height: this.viewports[1].height,
                                ratio: this.viewports[1].width / this.viewports[1].height
                            }

                        self.options.numPages = pdf._pdfInfo.numPages;

                        // if (this.backCover)
                        //     self.options.numPages--;

                        var pages = []

                        for (var i = 0; i < self.options.numPages; i++) {

                            var p = {
                                canvas: {}
                            }

                            if (self.options.pages && self.options.pages[i]) {
                                jQuery.extend(p, self.options.pages[i])
                            } else {
                                p.title = i + 1
                            }

                            pages[i] = p
                        }

                        self.options.pages = pages

                        var bh = self.book.height()
                        //var pageSize = 1000
                        var pageSize = self.options.pageTextureSize
                        self.options.pageWidth = parseInt(pageSize * self.viewportOriginal.width / self.viewportOriginal.height);
                        self.options.pageHeight = pageSize;

                        self.options.pw = self.options.pageWidth
                        self.options.ph = self.options.pageHeight

                        self.options.zoomSize = self.options.zoomSize || self.options.pageTextureSize

                        self.start()

                    })

                    self.pdfService.init(function() { }, loadPdfOutline) 
                });
            },

            loadPage: function(index, size, callback) {

                var self = this

                if (this.options.pdfMode) {

                    this.loadPageFromPdf(index, size, callback)
                    // this.loadPageFromPdf(index, size, function(){
                    //     self.pageLoaded({index:index, size:size, canvas:self.options.pages[index].canvas[size]}, callback)
                    // })

                } else {

                    var self = this, page = this.options.pages[index]

                    if(page) {

                        if (!page.img) {
     
                            page.img = document.createElement('img')
                            // console.log('loading page ' + index)
                            page.img.setAttribute("id", index);
    
                            page.img.onload = function() {
    
                                page.imgLoaded = true
    
                                if(page.htmlContent){
                                            page.htmlContentDiv = jQuery(document.createElement('div'))
                                            .addClass('flipbook-page-htmlContent')
                                            .append(jQuery(page.htmlContent))
                                }
    
                                self.pageLoaded({ index: index, size: size, image: page.img, htmlContent: page.htmlContentDiv }, callback)
    
                            }
    
                            // crossOrigin is used only for mode webgl
                            if(this.options.viewMode == "webgl")
                                page.img.crossOrigin = 'Anonymous'
    
                            if(location.protocol == "https:"){
                                page.src = page.src.replace("http://","https://")
                            }
    
                            page.img.src = page.src
    
                        } else if (page.imgLoaded) {
    
                            self.pageLoaded({ index: index, size: size, image: page.img, htmlContent: page.htmlContentDiv }, callback)
                        
                        } else {
                            setTimeout(function() {
                                self.loadPage(index, size, callback)
                            }, 300)
                        }
                    } else {
                        
                        self.pageLoaded({ index: index, size: size, image: null, htmlContent: null }, callback)

                    }

                }

            },

            pageLoaded: function(page, callback) {

                // console.log("page loaded : ",page.index)

                // jQuery(this).trigger("pageLoaded", index, 1);

                callback.call(this, page, callback)

                if (this.options.loadAllPages && page.index < (this.options.numPages - 1)) {


                    // console.log("....load : ", page.index + 1)

                    this.loadPage(page.index + 1, page.size, function() {})
                }



            },

            loadPageFromPdf: function(pageIndex, size, callback) {

                var self = this;
                // var pdf = self.pdfDocument;
                var pdfPageIndex = self.options.doublePage ? Math.round(pageIndex / 2) : pageIndex
                size = size || this.options.pageTextureSize

                /* if (pdfPageIndex >= pdf.pdfInfo.numPages) {
                     //callback.call(self)
                     return;
                 }*/
                if (!self.options.pages[pageIndex]) {
                    callback.call(self)
                } else {
                    self.pdfService.renderPageFromPdf(pdfPageIndex, size, callback)
                }

            },

            loadThumbsFromPdf: function(arr) {

                var self = this,
                    pdf = self.pdfDocument,
                    info = pdf._pdfInfo,
                    numPages = info.numPages

                for (var i = 0; i < numPages; i++) {


                    var c = document.createElement('canvas');
                    arr[i].thumbCanvas = c

                }

                this.loadThumbFromPdf(0, arr)

            },

            loadThumbFromPdf: function(i, arr) {

                var self = this



                this.pdfDocument.getPage(i + 1).then(function(page) {

                    var v = page.getViewport(1)

                    var scale = self.options.thumbQuality * self.options.thumbSize / v.height

                    var viewport = page.getViewport(scale);

                    var c = arr[page.pageIndex].thumbCanvas
                    var context = c.getContext('2d');
                    c.height = viewport.height;
                    c.width = viewport.width;

                    var renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    page.cleanupAfterRender = true
                    page.render(renderContext).then(function() {
                        page.cleanup()
                        if ((page.pageIndex + 1) < self.pdfDocument._pdfInfo.numPages)
                            self.loadThumbFromPdf(page.pageIndex + 1, arr)

                    })
                    self.thumbScroll.refresh()

                });
            },

            getString:function(name){
                return this.options.strings[name]
            },

            findInDocument: function(str) {

                this.hideAllThumbs()
                this.$findInfo.hide()
                this.pagesFound = 0

                this.$findInfo.show().text('0 ' + this.strings.pagesFoundContaining + ' "' + str + '"')

                if (this.pdfService) {
                    for (var i = 0; i < this.pdfService.pdfInfo.numPages; i++) {
                        this.findInPage(str, i)
                    }
                }


                this.mark(str)

                this.searchingString = str

            },

            findInPage: function(str, index) {



                var self = this
                this.pdfService.findInPage(str, index, function(matches) {
                    if (matches > 0) {
                        self.showThumb(index)
                        self.pagesFound++;
                        self.$findInfo.show().text(self.pagesFound + ' ' + self.strings.pagesFoundContaining + ' "' + str + '"')

                    }

                })

            },

            mark: function(str) {

                for (var i = 0; i < this.options.pages.length; i++) {

                    var p = this.options.pages[i]
                    var c = p.htmlContent

                    jQuery(c).unmark({
                        done: function() {
                            jQuery(c).mark(str);
                        }
                    })
                }

            },

            unmark: function() {

                this.searchingString = null

                for (var i = 0; i < this.options.pages.length; i++) {

                    var p = this.options.pages[i]
                    var c = p.htmlContent

                    jQuery(c).unmark({})
                }

            },

            setTool: function(tool) {

                this.tool = tool
                this.model.trigger(tool)

            },

            toggleTool: function() {

                var tool = this.tool == "toolSelect" ? "toolMove" : "toolSelect"
                this.setTool(tool)

            },

            scrollPageIntoView: function(obj) {

                var num = this.options.rightToLeft ? this.options.pages.length - obj.pageNumber + 1 : obj.pageNumber

                this.Book.goToPage(num)

            },

            goToPage: function(pageNumber, instant) {

                if(this.Book)
                    this.Book.goToPage(pageNumber, instant)

            },

            loadScript: function(src, callback) {

                var self = this
                var script = document.createElement('script');
                var prior = document.getElementsByTagName('script')[0];
                script.async = 1;
                prior.parentNode.insertBefore(script, prior);

                FLIPBOOK.scriptsAdded[src] = true;

                script.onload = script.onreadystatechange = function(_, isAbort) {
                    if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                        script.onload = script.onreadystatechange = null;
                        script = undefined;

                        if (!isAbort) {
                            if (callback) callback.call(self);
                        }
                        FLIPBOOK.scriptsLoaded[src] = true;
                    }
                };

                script.src = src;

            },

            createBook: function() {

                var self = this,
                    model = this.model,
                    options = this.options;


                if(typeof IScroll == 'undefined'){

                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.iscrollSrc]) {
                        self.loadScript(FLIPBOOK.iscrollSrc, self.createBook)
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.iscrollSrc]) {
                        setTimeout(function(){
                            self.createBook()
                        },100)
                        return
                    }
                }

                if (this.options.btnSearch.enabled){

                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.markSrc]) {
                        self.loadScript(FLIPBOOK.markSrc, self.createBook)
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.markSrc]) {
                        setTimeout(function(){
                            self.createBook()
                        },100)
                        return
                    }

                }

                self.setLoadingProgress(.9)

                if (self.options.viewMode == "webgl") {

                    if(typeof THREE == 'undefined'){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.threejsSrc]) {
                            self.loadScript(FLIPBOOK.threejsSrc, self.createBook)
                            return;
                        }

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.threejsSrc]) {
                            setTimeout(function(){
                                self.createBook()
                            },100)
                            return
                        }
                    }

                    if(typeof FLIPBOOK.BookWebGL == 'undefined'){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipbookWebGlSrc]) {
                            self.loadScript(FLIPBOOK.flipbookWebGlSrc, self.createBook)
                            return;
                        }

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.flipbookWebGlSrc]) {
                            setTimeout(function(){
                                self.createBook()
                            },100)
                            return
                        }

                    }

                } else if (self.options.viewMode == "swipe") {

                    if(typeof FLIPBOOK.BookSwipe == 'undefined'){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipBookSwipeSrc]) {
                            self.loadScript(FLIPBOOK.flipBookSwipeSrc, self.createBook)
                            return;
                        }

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.flipBookSwipeSrc]) {
                            setTimeout(function(){
                                self.createBook()
                            },100)
                            return
                        }

                    }

                } else {

                    if(typeof FLIPBOOK.Book3 == 'undefined'){

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.flipbookBook3Src]) {
                            self.loadScript(FLIPBOOK.flipbookBook3Src, self.createBook)
                            return;
                        }

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipbookBook3Src]) {
                            setTimeout(function(){
                                self.createBook()
                            },100)
                            return
                        }

                    }

                    

                }

                this.setLoadingProgress(1)

                this.initEasing()

                if ( /*!self.options.pdfMode && */ self.options.pageMode == "doubleWithCover" && self.options.pages.length > 2) {
                    var newArr = [self.options.pages[0]]
                    for (var i = 1; i <= self.options.pages.length - 2; i++) {
                        var p = self.options.pages[i]
                        var left = {
                            src: p.src,
                            thumb: p.thumb,
                            title: p.title,
                            htmlContent: p.htmlContent,
                            side: 'left'
                        }
                        var right = {
                            src: p.src,
                            thumb: p.thumb,
                            title: p.title,
                            htmlContent: p.htmlContent,
                            side: 'right'
                        }

                        newArr.push(left)
                        newArr.push(right)

                    }
                    newArr.push(self.options.pages[self.options.pages.length - 1])
                    self.options.pages = newArr
                }

                this.options.numPages = this.options.pages.length
                if (this.options.numPages % 2 != 0 && !this.options.singlePageMode  /*&& this.options.viewMode != 'swipe' */) {
                    this.oddPages = true
                    this.options.oddPages = true
                    //because of RTL - pages array needs to have even number of pages
                    this.options.pages.push({
                        src: this.options.assets.preloader,
                        thumb: ''
                    })
                }

                if (self.options.pages.length > 0) {
                    for (var i = 0; i < self.options.pages.length; i++) {
                        if (typeof(self.options.pages[i].htmlContent) != 'undefined') {
                            // self.options.viewMode = '3d'
                            self.options.hasHtmlContent = true
                            self.options.pages[i].htmlContent = jQuery(self.options.pages[i].htmlContent)
                        }
                    }
                }

                function initSound() {

                    self.flipsound = document.createElement('audio');
                    self.flipsound.setAttribute('src', self.options.assets.flipMp3);
                    self.flipsound.setAttribute('type', 'audio/mpeg')


                }

                if (self.options.viewMode == "webgl") {

                    var bookOptions = self.options;
                    // bookOptions.pagesArr = self.options.pages;
                    bookOptions.scroll = self.scroll;
                    bookOptions.parent = self;
                    self.Book = new FLIPBOOK.BookWebGL(self.book[0], model, bookOptions);
                    self.webglMode = true;

                    self.initSwipe();
                    initSound()


                } else if (self.options.viewMode == "swipe") {

                    self.Book = new FLIPBOOK.BookSwipe(self.book[0], self.bookLayer[0], model, options);

                    self.initSwipe();

                } else {

                    if (self.options.viewMode != "2d")
                        self.options.viewMode = "3d"

                    self.Book = new FLIPBOOK.Book3(self.book[0], model, options);

                    self.initSwipe();

                    self.webglMode = false;
                    initSound()
                }

                self.Book.enable()
                self.book.hide().fadeIn("slow")

                this.createToc(this.options.tableOfContent);
                this.thumbsCreated = false;
                this.createMenu();

                this.createCurrentPage();
                if (!this.options.currentPage.enabled) {
                    this.currentPageHolder.hide()
                }

                if (this.options.pages.length == 1) {
                    this.rightToLeft = false
                    this.deeplinking = {
                        enabled: false
                    }
                }

                var $book = jQuery(self.Book)

                $book.bind('loadPagesFromPdf', function(e, arr, size, callback) {
                    self.loadPagesFromPdf(arr, size, callback)
                })

                $book.bind('turnPageComplete', function(e) {
                    self.turnPageComplete()
                })

                $book.bind('initEasing', function(e) {
                    self.initEasing()
                })

                $book.bind('playFlipSound', function(e) {
                    self.playFlipSound()
                })

                $book.bind('closeLightbox', function(e) {
                    self.closeLightbox()
                })

                $book.bind('updateCurrentPage', function(e) {
                    self.updateCurrentPage()
                })

                this.createLogo()

                this.onBookCreated()
            },

            onBookCreated: function() {

                var o = this.options

                var self = this
                jQuery(window).resize(function() {
                    self.resize();
                });

                if (o.rightToLeft) {
                    self.Book.goToPage(Number(o.pages.length - Number(o.startPage) + 1), true);
                } else {
                    self.Book.goToPage(Number(o.startPage), true);
                }

                this.updateCurrentPage();

                //keyboard evetns
                document.addEventListener("keydown", function(e) {
                    if (!self.Book.enabled)
                        return;

                    if (!self.options.lightBox && !self.fullscreenActive){
                        if(self.options.arrowsDisabledNotFullscreen || self.bodyHasVerticalScrollbar())
                            return;
                    }

                    e = e || window.event;
                    switch (e.keyCode) {
                        //left
                        case 37:
                            self.Book.prevPage();
                            break;
                            //up
                        case 38:
                            self.zoomIn();
                            break;
                            //right
                        case 39:
                            self.Book.nextPage();
                            break;
                            //down
                        case 40:
                            self.zoomOut();
                            break;
                    }
                    return false;
                })

                document.addEventListener("MSFullscreenChange", function(e) {
                    self.handleFsChange()
                });

                document.addEventListener("mozfullscreenchange", function(e) {
                    self.handleFsChange()
                });

                document.addEventListener("webkitfullscreenchange", function(e) {
                    self.handleFsChange()
                });

                document.addEventListener("fullscreenchange", function(e) {
                    self.handleFsChange()
                });

                // if (!o.zoomDisabled) {
                //disable page scrolling
                // jQuery(this.wrapper).on('DOMMouseScroll', function(e) {
                //     e.preventDefault();
                // });
                // jQuery(this.wrapper).on('mousewheel', function(e) {
                //     e.preventDefault();
                // });
                // }

                this.zoom = o.zoomMin;

                //add mouse scroll listeners
                // if (!o.zoomDisabled) {
                //Firefox
                this.bookLayer.bind('DOMMouseScroll', function(e) {

                    if (!self.Book.enabled) 
                        return;

                    if (!self.options.lightBox && !self.fullscreenActive){
                        if(self.options.wheelDisabledNotFullscreen || self.bodyHasVerticalScrollbar())
                            return;
                    }

                    e.stopPropagation()
                    e.preventDefault()

                    if (e.originalEvent.detail > 0) {
                        //scroll down
                        // console.log('Down');
                        self.zoomOut(e.originalEvent)
                    } else {
                        //scroll up
                        // console.log('Up');
                        self.zoomIn(e.originalEvent)
                    }
                    //prevent page fom scrolling
                    return false;
                });

                //IE, Opera, Safari
                this.bookLayer.bind('mousewheel', function(e) {

                    if (!self.Book.enabled) 
                        return;

                    if (!self.options.lightBox && !self.fullscreenActive){
                        if(self.options.wheelDisabledNotFullscreen || self.bodyHasVerticalScrollbar())
                            return;
                    }

                    e.stopPropagation()
                    e.preventDefault()

                    // alert("mousewheel")
                    if (e.originalEvent.wheelDelta < 0 /*|| e.originalEvent.deltaY < 0  -> zoom in does not work in chrome*/ ) {
                        //scroll down
                        // console.log('Down');
                        self.zoomOut(e.originalEvent)
                    } else {
                        //scroll up
                        // console.log('Up');
                        self.zoomIn(e.originalEvent)
                    }
                    //prevent page fom scrolling
                    return false;
                });

                this.setTool("toolMove")



                // this.bookLayer.bind('gesturestart', function(e) {
                //     if (!self.Book.enabled) return;
                //     // alert("gesturestart")
                //     if (e.scale < 1.0) {
                //         // User moved fingers closer together
                //     } else if (e.scale > 1.0) {
                //         // User moved fingers further apart
                //     }
                // }, false);

                // this.bookLayer.bind('gestureend', function(e) {
                //     if (!self.Book.enabled) return;
                //     // alert("gestureend")
                //     if (e.scale < 1.0) {
                //         self.zoomOut(e)
                //         // User moved fingers closer together
                //     } else if (e.scale > 1.0) {
                //         self.zoomIn(e)
                //         // User moved fingers further apart
                //     }
                // }, false);

                // this.bookLayer.bind('gesturechange', function(e) {
                //     if (!self.Book.enabled) return;
                //     // alert("gesturechange")
                //     if (e.scale < 1.0) {
                //         // User moved fingers closer together
                //         self.zoomOut(e)
                //     } else if (e.scale > 1.0) {
                //         // User moved fingers further apart
                //         self.zoomIn(e)
                //     }
                // }, false);

                // }

                if (o.contentOnStart) self.toggleToc(true);

                if (o.thumbnailsOnStart) self.toggleThumbs(true);

                if (o.autoplayOnStart) self.toggleAutoplay(true);

                if (self.options.lightBox)
                    self.Book.disable()

                self.Book.updateVisiblePages()

                self.initColors();

                self.resize();

                setTimeout(function() {
                    self.resize();
                }, 200)

                // setTimeout(function() {
                //     self.resize();
                // }, 400)

                setTimeout(function() {
                    self.resize();
                }, 600)

                if (o.onbookcreated)
                    o.onbookcreated.call(this)

            },

            initSwipe: function() {

                var self = this

                window.jQuery(this.bookLayer).swipe({

                    swipeStatus: function(e, phase, direction, distance, duration, fingerCount, fingerData) {
                        // console.log(e,phase,direction,distance,duration,fingerCount,fingerData)

                        // if(fingerCount > 1){
                        //     if(self.Book.disablePan)
                        //         self.Book.disablePan()
                        // }

                        // if(phase == 'end' || phase == 'cancel'){
                        //     if(self.Book.enablePan)
                        //         self.Book.enablePan()
                        // }

                        if (phase == 'start') {

                            try {
                                self.currentPageInput.trigger('blur')
                            } catch (e) {}
                        }

                        if (self.options.sideNavigationButtons && (e.target === self.arrowL[0] || e.target === self.arrowR[0])) return;

                        //gesture for fullscreen disabled

                        // if (phase == 'cancel' && duration < 200 && distance > 10 && direction == 'up') {
                        //     if (!self.fullscreenActive) self.toggleExpand();
                        // }

                        // if (phase == 'cancel' && duration < 200 && distance > 10 && direction == 'down') {
                        //     if (self.fullscreenActive) self.toggleExpand();
                        // }

                        /*if (e.type == 'touchend' && duration < 200 && distance < 10) {
                            // console.log("tap")
                            var posX = e.changedTouches[0].pageX
                            var w = self.bookLayer.width()

                            if (posX < (w / 3)) {
                                self.Book.prevPage()
                                e.preventDefault()
                                e.stopPropagation()
                            } else if (posX > (w * 2 / 3)) {
                                self.Book.nextPage()
                                e.preventDefault()
                                e.stopPropagation()
                            } else {
                                //tap in the middle
                                //                                 self.toggleMenu()
                                //                                 e.preventDefault()
                                //                                 e.stopPropagation()
                            }
                        } else */
                        if ((phase == "end" || phase == "cancel") && duration < 200 && distance < 10) {

                            // double tap zoom if text layer not active
                            // if (!self.options.textLayer && !self.options.doubleClickZoomDisabled) {
                            if (self.tool == "toolMove" && !self.options.doubleClickZoomDisabled) {

                                if (self.clickTimer == null) {
                                    self.clickTimer = setTimeout(function() {
                                        self.clickTimer = null;
                                        // console.log("single")
                                        if (e.type == 'touchend') {

                                            var posX = e.changedTouches[0].pageX

                                        } else if (e.type == 'mouseup') {
                                            var posX = e.offsetX
                                        }

                                        //turn page on click - disabled

                                        // var w = self.bookLayer.width()

                                        // if (posX < (w * 0.4) && self.zoom <= 1) {
                                        //     self.Book.prevPage()
                                        //     e.preventDefault()
                                        //     e.stopPropagation()
                                        // } else if (posX > (w * 0.6) && self.zoom <= 1) {
                                        //     self.Book.nextPage()
                                        //     e.preventDefault()
                                        //     e.stopPropagation()
                                        // }

                                    }, 300)
                                } else {
                                    clearTimeout(self.clickTimer);
                                    self.clickTimer = null;
                                    // console.log("double")

                                    var t = self.options.zoomTime
                                    if (self.zoom >= self.options.zoomMax)
                                        self.zoomTo(self.options.zoomMin, t, e)
                                    else
                                        self.zoomTo(self.options.zoomMax, t, e)

                                }
                            }

                            //start timer, if another click arrives 
                        } else {

                            if ((direction == "up" || direction == "down") && phase == 'move' || self.zoom > 1 || self.tool == "toolSelect") return;
                            // console.log(phase,direction,distance, fingerCount, fingerData)
                            self.Book.onSwipe(e, phase, direction, distance, duration, fingerCount, fingerData)
                        }

                        /*if (e.type == 'mouseup' && duration < 100 && distance < 10) {
                            var posX = e.pageX
                            var w = self.bookLayer.width()

                            if (posX < (w / 3)) {
                               e.stopPropagation();
                            e.preventDefault();
                            self.Book.prevPage();
                            } else if (posX > (w * 2 / 3)) {
                                e.stopPropagation();
                            e.preventDefault();
                            self.Book.nextPage();
                            } else {
                                        
                            }
                        }*/
                    },

                    // pinchIn: function(event, direction, distance, duration, fingerCount, pinchZoom) {
                        // console.log("pinch in")
                        // jQuery("#trace").text("You pinched " + direction + " by " + distance + "px, zoom scale is " + pinchZoom);
                    // },
                    // pinchOut: function(event, direction, distance, duration, fingerCount, pinchZoom) {
                        // console.log("pinch out")
                        // jQuery("#trace").text("You pinched " + direction + " by " + distance + "px, zoom scale is " + pinchZoom);
                    // },
                    pinchStatus: function(event, phase, direction, distance, duration, fingerCount, pinchZoom) {
                        // console.log(event, phase, direction, distance, duration, fingerCount, pinchZoom)
                        // console.log(pinchZoom)
                        if (phase == "start")
                            self.zoomStart = self.zoom

                        if (fingerCount > 1 && phase == "move"){

                            event.preventDefault()

                            if(event.scale)
                                pinchZoom = event.scale

                            // if (self.options.viewMode == "webgl"){
                                self.zoomTo(self.zoomStart * pinchZoom, 0, event)
                                // console.log("zoom to ",self.zoomStart * pinchZoom, event)
                            // }
                            
                        }

                   },

                    fingers: 2,

                    pinchThreshold: 0,

                    allowPageScroll: 'vertical',

                    preventDefaultEvents: false

                });

                this.swipeEnabled = true

            },

            toggleMenu: function() {

                if (this.menuShowing) {
                    //hide menu 
                    this.menuShowing = false

                    this.bookLayer.css('bottom', '0px');
                    this.menuWrapper.fadeOut()
                    this.currentPageHolder.fadeOut()
                    jQuery('.flipbook-nav').fadeOut()
                    this.Book.onResize()

                } else {
                    //show menu 
                    this.menuShowing = true

                    this.bookLayer.css('bottom', this.menuWrapper.height() + 'px');
                    this.menuWrapper.fadeIn()
                    this.currentPageHolder.fadeIn()
                    jQuery('.flipbook-nav').fadeIn()
                    this.Book.onResize()

                }

            },

            createButton: function(btn) {
                // console.log(btn)
                var o = this.options;
                if (o.icons == "material") {
                    var $btn = jQuery('<i>')
                        // .attr('aria-hidden', 'true')
                        .appendTo(this.menu)
                        // .addClass(btn.icon)
                        .addClass('material-icons flipbook-icon-material flipbook-menu-btn skin-color skin-color-bg')
                        .attr('title', btn.title)
                        .text(btn.icon2)

                    // o.btnSize = 24

                    $btn.css({

                        // 'width': o.btnSize + 'px',
                        // 'font-size': o.btnSize + 'px',
                        'border-radius': o.btnRadius + 'px',
                        // 'margin': o.btnMargin + 'px',
                        // 'padding': o.btnPaddingV + 'px ' + o.btnPaddingH + 'px',
                        'text-shadow': o.btnTextShadow,
                        'box-shadow': o.btnShadow,
                        'border': o.btnBorder,
                        'color': o.btnColor,
                        'background': o.btnBackground

                    })
                } else {


                    var $btn = jQuery(document.createElement('span'))
                        .appendTo(this.menu)
                        .attr('title', btn.title)

                    $btn.$icon = jQuery(document.createElement('span')).appendTo($btn)
                        .attr('aria-hidden', 'true')
                        .addClass(btn.icon)
                        .addClass('flipbook-icon-fa flipbook-menu-btn skin-color skin-color-bg fa')
                        .css({
                            'width': o.btnSize + 'px',
                            'font-size': o.btnSize + 'px',
                            'border-radius': o.btnRadius + 'px',
                            'margin': o.btnMargin + 'px',
                            'padding': o.btnPaddingV + 'px ' + o.btnPaddingH + 'px',
                            'text-shadow': o.btnTextShadow,
                            'box-shadow': o.btnShadow,
                            'border': o.btnBorder,
                            'color': o.btnColor,
                            'background': o.btnBackground

                        })

                    if(btn.iconAlt)
                        $btn.$iconAlt = jQuery(document.createElement('span')).appendTo($btn)
                        .attr('aria-hidden', 'true')
                        .addClass(btn.iconAlt)
                        .addClass('flipbook-icon-fa flipbook-menu-btn skin-color skin-color-bg fa')
                        .css({
                            'width': o.btnSize + 'px',
                            'font-size': o.btnSize + 'px',
                            'border-radius': o.btnRadius + 'px',
                            'margin': o.btnMargin + 'px',
                            'padding': o.btnPaddingV + 'px ' + o.btnPaddingH + 'px',
                            'text-shadow': o.btnTextShadow,
                            'box-shadow': o.btnShadow,
                            'border': o.btnBorder,
                            'color': o.btnColor,
                            'background': o.btnBackground

                        }).hide()

                }

                $btn.icon = btn.icon
                $btn.iconAlt = btn.iconAlt

                if (btn.onclick)
                    $btn.bind('tap click', function(e) {
                        btn.onclick()
                    })

                if (o.btnColorHover || o.btnBackgroundHover || o.btnBorderHover)

                    $btn.mouseenter(function() {
                        $btn.css({
                            'color': o.btnColorHover,
                            'background': o.btnBackgroundHover,
                            'border': o.btnBorderHover,

                        })
                    }).mouseleave(function() {
                        $btn.css({
                            'color': o.btnColor,
                            'background': o.btnBackground,
                            'border': o.btnBorder,

                        })
                    });

                return $btn

            },

            createMenu: function() {

                var o = this.options

                var self = this;
                this.menuWrapper = jQuery(document.createElement('div'))
                    .addClass('flipbook-menuWrapper')

                this.menuWrapper.appendTo(this.wrapper);

                if (o.hideMenu)
                    this.menuWrapper.hide();

                if (o.viewMode == "swipe") o.btnSound.enabled = false

                this.menu = jQuery(document.createElement('div'))
                    .addClass('flipbook-menu skin-color-bg')
                    .appendTo(this.menuWrapper)
                    .css({
                        'background': o.menuBackground,
                        'box-shadow': o.menuShadow,
                        'margin': o.menuMargin + 'px',
                        'padding': o.menuPadding + 'px',
                        'text-align': o.menuAlignHorizontal
                    })

                //if(o.menuAlignVertical === 'top') this.menuWrapper.css({'top':'0','bottom':'initial'});

                //arrows
                if (o.sideNavigationButtons) {

                    //if (self.options.btnNext.enabled)
                    self.btnNext = jQuery('<div class="flipbook-nav nav-next"><div class="flipbook-arrow-wrapper"><span class="flipbook-right-arrow fal ' + self.options.btnNext.icon + ' skin-color skin-color-bg"></div></div>')
                        .appendTo(self.bookLayer)
                        .bind('tap click', function(e) {

                            if (self.btnNext.disabled) return;
                            self.btnNext.disabled = true
                            setTimeout(function() {
                                self.btnNext.disabled = false;
                            }, 300)

                            e.stopPropagation();
                            e.preventDefault();
                            self.Book.nextPage();
                        });


                    self.arrowR = self.btnNext.find('span')

                    self.arrowR.css({

                        'width': o.sideBtnSize + 'px',
                        'font-size': o.sideBtnSize + 'px',
                        'border-radius': o.sideBtnRadius + 'px',
                        'margin-top': String(-o.sideBtnSize / 2) + 'px',
                        'margin-right': o.sideBtnMargin + 'px',
                        'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                        'text-shadow': o.sideBtnTextShadow,
                        'box-shadow': o.sideBtnShadow,
                        'border': o.sideBtnBorder,
                        'color': o.sideBtnColor,
                        'background': o.sideBtnBackground,
                        'box-sizing': 'initial'

                    }).attr("title", this.options.btnNext.title)


                    //if (self.options.btnPrev.enabled)
                    self.btnPrev = jQuery('<div class="flipbook-nav"><div class="flipbook-arrow-wrapper"><span class="flipbook-left-arrow fal ' + self.options.btnPrev.icon + ' skin-color skin-color-bg"></div></div>')
                        .appendTo(self.bookLayer)
                        .bind('tap click', function(e) {

                            if (self.btnPrev.disabled) return;
                            self.btnPrev.disabled = true
                            setTimeout(function() {
                                self.btnPrev.disabled = false;
                            }, 300)

                            e.stopPropagation();
                            e.preventDefault();
                            self.Book.prevPage();
                        })

                    self.arrowL = self.btnPrev.find('span')

                    self.arrowL.css({

                        'width': o.sideBtnSize + 'px',
                        'font-size': o.sideBtnSize + 'px',
                        'border-radius': o.sideBtnRadius + 'px',
                        'margin-top': String(-o.sideBtnSize / 2) + 'px',
                        'margin-left': o.sideBtnMargin + 'px',
                        'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                        'text-shadow': o.sideBtnTextShadow,
                        'box-shadow': o.sideBtnShadow,
                        'border': o.sideBtnBorder,
                        'color': o.sideBtnColor,
                        'background': o.sideBtnBackground,
                        'box-sizing': 'initial'

                    }).attr("title", this.options.btnPrev.title)

                    if (self.options.btnFirst.enabled) {
                        self.btnFirst = jQuery('<div class="flipbook-nav"><div class="flipbook-arrow-wrapper"><span class="flipbook-first-arrow fa ' + this.options.btnFirst.icon + ' skin-color skin-color-bg"></div></div>')
                            .appendTo(self.bookLayer)
                            .bind('tap click', function(e) {

                                if (self.btnFirst.disabled) return;
                                self.btnFirst.disabled = true
                                setTimeout(function() {
                                    self.btnFirst.disabled = false;
                                }, 300)


                                e.stopPropagation();
                                e.preventDefault();
                                self.Book.goToPage(1);
                            });

                        self.btnFirst.find('span').css({

                            'width': o.sideBtnSize + 'px',
                            'font-size': o.sideBtnSize * .66 + 'px',
                            'border-radius': o.sideBtnRadius + 'px',
                            'margin-top': String(o.sideBtnSize / 2 + o.sideBtnMargin + 2 * o.sideBtnPaddingV) + 'px',
                            'margin-left': o.sideBtnMargin + 'px',
                            'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                            'text-shadow': o.sideBtnTextShadow,
                            'box-shadow': o.sideBtnShadow,
                            'border': o.sideBtnBorder,
                            'color': o.sideBtnColor,
                            'background': o.sideBtnBackground,
                            'box-sizing': 'initial'

                        }).attr("title", this.options.btnFirst.title)
                    }

                    if (self.options.btnLast.enabled) {
                        self.btnLast = jQuery('<div class="flipbook-nav"><div class="flipbook-arrow-wrapper"><span class="flipbook-last-arrow fa ' + this.options.btnLast.icon + ' skin-color skin-color-bg"></div></div>')
                            .appendTo(self.bookLayer)
                            .bind('tap click', function(e) {

                                if (self.btnLast.disabled) return;
                                self.btnLast.disabled = true
                                setTimeout(function() {
                                    self.btnLast.disabled = false;
                                }, 300)


                                e.stopPropagation();
                                e.preventDefault();
                                self.Book.goToPage(self.options.pages.length);
                            });

                        self.btnLast.find('span').css({

                            'width': o.sideBtnSize + 'px',
                            'font-size': o.sideBtnSize * .66 + 'px',
                            'border-radius': o.sideBtnRadius + 'px',
                            'margin-top': String(o.sideBtnSize / 2 + o.sideBtnMargin + 2 * o.sideBtnPaddingV) + 'px',
                            'margin-right': o.sideBtnMargin + 'px',
                            'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                            'text-shadow': o.sideBtnTextShadow,
                            'box-shadow': o.sideBtnShadow,
                            'border': o.sideBtnBorder,
                            'color': o.sideBtnColor,
                            'background': o.sideBtnBackground,
                            'box-sizing': 'initial'

                        }).attr("title", this.options.btnLast.title)

                    }
                } else {

                    if (o.btnFirst.enabled)
                        this.btnFirst = this.createButton(o.btnFirst)
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            self.Book.goToPage(1);
                        })

                    if (o.btnPrev.enabled)
                        this.btnPrev = this.createButton(o.btnPrev)
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            self.Book.prevPage();
                        })

                    if (o.btnNext.enabled)
                        this.btnNext = this.createButton(o.btnNext)
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            self.Book.nextPage();
                        })


                    if (o.btnLast.enabled)
                        this.btnLast = this.createButton(o.btnLast)
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            self.Book.goToPage(self.options.pages.length);
                        })
                }

                if (o.btnAutoplay.enabled)
                    this.btnAutoplay = this.createButton(o.btnAutoplay)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if (!self.autoplay)
                            self.Book.nextPage()
                        self.toggleAutoplay();
                    });


                if (o.btnSearch.enabled) {

                    this.btnSearch = this.createButton(o.btnSearch)
                        .bind('touchend click', function(e) {

                            self.toggleSearch();
                        });
                    this.createSearch()

                }

                if (o.btnBookmark.enabled) {

                    this.btnBookmark = this.createButton(o.btnBookmark)
                        .bind('touchend click', function(e) {

                            self.toggleBookmark()

                            // if(self.bookmarkShowing)
                            //     self.toggleBookmark()
                            // else
                            //     self.toggleBookmarkMenu();

                        });

                    this.createBookmark()

                }

                if (o.btnZoomIn.enabled)
                    this.btnZoomIn = this.createButton(o.btnZoomIn)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.zoomIn();
                    });

                if (o.btnZoomOut.enabled)
                    this.btnZoomOut = this.createButton(o.btnZoomOut)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.zoomOut();
                    });

                this.onZoom(o.zoom)


                if (o.btnRotateLeft.enabled)
                    this.btnRotateLeft = this.createButton(o.btnRotateLeft)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if(self.Book.rotateLeft)
                            self.Book.rotateLeft()

                    });

                if (o.btnRotateRight.enabled)
                    this.btnRotateRight = this.createButton(o.btnRotateRight)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if(self.Book.rotateRight)
                            self.Book.rotateRight()
                        
                    });


                if (o.btnToc.enabled && (o.btnTocIfMobile || !o.isMobile))
                    this.btnToc = this.createButton(o.btnToc)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.toggleToc();
                    });

                if (o.btnThumbs.enabled && (o.btnThumbsIfMobile || !o.isMobile))
                    this.btnThumbs = this.createButton(o.btnThumbs)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.toggleThumbs();
                    });

                if (o.btnShare.enabled /*&& o.socialShare.length > 0*/ && (o.btnShareIfMobile || !o.isMobile)) {

                    this.btnShare = this.createButton(o.btnShare)
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            self.toggleShareMenu();
                        });

                }

                if (o.btnDownloadPages.enabled && (o.btnDownloadPagesIfMobile || !o.isMobile))
                    this.btnDownloadPages = this.createButton(o.btnDownloadPages)
                    .bind('touchend click', function(e) {

                        if (self.options.downloadMenu) {

                            self.toggleDownloadMenu()

                        } else {

                            e.stopPropagation();
                            e.preventDefault();

                            var link = document.createElement('a');
                            link.href = o.btnDownloadPages.url;
                            link.download = 'file.pdf';
                            link.dispatchEvent(new MouseEvent('click'));


                            // window.location = o.btnDownloadPages.url;

                        }

                    });

                if (o.btnPrint.enabled && (o.btnPrintIfMobile || !o.isMobile))
                    this.btnPrint = this.createButton(o.btnPrint)
                    .bind('touchend click', function(e) {

                        if (self.options.printMenu) {

                            self.togglePrintMenu();

                        } else {

                            e.stopPropagation();
                            e.preventDefault();
                            self.togglePrintWindow();

                        }

                    });

                if (o.btnDownloadPdf.enabled && (o.btnDownloadPdfIfMobile || !o.isMobile)) {

                    this.btnDownloadPdf = this.createButton(o.btnDownloadPdf)

                    if (o.pdfMode && !o.btnDownloadPdf.url)
                        o.btnDownloadPdf.url = o.pdfUrl

                    var downloadPdf = function(e) {

                        e.stopPropagation();
                        e.preventDefault();

                        if (o.btnDownloadPdf.forceDownload) {

                            var path = o.btnDownloadPdf.url;
                            var save = document.createElement('a');
                            save.href = path;
                            var filename = save.href.split('/').pop().split('#')[0].split('?')[0];
                            save.download = filename;
                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);

                        } else {

                            var target = o.btnDownloadPdf.openInNewWindow || typeof(o.btnDownloadPdf.openInNewWindow == 'undefined') ? '_blank' : '_self'
                            window.open(o.btnDownloadPdf.url, '_self')

                        }

                        if(self.gaCode){
                            ga('send', {
                               hitType: 'event',
                               eventCategory: 'Flipbook : '+self.options.name,
                               eventAction: 'download PDF' ,
                               eventLabel: o.btnDownloadPdf.url,
                               nonInteraction: true
                           });
                        }

                    }

                    this.btnDownloadPdf.bind('touchend click', downloadPdf);
                    $("#download-pdf").bind('touchend click', downloadPdf);

                }

                if (o.sound && o.btnSound.enabled && (o.btnSoundIfMobile || !o.isMobile))
                    this.btnSound = this.createButton(o.btnSound)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if (o.sound) {
                            o.sound = false
                            self.btnSound.find("."+self.btnSound.icon).hide()
                            self.btnSound.find("."+self.btnSound.iconAlt).show()
                        } else {
                            o.sound = true
                            self.btnSound.find("."+self.btnSound.icon).show()
                            self.btnSound.find("."+self.btnSound.iconAlt).hide()
                        }
                    });


                if (o.textLayer && o.btnSelect.enabled) {

                    this.btnSelect = this.createButton(o.btnSelect)
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            self.toggleTool()
                        })

                }

                if (o.btnExpand.enabled && (o.btnExpandIfMobile || !o.isMobile))
                    this.btnExpand = this.createButton(o.btnExpand)
                    .addClass('btnExpand')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.toggleExpand()
                    })


                if (o.btnSlideshow.enabled)
                    this.btnSlideshow = this.createButton(o.btnSlideshow)
                    .addClass('btnSlideshow')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.toggleSlideshow()
                    })

                if (o.buttons) {
                    for (var i = 0; i < o.buttons.length; i++) {
                        var btn = o.buttons[i]
                        self.createButton(btn).index(1)
                    }
                }

            },

            handleFsChange: function(e) {

                if (!this.Book || !this.Book.enabled)
                    return

                // var $el = this.lightbox ? this.$body : this.$elem
                var $el = jQuery(this.fullscreenElement)
                
                var currentFullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement
                if (currentFullscreenElement === this.fullscreenElement || this.isFullscreen) {
                    
                    this.btnExpand.find("."+this.btnExpand.icon).hide()
                    this.btnExpand.find("."+this.btnExpand.iconAlt).show()

                    $el.addClass('flipbook-browser-fullscreen')

                    this.fullscreenActive = true

                    if (this.options.onfullscreenenter)
                        this.options.onfullscreenenter.call(this)

                } else {

                    this.btnExpand.find("."+this.btnExpand.icon).show()
                    this.btnExpand.find("."+this.btnExpand.iconAlt).hide()

                    $el.removeClass('flipbook-browser-fullscreen')

                    this.fullscreenActive = false
                    
                    if (this.options.onfullscreenexit)
                        this.options.onfullscreenexit.call(this)
                }

                this.triggerResizeOnce()

            },

            createLogo: function() {
                var o = this.options
                if (!o.logoImg) return;
                if (o.isMobile && o.logoHideOnMobile) return;

                var $logo = jQuery('<img>')
                    .attr('src', o.logoImg)
                    .attr('style', o.logoCSS)
                    .appendTo(this.wrapper)

                if (o.logoAlignH == 'right')
                    $logo.css('right', '0')
                if (o.logoAlignV == 'bottom')
                    $logo.css('bottom', '0')

                if (o.logoUrl) {
                    $logo.bind('touchend click', function() {
                        window.open(o.logoUrl, '_blank')
                    })
                }
            },

            setLoadingProgress: function(percent) {

                if(this.$fillPreloader)
                    this.setFillPreloaderProgress(percent)
                else{
                    if (percent > 0 && percent < 1) {
                        jQuery(this.preloader).stop(true, true).show()
                    } else {
                        jQuery(this.preloader).stop(true, true).hide()
                    }
                }

                
            },

            setFillPreloaderProgress: function(percent) {

                if (!this.$fillPreloader)
                    return;

                if (percent > 0 && percent < 1) {

                    this.fillPreloaderProgress = this.fillPreloaderProgress || 0

                    if (percent < this.fillPreloaderProgress)
                        return;
                    else
                        this.fillPreloaderProgress = percent
                    // percent = .5
                    var img = this.$fillPreloaderImg[0]
                    img.style.clip = "rect(0px," + img.width * percent + "px," + img.height + "px,0px)"
                    this.$fillPreloader.show()

                } else {
                    this.$fillPreloader.hide()

                }
            },

            createNavigation: function() {
                var self = this;

                this.navLeft = jQuery('<div />');
                this.navLeft
                    // .appendTo(this.bookLayer)
                    // .css('position','absolute')
                    // .css('width','200px')
                    // .css('height','200px')
                    .css('background', '#f00')
                    .css('left', '0')
                    .css('top', '200px')
                    .attr('aria-hidden', 'true')
                    .addClass('skin-color fa fa-chevron-left fa-5x')
                    .css('margin-top', this.navLeft.height() + 'px')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.Book.prevPage();
                    });

                this.navRight = jQuery('<div />')
                    .appendTo(this.bookLayer)
                    .css('position', 'absolute')
                    .css('width', '200px')
                    .css('height', '200px')
                    .css('margin-top', '-100px')
                    .css('background', '#f00')
                    .css('right', '0')
                    .css('top', '200px')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.Book.nextPage();
                    });


            },
            playFlipSound: function() {

                var self = this

                if (this.options.sound && this.Book.enabled && typeof(this.flipsound.play) != 'undefined') {

                    this.flipsound.currentTime = 0;

                    setTimeout(function() {

                        try {

                            self.flipsound.play()

                        } catch (e) {

                        }

                    }, 100);
                }
            },

            onMouseWheel: function(e) {
                //console.log(e)

                if ('wheelDeltaX' in e) {
                    wheelDeltaX = e.wheelDeltaX / 12;
                    wheelDeltaY = e.wheelDeltaY / 12;
                } else if ('wheelDelta' in e) {
                    wheelDeltaX = wheelDeltaY = e.wheelDelta / 12;
                } else if ('detail' in e) {
                    wheelDeltaX = wheelDeltaY = -e.detail * 3;
                } else {
                    return;
                }
                if (wheelDeltaX > 0)
                    this.zoomIn(e)
                else
                    this.zoomOut(e);

            },

            zoomTo: function(val, time, e) {

                // console.log(val, time, e, e.pageX)

                this.zoom = val

                var x, y

                if (typeof e == 'undefined') {

                    //zoom to middle
                    x = this.model.wrapperW / 2
                    y = this.model.wrapperH / 2

                } else {

                    if (e.touches && e.touches[0]) {

                        x = e.touches[0].pageX
                        y = e.touches[0].pageY

                    } else if (e.changedTouches && e.changedTouches[0]) {

                        x = e.changedTouches[0].pageX
                        y = e.changedTouches[0].pageY

                    } else {

                        x = e.pageX
                        y = e.pageY
                    }

                    //main wrapper offset - works for all modes

                    // if(!this.fullscreenActive){
                        x = x - this.wrapper.offset().left
                        y = y - this.wrapper.offset().top
                    // }

                }

                // console.log(this.zoom, this.options.zoomMin, this.options.zoomMax)
                if(this.zoom < this.options.zoomMin)
                    this.zoom = this.options.zoomMin
                if(this.zoom > this.options.zoomMax)
                    this.zoom = this.options.zoomMax

                this.Book.zoomTo(this.zoom, time, x, y);

                this.onZoom(this.zoom)

            },

            zoomOut: function(e) {

                var newZoom = this.zoom / this.options.zoomStep
                newZoom = newZoom < this.options.zoomMin ? this.options.zoomMin : newZoom;

                if(this.zoom == newZoom)
                    return

                this.zoom = newZoom

                var t = this.options.zoomTime

                this.zoomTo(this.zoom, t, e)

            },

            zoomIn: function(e) {

                var newZoom = this.zoom * this.options.zoomStep

                if (this.bookLayer.height() * newZoom > this.options.zoomSize)
                    newZoom = this.options.zoomSize / this.bookLayer.height()
                //newZoom = newZoom > this.options.zoomMax ? this.options.zoomMax : newZoom;

                if(this.zoom == newZoom)
                    return

                this.zoom = newZoom

                var t = this.options.zoomTime

                this.zoomTo(this.zoom, t, e)

            },

            onZoom: function(newZoom) {
                this.zoom = newZoom
                this.enableButton(this.btnZoomIn, newZoom < this.options.zoomMax)
                this.enableButton(this.btnZoomOut, newZoom > this.options.zoomMin)
                // this.enableSwipe(newZoom <= this.options.zoomMin)
                this.enableSwipe(newZoom <= 1)
                /*if (this.pdfDocument)
                    this.pdfResize()*/
            },

            enableSwipe: function(val) {
                this.swipeEnabled = val
                /*if (this.bookLayer) {
                    var action = val ? "enable" : "disable"
                    window.jQuery(this.bookLayer).swipe(action)
                }*/
            },
            createCurrentPage: function() {
                var self = this;

                var currentPageHolder = jQuery('<div>').appendTo(this.wrapper).addClass('flipbook-currentPageHolder')

                if (this.options.currentPagePositionV == 'top')
                    currentPageHolder.css('top', '0')
                else
                    currentPageHolder.css('bottom', '0')

                if (this.options.currentPagePositionH == 'left')
                    currentPageHolder.css('left', '0')
                else
                    currentPageHolder.css('right', '0')

                currentPageHolder.css('margin', this.options.currentPageMarginV + 'px ' + this.options.currentPageMarginH + 'px')

                this.currentPageHolder = currentPageHolder
                this.currentPage = jQuery(document.createElement('div'))
                    .addClass('flipbook-currentPageNumber')
                    .appendTo(currentPageHolder)

                var $form = jQuery('<form>')
                    .appendTo(currentPageHolder)
                    .submit(function(e) {

                        var value = parseInt(self.currentPageInput.val());
                        value = value > self.options.pages.length ? self.options.pages.length : value;
                        if (self.options.rightToLeft) {

                            value = self.options.pages.length - value + 1;
                        }
                        //self.updateCurrentPage();
                        //if (self.options.singlePageMode) value--;
                        self.Book.goToPage(value);
                        self.currentPageInput.trigger('blur')
                        return false
                    })

                this.currentPageInput = jQuery('<input type="text" maxlength="4">')
                    .addClass('flipbook-currentPageInput')
                    .appendTo($form)
                    .focus(function() {

                        self.currentPageInput.val('').width(self.currentPageHolder.width())
                        self.currentPage.addClass('flipbook-color-transparent')

                    })
                    .blur(function() {

                        self.currentPage.removeClass('flipbook-color-transparent')
                        self.currentPageInput.val('')

                    })

            },

            createSearch: function() {

                var self = this;
                this.searchEnabled = true
                this.searchHolder = jQuery('<div>')
                    .addClass('flipbook-searchHolder skin-color-bg')
                    .appendTo(this.wrapper)
                    .hide()
                // .css('left', '-1000px')
                this.search = jQuery('<div>')
                    .addClass('flipbook-search')
                    .appendTo(this.searchHolder);
                self.searchScroll = new FLIPBOOK.IScroll(self.searchHolder[0], {
                    bounce: false,
                    mouseWheel: true,
                    scrollbars: true,
                    interactiveScrollbars: true,
                });

                // this.$searchResults = jQuery('<div>').addClass('flipbook-search-results').appendTo(this.searchHolder)

                this.createMenuHeader(this.search, "Search", this.toggleSearch)


                this.$searchBar = jQuery(
                    '<div class="flipbook-findbar" id="findbar" deluminate_imagetype="png">' +
                    '<div id="findbarInputContainer">' +
                    '<input id="findInput" class="toolbarField" title="Find" placeholder="'+this.strings.findInDocument+'...">' +
                    '</div>' +
                    '<div class="flipbook-find-info skin-color"/>' +
                    '</div>').appendTo(this.search)

                this.$findInput = this.$searchBar.find('#findInput').keyup(function() {
                    // console.log("searching", this.value)
                    if (this.value != '')
                        self.findInDocument(this.value)
                    else
                        self.unmark()

                })

                this.$findInfo = this.$searchBar.find('.flipbook-find-info')


                // load script     <script src="https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/jquery.mark.min.js"></script>


            },

            createBookmark: function() {


                var self = this;
                this.bookmarkHolder = jQuery('<div>')
                    .addClass('skin-color-bg flipbook-bmHolder flipbook-font')
                    .appendTo(this.wrapper)
                    .hide()
                // .css('left', '-1000px')
                this.createMenuHeader(this.bookmarkHolder, this.strings.bookmarks, this.toggleBookmark)
                
                this.bookmark = jQuery('<div>')
                    // .addClass('flipbook-toc')
                    .appendTo(this.bookmarkHolder);

                self.bookmarkScroll = new FLIPBOOK.IScroll(self.bookmarkHolder[0], {
                    bounce: false,
                    mouseWheel: true,
                    scrollbars: true,
                    interactiveScrollbars: true
                });


                var current = jQuery('<a><div class="c-p skin-color flipbook-btn">Bookmark current page</div></a>')
                    .appendTo(this.bookmark)
                    .bind('touchend click', function(e) {
                        self.bookmarkPage(self.cPage[0], this)
                        e.preventDefault()
                        e.stopPropagation()
                    })

                var left = jQuery('<a><div class="c-l-p skin-color flipbook-btn">'+this.strings.bookmarkLeftPage+'</div></a>')
                    .appendTo(this.bookmark)
                    .bind('touchend click', function(e) {
                        self.bookmarkPage(self.cPage[0], this)
                        e.preventDefault()
                        e.stopPropagation()
                    })

                var right = jQuery('<a><div class="c-r-p skin-color flipbook-btn">'+this.strings.bookmarkRightPage+'</div></a>')
                    .appendTo(this.bookmark)
                    .bind('touchend click', function(e) {
                        self.bookmarkPage(self.cPage[1], this)
                        e.preventDefault()
                        e.stopPropagation()
                    })

                // var all = jQuery('<a><div class="skin-color flipbook-btn">View Bookmarks</div></a>')
                //     .appendTo(this.bookmark)
                //     .bind('touchend click', function(e) {

                //         e.preventDefault()
                //         e.stopPropagation()

                //         self.toggleBookmark()

                //     })

            },

            createMenuHeader: function(elem, title, onClose) {

                var self = this

                var header = jQuery("<div>")
                    .addClass("flipbook-menu-header skin-clor flipbook-font")
                    .appendTo(elem);

                var title = jQuery('<span>')
                    .text(title)
                    .addClass('flipbook-menu-title skin-color')
                    .appendTo(header);

                var btnClose = jQuery('<span>').appendTo(header)
                    .addClass('flipbook-btn-close')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        onClose.call(self)
                    });

                var $icon = jQuery('<span>')
                    .attr('aria-hidden', 'true')
                    .appendTo(btnClose)
                    .addClass('fa fa-times flipbook-btn-close-icon skin-color')


            },

            createToc: function(tocArray) {

                var self = this;
                this.tocHolder = jQuery('<div>')
                    .addClass('flipbook-tocHolder skin-color-bg')
                    .appendTo(this.wrapper)
                    .hide()

                this.createMenuHeader(this.tocHolder, this.strings.tableOfContent, this.toggleToc)

                // .css('left', '-1000px')
                this.toc = jQuery('<div>')
                    .addClass('flipbook-toc')
                    .appendTo(this.tocHolder)

                this.tocScroller = jQuery('<div>')
                    .addClass('flipbook-toc-scroller')
                    .appendTo(this.toc);

                self.tocScroll = new FLIPBOOK.IScroll(self.toc[0], {
                    bounce: false,
                    mouseWheel: true,
                    scrollbars: true,
                    interactiveScrollbars: true
                });

                 if (tocArray && tocArray.length > 0) {

                    var pages = this.options.pages;
                    for (var i = 0; i < tocArray.length; i++) {

                        this.createTocItem(tocArray[i])
                    }

                } else {
                    var arr = []
                    var arr2 = []
                    if (this.options.rightToLeft) {
                        for (var i = this.options.pages.length - 1; i >= 0; i--)
                            arr2.push(this.options.pages[i])
                    } else {
                        arr2 = this.options.pages
                    }
                    for (var i = 0; i < arr2.length; i++) {
                        var title = arr2[i].title
                        if (title == "" || typeof title == 'undefined')
                            continue;
                        var page = String(i + 1)
                        var item = {title:title, page:page}

                        this.createTocItem(item)

                    }
                }

                self.tocScroll.refresh();
            },

            createTocItem:function(item, parent, level){

                var self = this
                var parent = parent || this.tocScroller

                var tocItem = jQuery(document.createElement('a'))
                .attr('class', 'flipbook-tocItem')
                .addClass('skin-color')
                // .attr('title', item.page)
                .appendTo(parent)
                .bind('touchend click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();

                    //console.log(item)

                    if (self.tocScroll.moved) 
                        return;

                    if (self.options.tableOfContentCloseOnClick)
                        self.toggleToc(false)

                    if(!item.page && item.dest){
                        self.pdfService.pdfDocument.getPageIndex(item.dest[0]).then(function(index){
                            // item.page = index + 1

                            var targetPage = index + 1

                            targetPage = self.options.rightToLeft ? self.options.pages.length - targetPage + 1 : targetPage   

                            setTimeout(function(){
                                self.Book.goToPage(targetPage);
                            },200)

                        })
                    }else{

                        var targetPage = item.page

                        targetPage = self.options.rightToLeft ? self.options.pages.length - targetPage + 1 : targetPage   

                        setTimeout(function(){
                            self.Book.goToPage(targetPage);
                        },200)

                    }
                    
                });

                if(!level) 
                    level = 0
                
                tocItem.level = level

                // tocItem.css('padding','8px 0')
                // tocItem.css('margin-left','10px')
                // if(!level){
                //     tocItem.css('margin-right','15px')
                //     tocItem.css('padding-left','10px')
                // }
                // else{
                //     tocItem.css('margin-top','8px')
                //     tocItem.css('padding-bottom','0')
                // }

                var expandBtn = jQuery(document.createElement('span'))
                .appendTo(tocItem)
                // .css('width','20px')
                // .css('display','inline-block')
                .css('cursor','auto')
                .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        for (var i = 0; i < tocItem.items.length; i++) {
                           tocItem.items[i].toggle()
                        }
                        $icon.toggle()
                        $icon2.toggle()
                        self.tocScroll.refresh();
                    })

                var $icon = jQuery('<span>')
                .attr('aria-hidden', 'true')
                .appendTo(expandBtn)
                .addClass('fa fa-chevron-right skin-color')
                .hide()

                var $icon2 = jQuery('<span>')
                .attr('aria-hidden', 'true')
                .appendTo(expandBtn)
                .addClass('fa fa-chevron-down skin-color')
                .hide()

                jQuery('<img/>')
                    .appendTo(tocItem)
                    .addClass("flipbook-thumb")
                    .attr('src', item.thumb)
                    .width(70);
                jQuery(document.createElement('span'))
                    .appendTo(tocItem)
                    .addClass('detail pages')
                    .text(`pages: ${item.pages}`);

                if(item.items && item.items.length){
                    tocItem.items = []
                    for (var i = 0; i < item.items.length; i++) {
                        var subItem = this.createTocItem(item.items[i], tocItem, tocItem.level + 1)
                        tocItem.items.push(subItem)
                        subItem.hide()
                    }
                    $icon.show()
                }

                return tocItem

            },

            enablePrev: function(val) {

                this.enableButton(this.btnPrev, val)
                this.enableButton(this.btnFirst, val)
                this.Book.enablePrev(val)

            },

            enableNext: function(val) {

                this.enableButton(this.btnNext, val)
                this.enableButton(this.btnLast, val)
                this.Book.enableNext(val)

            },

            /* enableAutoplay: function(val) {

                 this.enableButton(this.btnAutoplay, val)
                 this.enableButton(this.btnAutoplay, val)

             },*/

            enableButton: function(button, enabled) {
                if (typeof(button) == 'undefined')
                    return;
                if (enabled) {
                    button.css('opacity', '1')
                    button.css('pointer-events', 'auto')
                } else {
                    button.css('opacity', '0.2')
                    button.css('pointer-events', 'none')
                }
                button.enabled = enabled
            },

            resize: function() {

                var self = this

                if (!self.options.menuOverBook && self.menuShowing)
                    self.bookLayer.css('bottom', self.menuWrapper.height() + 'px');
                else
                    self.bookLayer.css('bottom', '0px');

                var model = this.model
                model.wrapperW = this.bookLayer.width()
                model.wrapperH = this.bookLayer.height()

                self.options.zoomMax = this.options.zoomSize / model.wrapperH

                self.Book.onResize();
                self.Book.zoomTo(self.options.zoomMin)

            },

            pdfResize: function() {
                var self = this
                debugger
                /*
                    //this.pdfDocument.getPage(1).then(function(page) {
                    //self.viewportOriginal = page.getViewport(1);
                var bh = self.bookLayer.height()
                scale = bh / self.viewportOriginal.height
                scale *= self.zoom

                function findClosestInArray(num, arr) {
                    var minDist = null
                    var dist
                    for (var i = 0; i < arr.length; i++) {
                        dist = Math.abs(num - arr[i])
                        if (!minDist || dist < minDist) {
                            minDist = dist
                            min = arr[i]
                        }
                    }
                    return min
                }

                scale = findClosestInArray(scale, self.options.pdf.supportedScales)


                if (self.Book && self.options.pdf.currentScale != scale)*/
                self.Book.onZoom();
                //});


            },

            createThumbs: function() {
                var self = this,
                    point1,
                    point2;
                if (!this.options.btnThumbs.enabled) {
                    return;
                }

                this.thumbsCreated = true;
                //create thumb holder - parent for thumb container
                this.thumbHolder = jQuery(document.createElement('div'))
                    .addClass('flipbook-thumbHolder')
                    .addClass('skin-color-bg')
                    .appendTo(self.wrapper)
                    .hide()
                // .css('left', '-1000px')
                //create thumb container - parent for thumbs
                this.thumbsWrapper = jQuery(document.createElement('div'))
                    .appendTo(this.thumbHolder)
                    .addClass('flipbook-thumbsWrapper')

                this.thumbsScroller = jQuery(document.createElement('div'))
                    .appendTo(this.thumbsWrapper)
                    .addClass('flipbook-thumbsScroller')

                this.createMenuHeader(this.thumbHolder, this.strings.thumbnails, this.toggleThumbs)

                self.thumbs = [];

                // var $thumb = jQuery('<div class="flipbook-thumb">').appendTo(self.thumbsContainer).width(self.options.thumbSize);

                var arr2 = []
                if (this.options.rightToLeft) {
                    for (var i = this.options.pages.length - 1; i >= 0; i--)
                        arr2.push(this.options.pages[i])
                } else {
                    arr2 = this.options.pages
                }

                var arr = []
                if (this.options.doublePage) {
                    for (var i = 0; i < arr2.length; i++) {
                        if (i == 0 || i % 2 != 0)
                            arr.push(arr2[i])
                    }
                } else {
                    arr = arr2
                }

                if (this.options.pdfMode) {
                    this.loadThumbsFromPdf(arr)
                }

                var h = this.options.thumbSize
                var w = this.options.thumbSize * this.options.pageWidth / this.options.pageHeight


                for (var i = 0; i < arr.length; i++) {
                    var th = arr[i].thumb;

                    var $thumb = jQuery('<div>')
                        .addClass("flipbook-thumb")
                        .appendTo(self.thumbsScroller)
                        .attr('data-thumb-index', i)
                        .width(w)
                        .height(h)



                    // var btnClose = jQuery(document.createElement('span'))
                    //     .attr('aria-hidden', 'true')
                    //     .appendTo($thumb)
                    //     .addClass('thumb-btn-close')
                    //     .addClass('fa fa-times')
                    //     .addClass('skin-color')
                    //     .bind('touchend click', function(e) {
                    //         e.stopPropagation();
                    //         e.preventDefault();
                    //         self.removeBookmark(jQuery(this).parent().attr("data-thumb-index"))
                    //         //remove bookmark
                    //     }).hide()




                var btnClose = jQuery('<span>')
                    .appendTo($thumb)
                    .addClass('thumb-btn-close')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.removeBookmark(jQuery(this).parent().attr("data-thumb-index"))
                    });

                var $icon = jQuery('<span>')
                    .attr('aria-hidden', 'true')
                    .appendTo(btnClose)
                    .addClass('fa fa-times skin-color')






               /*     var btnClose = jQuery('<span>')
                        .appendTo($thumb)
                        // .addClass('flipbook-btn-close')
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            self.removeBookmark(jQuery(this).parent().attr("data-thumb-index"))
                        })

                    var $icon = jQuery('<span>')
                        .attr('aria-hidden', 'true')
                        .appendTo(btnClose)
                        .addClass('fa fa-times flipbook-icon-fa skin-color')
                        .addClass('flipbook-btn-close')
                        // .hide()

                        */


                    // var emptyThumb = jQuery("<div class='flipbook-empty-thumb'>")
                    // .appendTo($thumb)
                    // .height(this.options.thumbSize)
                    // .width(this.options.thumbSize)


                    this.thumbs.push($thumb)

                    if (arr[i].thumbCanvas) {
                        var $thumbImg = jQuery(arr[i].thumbCanvas)
                    } else if (th) {
                        var $thumbImg = jQuery('<img/>').attr('src', th)
                        $thumbImg[0].onload = function() {
                            self.thumbScroll.refresh()
                        }

                    } else
                        continue;

                    $thumbImg.appendTo($thumb)
                    jQuery('<br/>').appendTo($thumb)
                    if (this.options.doublePage && i > 0) {
                        $thumb.width(2 * w)

                        $thumbImg
                            // .width(2 * self.options.thumbSize)
                            .height(h)
                            .width(2 * w)

                            .attr('page-title', 2 * i + 1)

                        var $pageNumber = jQuery(document.createElement('soan')).text(String(2 * i) + "-" + String(2 * i + 1))
                            .appendTo($thumb)
                            .addClass('skin-color')
                            .addClass('flipbook-thumb-num')
                        // .width(self.options.thumbSize);

                        // var $pageNumber = jQuery(document.createElement('span')).text(String(2 * i + 1))
                        //     .appendTo($thumb)
                        //     .addClass('skin-color')
                        //     .addClass('flipbook-thumb-num')
                        // .width(self.options.thumbSize);
                    } else {
                        $thumbImg
                            .height(h)
                            .width(w)
                            .attr('page-title', i + 1)

                        var $pageNumber = jQuery(document.createElement('span')).text(i + 1)
                            .appendTo($thumb)
                            .addClass('skin-color')
                            .addClass('flipbook-thumb-num')
                        // .width(self.options.thumbSize);


                    }

                    jQuery('.flipbook-carousel-slide').unbind('tap click').bind('tap click', function(e){
                        self.toggleThumbs(false);
                    });

                    $thumbImg.bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if (!self.thumbScroll.moved) {
                            var clickedPage = Number(jQuery(this).attr('page-title'));
                            if (self.options.rightToLeft)
                                clickedPage = self.options.pages.length - clickedPage + 1;

                            //if (self.options.singlePageMode) clickedPage--;
                           // if (self.Book.goingToPage != clickedPage)
                           setTimeout(function(){
                                self.Book.goToPage(clickedPage);
                           },200)
                                

                            if(self.options.thumbsCloseOnClick)
                                self.toggleThumbs(false)
                        }
                    });
                }

                this.thumbScroll = new FLIPBOOK.IScroll(this.thumbsWrapper[0], {
                    bounce: false,
                    mouseWheel: true,
                    scrollbars: true,
                    interactiveScrollbars: true
                });
            },
            toggleThumbs: function(value) {

                if (!this.thumbsCreated) {

                    this.createThumbs()
                    this.initColors()

                }

                if (this.thumbHolder) {

                    if (!this.thumbsShowing || value) {

                        this.closeMenus()
                        this.thumbsShowing = true
                        // this.thumbHolder.css('left', '0')
                        this.thumbHolder.show()
                        this.thumbsVertical();
                        if(!this.options.sideMenuOverBook)
                            this.bookLayer.css('left', this.thumbHolder.width() + 'px')
                        this.thumbsWrapper.appendTo(this.thumbHolder).css("top", "25px")
                        this.showAllThumbs()
                        jQuery(".thumb-btn-close").hide()

                    } else {

                        // this.thumbHolder.css('left', '-1000px')
                        this.thumbHolder.hide()
                        if(!this.options.sideMenuOverBook)
                            this.bookLayer.css('left', '0')
                        this.thumbsShowing = false

                    }

                    this.resize()
                }
            },


            toggleToc: function(value) {

                if (!this.tocShowing || value) {

                    this.closeMenus()
                    this.tocShowing = true
                    // this.tocHolder.css('left', '0').show()
                    this.tocHolder.show()
                    this.tocScroll.refresh();
                    if(!this.options.sideMenuOverBook)
                        this.bookLayer.css('left', this.tocHolder.width() + 'px')

                } else {

                    this.tocHolder.hide()
                    this.tocShowing = false
                    if(!this.options.sideMenuOverBook)
                        this.bookLayer.css('left', '0')

                }

                this.resize()

            },

            toggleSearch: function(value) {

                if (!this.thumbsCreated) {

                    this.createThumbs()
                    this.initColors()
                }

                if (!this.searchShowing || value) {

                    this.closeMenus()
                    this.searchShowing = true

                    this.searchHolder.show()
                    // this.searchHolder.css('left', '0')

                    if(!this.options.sideMenuOverBook)
                        this.bookLayer.css('left', this.searchHolder.width() + 'px')

                    this.thumbsWrapper.appendTo(this.searchHolder).css("top", "120px")
                    this.hideAllThumbs()
                    jQuery(".thumb-btn-close").hide()

                    this.searchScroll.refresh()
                    //focu search input
                    this.$findInput.focus()

                } else {

                    this.searchHolder.hide()
                    // this.searchHolder.css('left', '-1000px')
                    this.searchShowing = false
                    if(!this.options.sideMenuOverBook)
                        this.bookLayer.css('left', '0')

                }

                this.$findInput.val("")
                this.$findInfo.hide()
                this.resize()

                this.unmark()

            },

            toggleBookmark: function() {

                if (!this.thumbsCreated) {
                    this.createThumbs()
                    this.initColors()
                }

                if (!this.bookmarkShowing) {

                    this.closeMenus()
                    this.bookmarkShowing = true
                    jQuery(".thumb-btn-close").show()
                    // this.bookmarkHolder.css('left', '0')
                    this.bookmarkHolder.show()

                    this.bookmarkScroll.refresh();

                    if(!this.options.sideMenuOverBook)
                        this.bookLayer.css('left', this.bookmarkHolder.width() + 'px')

                    this.thumbsWrapper.appendTo(this.bookmarkHolder).css("top", "120px")
                    this.showBookmarkedThumbs()

                    this.bookmarkScroll.refresh()

                } else {

                    // this.bookmarkHolder.css('left', '-1000px')
                    this.bookmarkHolder.hide()
                    this.bookmarkShowing = false
                    jQuery(".thumb-btn-close").hide()

                    if(!this.options.sideMenuOverBook)
                        this.bookLayer.css('left', '0')

                }

                this.resize()

            },

            closeMenus: function() {

                if (this.thumbsShowing) this.toggleThumbs()
                if (this.tocShowing) this.toggleToc()
                if (this.searchShowing) this.toggleSearch()
                if (this.bookmarkShowing) this.toggleBookmark()

                if (this.printMenuShowing) this.togglePrintMenu()
                if (this.dlMenuShowing) this.toggleDownloadMenu()
                if (this.shareMenuShowing) this.toggleShareMenu()

            },

            togglePrintMenu: function() {

                var self = this

                if (!this.printMenu) {

                    this.printMenu = jQuery('<div class="flipbook-sub-menu flipbook-font">').appendTo(this.wrapper)

                    var center = jQuery('<idv class="flipbook-sub-menu-center">').appendTo(this.printMenu)
                    var content = jQuery('<idv class="flipbook-sub-menu-content skin-color-bg">').appendTo(center)

                    this.createMenuHeader(content, this.strings.print, this.togglePrintMenu)

                    var current = jQuery('<a><div class="c-p skin-color flipbook-btn">'+this.strings.printCurrentPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.printPage(self.cPage[0], this)
                        })
                    var left = jQuery('<a><div class="c-l-p skin-color flipbook-btn">'+this.strings.printLeftPage+'</div></a>').appendTo(this.printMenu)
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.printPage(self.cPage[0], this)
                        })

                    var right = jQuery('<a><div class="c-r-p skin-color flipbook-btn">'+this.strings.printRightPage+'</div></a>').appendTo(this.printMenu)
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.printPage(self.cPage[1], this)
                        })

                    var all = jQuery('<a><div class="skin-color flipbook-btn">'+this.strings.printAllPages+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {

                            self.togglePrintWindow()

                        })

                    this.closeMenus()
                    this.printMenuShowing = true
                    this.initColors()

                } else if (!this.printMenuShowing) {

                    this.closeMenus()

                    // this.printMenu.show()
                    this.printMenu.show()
                    this.printMenuShowing = true

                } else {

                    this.printMenu.hide()
                    this.printMenuShowing = false

                }

                if (this.cPage.length == 2) {
                    this.wrapper.find(".c-l-p").show()
                    this.wrapper.find(".c-r-p").show()
                    this.wrapper.find(".c-p").hide()
                } else {
                    this.wrapper.find(".c-l-p").hide()
                    this.wrapper.find(".c-r-p").hide()
                    this.wrapper.find(".c-p").show()
                }

            },

            toggleDownloadMenu: function() {

                var self = this

                if (!this.dlMenu) {

                    this.dlMenu = jQuery('<div class="flipbook-sub-menu flipbook-font">').appendTo(this.wrapper)

                    var center = jQuery('<idv class="flipbook-sub-menu-center">').appendTo(this.dlMenu)
                    var content = jQuery('<idv class="flipbook-sub-menu-content skin-color-bg">').appendTo(center)

                    this.createMenuHeader(content, this.strings.download, this.toggleDownloadMenu)

                    var current = jQuery('<a><div class="c-p skin-color flipbook-btn">'+this.strings.downloadCurrentPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.downloadPage(self.cPage[0], this)
                        })
                    var left = jQuery('<a><div class="c-l-p skin-color flipbook-btn">'+this.strings.downloadLeftPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.downloadPage(self.cPage[0], this)
                        })

                    var right = jQuery('<a><div class="c-r-p skin-color flipbook-btn">'+this.strings.downloadRightPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.downloadPage(self.cPage[1], this)
                        })

                    var all = jQuery('<a><div class="skin-color flipbook-btn">'+this.strings.downloadAllPages+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {

                            var link = document.createElement('a');
                            link.href = self.options.btnDownloadPages.url;
                            var filename = link.href.split('/').pop().split('#')[0].split('?')[0];
                            link.download = filename;
                            link.dispatchEvent(new MouseEvent('click'));

                            // window.location = self.options.btnDownloadPages.url;
                        })

                    this.closeMenus()
                    this.dlMenuShowing = true
                    this.initColors()

                } else if (!this.dlMenuShowing) {

                    // this.dlMenu.show()
                    this.dlMenu.show()
                    this.closeMenus()
                    this.dlMenuShowing = true

                } else {

                    this.dlMenu.hide()
                    this.dlMenuShowing = false

                }

                if (this.cPage.length == 2) {
                    this.wrapper.find(".c-l-p").show()
                    this.wrapper.find(".c-r-p").show()
                    this.wrapper.find(".c-p").hide()
                } else {
                    this.wrapper.find(".c-l-p").hide()
                    this.wrapper.find(".c-r-p").hide()
                    this.wrapper.find(".c-p").show()
                }

            },

            toggleShareMenu: function() {

                var self = this

                if (!this.shareMenu) {

                    this.shareMenu = jQuery('<div class="flipbook-sub-menu flipbook-font">').appendTo(this.wrapper)

                    var center = jQuery('<idv class="flipbook-sub-menu-center">').appendTo(this.shareMenu)
                    var content = jQuery('<idv class="flipbook-sub-menu-content skin-color-bg">').appendTo(center)

                    this.createMenuHeader(content, "Share", this.toggleShareMenu)

                    var shareBtn = jQuery('<idv class="flipbook-share">').appendTo(content)

                    var o = this.options

                    this.share = new Share(shareBtn[0], {
                        networks: {
                            google_plus: o.google_plus,
                            twitter: o.twitter,
                            facebook: o.facebook,
                            pinterest: o.pinterest,
                            email: o.email
                        }
                    });

                    this.closeMenus()
                    this.shareMenuShowing = true
                    this.initColors()

                } else if (!this.shareMenuShowing) {

                    // this.shareMenu.show()
                    this.shareMenu.show()

                    this.closeMenus()
                    this.shareMenuShowing = true

                } else {

                    this.shareMenu.hide()
                    this.shareMenuShowing = false

                }



            },

            bookmarkPage: function(index) {

                var arr = this.getBookmarkedPages()
                if (arr.indexOf(String(index)) < 0)
                    arr.push(index)
                this.setBookmarkedPages(arr)

                this.showBookmarkedThumbs()

                if (!this.bookmarkShowing)
                    this.toggleBookmark()

            },

            removeBookmark: function(index) {

                var arr = this.getBookmarkedPages()
                if (arr.indexOf(String(index)) > -1)
                    arr.splice(arr.indexOf(String(index)), 1)
                this.setBookmarkedPages(arr)

                this.showBookmarkedThumbs()

                if (!this.bookmarkShowing)
                    this.toggleBookmark()

            },


            isBookmarked: function(index) {
                var arr = this.getBookmarkedPages()
                return (arr.indexOf(String(index)) > 0)
            },

            getBookmarkedPages: function() {
                var str = localStorage.getItem(this.options.name + "_flipbook_bookmarks")
                if (str)
                    return str.split(";")
                else
                    return []
            },

            setBookmarkedPages: function(arr) {
                localStorage.setItem(this.options.name + "_flipbook_bookmarks", arr.join(";"))

            },


            printPage: function(index, link) {

                var url

                if (this.options.pages[index] && this.options.pages[index].print) {

                    url = this.options.pages[index].print

                } else if (this.options.pages[index] &&
                    this.options.pages[index].canvas &&
                    this.options.pages[index].canvas[this.options.pageTextureSize]) {

                    url = this.options.pages[index].canvas[this.options.pageTextureSize].toDataURL()
                } else if (this.options.pages[index] && this.options.pages[index].src) {

                    url = this.options.pages[index].src

                }

                if (url) {

                    var windowContent = '<!DOCTYPE html>';
                    windowContent += '<html>'
                    windowContent += '<head><title>Print canvas</title></head>';
                    windowContent += '<body>'
                    windowContent += '<img src="' + url + '">';
                    windowContent += '</body>';
                    windowContent += '</html>';
                    var printWin = window.open("", 'Print', 'height=1600,width=800');
                    printWin.document.open();
                    printWin.document.write(windowContent);
                    printWin.document.close();

                    printWin.document.addEventListener('load', function() {
                        printWin.focus();
                        printWin.print();
                        printWin.document.close();
                        printWin.close();
                    }, true);

                }

            },

            downloadPage: function(index) {

                if (this.options.pages[index] && this.options.pages[index].download) {

                    url = this.options.pages[index].download

                } else if (this.options.pages[index] && this.options.pages[index].src) {

                    url = this.options.pages[index].src

                } else if (this.options.pages[index] &&
                    this.options.pages[index].canvas &&
                    this.options.pages[index].canvas[this.options.pageTextureSize]) {

                    var c = document.createElement("canvas")
                    var r = this.options.pageWidth / this.options.pageHeight
                    c.width = this.options.pageTextureSize * r;
                    c.height = this.options.pageTextureSize;
                    var ctx = c.getContext("2d");
                    ctx.drawImage(this.options.pages[index].canvas[this.options.pageTextureSize], 0, 0);

                    // url = this.options.pages[index].canvas[this.options.pageTextureSize].toDataURL('image/jpeg', 0.5);
                    url = c.toDataURL('image/jpeg', 0.5);
                    // delete c

                }

                if (url) {

                    var link = document.createElement('a');
                    link.href = url
                    link.download = "page" + String(index + 1)
                    // link.dispatchEvent(new MouseEvent('click'));

                    document.body.appendChild(link);
                    link.click();
                    // Cleanup the DOM
                    document.body.removeChild(link);
                    // delete link;


                }

            },

            showAllThumbs: function() {

                jQuery(".flipbook-thumb").show()
                this.thumbScroll.refresh();

            },

            hideAllThumbs: function() {

                jQuery(".flipbook-thumb").hide()
                this.thumbScroll.refresh();


            },

            showThumb: function(index) {
                this.thumbs[index].show()
                this.thumbScroll.refresh();
            },

            hideThumb: function(index) {
                this.thumbs[index].hide()
                this.thumbScroll.refresh();

            },

            showBookmarkedThumbs: function() {

                var arr = this.getBookmarkedPages()

                this.hideAllThumbs()
                for (var i = 0; i < arr.length; i++) {
                    var index = arr[i]
                    if(index)
                    this.showThumb(index)
                }


            },

            printPdf: function(url) {

                /*try{
                    var iframe = this._printIframe;
                    if (!this._printIframe) {
                        iframe = this._printIframe = document.createElement('iframe');
                        document.body.appendChild(iframe);

                        
                    }

                    iframe.style.display = 'none';
                    iframe.onload = function() {
                        setTimeout(function() {
                            iframe.focus();
                            iframe.contentWindow.print();
                        }, 1);
                    };

                    iframe.src = url;
                }catch(err){*/
                var w = window.open(url, '_blank')
                w.onload = function() {
                    this.print()
                }
                /*
                                }*/
            },
            togglePrintWindow: function(value) {
                var self = this;

                if (self.options.printPdfUrl) {
                    self.printPdf(self.options.printPdfUrl)
                    return
                }

                if (self.options.pdfUrl) {
                    self.printPdf(self.options.pdfUrl)
                    return
                }

                function printme() {
                    link = "about:blank";
                    var pw = window.open(link, "_new");
                    pw.document.open();
                    var images = ""
                    for (var i = 0; i < self.options.pages.length; i++) {
                        if (self.options.pages[i].src)
                            images += '<img src="' + self.options.pages[i].src.toString() + '"/>\n'
                    }
                    var printHtml = printWindowHtml(images)
                    pw.document.write(printHtml);
                    pw.document.close();
                }


                function printWindowHtml(images) {
                    // We break the closing script tag in half to prevent
                    // the HTML parser from seeing it as a part of
                    // the *main* page.

                    return "<html>\n" +
                        "<head>\n" +
                        "<title>Temporary Printing Window</title>\n" +
                        "<script>\n" +
                        "function step1() {\n" +
                        "  setTimeout('step2()', 10);\n" +
                        "}\n" +
                        "function step2() {\n" +
                        "  window.print();\n" +
                        "  window.close();\n" +
                        "}\n" +
                        "</scr" + "ipt>\n" +
                        "</head>\n" +
                        "<body onLoad='step1()'>\n" +
                        images +
                        "</body>\n" +
                        "</html>\n";
                }

                printme()
                return;


                var self = this
                if (!this.printWindowCreated) {
                    this.printWindowCreated = true
                    this.printWindow = jQuery('<div>').addClass('flipbook-print-window').appendTo(this.wrapper)
                    var html = jQuery('<div class="panel panel-default">' +
                        '<div class="panel-heading">Print</div>' +
                        '<div class="panel-body">' +
                        '<div class="row">' +
                        '<div class="col-lg-12">' +
                        '<form role="form">' +
                        '<div class="form-group">' +
                        '<label></label>' +
                        '<label class="radio-inline"><input type="radio" name="optionsRadiosInline" id="optionsRadiosInline1" value="option1" checked>Left page</label>' +
                        '<label class="radio-inline"><input type="radio" name="optionsRadiosInline" id="optionsRadiosInline2" value="option2">Right page</label>' +
                        '<label class="radio-inline"><input type="radio" name="optionsRadiosInline" id="optionsRadiosInline3" value="option3">All pages</label>' +
                        '</div>' +
                        '<div class="form-group">' +
                        '<label>Or select one or more pages</label>' +
                        '<select multiple class="form-control">' +
                        '<option>Page 1</option>' +
                        '</select>' +
                        '</div>' +
                        '<button type="button" class="btn btn-default btn-close">Close</button>' +
                        '<button type="button" class="btn btn-default pull-right btn-print">Print</button>' +
                        '</form>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>').appendTo(this.printWindow).hide().fadeIn()

                    this.printWindow.find('.btn-print').bind('touchend click', function() {
                        printme()
                    })
                    this.printWindow.find('.btn-close').bind('touchend click', function() {
                        self.printWindow.fadeToggle()
                    })
                } else {
                    this.printWindow.fadeToggle()
                }
            },
            thumbsVertical: function() {
                if (!this.thumbsCreated)
                    return;
                this.thumbScroll.hScroll = false;
                this.thumbScroll.vScroll = true;
                this.thumbScroll.refresh();
            },

            toggleExpand: function(e) {

                this.browserFullscreen = true

                if (screenfull.enabled) {

                    screenfull.toggle(this.fullscreenElement)

                } else {

                    this.isFullscreen = !this.isFullscreen
                    this.handleFsChange()

                }

            },

            expand: function() {

            },

            toggleAutoplay: function(value) {
                var self = this
                this.autoplay = value || !this.autoplay;

                if (this.autoplay) {

                    self.btnAutoplay.find("."+self.btnAutoplay.icon).hide()
                    self.btnAutoplay.find("."+self.btnAutoplay.iconAlt).show()


                    this.autoplayTimer = setInterval(function() {

                        if (self.autoplay) {

                            var autoplayStartPage = self.options.autoplayStartPage || 1

                            if (self.options.rightToLeft) {
                                if (self.Book.prevEnabled)
                                    self.Book.prevPage()
                                else
                                    self.goToPage(self.options.pages.length - autoplayStartPage + 1)
                            } else {
                                if (self.Book.nextEnabled)
                                    self.Book.nextPage()
                                else
                                    self.goToPage(autoplayStartPage)
                            }

                        }
                    }, self.options.autoplayInterval)
                } else {
                    self.btnAutoplay.find("."+self.btnAutoplay.icon).show()
                    self.btnAutoplay.find("."+self.btnAutoplay.iconAlt).hide()
                    clearInterval(self.autoplayTimer)
                }
            },

            triggerResizeOnce: function() {
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 100);
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 500);
            },

            triggerResize: function() {

                // var self = this
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 100);
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 500);
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 2000);

            },

            toggleSlideshow: function() {

            },

            initEasing: function() {
                //easign functions
                window.jQuery.extend(window.jQuery.easing, {
                    def: 'easeOutQuad',
                    swing: function(x, t, b, c, d) {
                        //alert(jQuery.easing.default);
                        return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
                    },
                    easeInQuad: function(x, t, b, c, d) {
                        return c * (t /= d) * t + b;
                    },
                    easeOutQuad: function(x, t, b, c, d) {
                        return -c * (t /= d) * (t - 2) + b;
                    },
                    easeInOutQuad: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t + b;
                        return -c / 2 * ((--t) * (t - 2) - 1) + b;
                    },
                    easeInCubic: function(x, t, b, c, d) {
                        return c * (t /= d) * t * t + b;
                    },
                    easeOutCubic: function(x, t, b, c, d) {
                        return c * ((t = t / d - 1) * t * t + 1) + b;
                    },
                    easeInOutCubic: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t * t + b;
                        return c / 2 * ((t -= 2) * t * t + 2) + b;
                    },
                    easeInQuart: function(x, t, b, c, d) {
                        return c * (t /= d) * t * t * t + b;
                    },
                    easeOutQuart: function(x, t, b, c, d) {
                        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
                    },
                    easeInOutQuart: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t * t * t + b;
                        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
                    },
                    easeInQuint: function(x, t, b, c, d) {
                        return c * (t /= d) * t * t * t * t + b;
                    },
                    easeOutQuint: function(x, t, b, c, d) {
                        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                    },
                    easeInOutQuint: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t * t * t * t + b;
                        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
                    },
                    easeInSine: function(x, t, b, c, d) {
                        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
                    },
                    easeOutSine: function(x, t, b, c, d) {
                        return c * Math.sin(t / d * (Math.PI / 2)) + b;
                    },
                    easeInOutSine: function(x, t, b, c, d) {
                        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
                    },
                    easeInExpo: function(x, t, b, c, d) {
                        return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
                    },
                    easeOutExpo: function(x, t, b, c, d) {
                        return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
                    },
                    easeInOutExpo: function(x, t, b, c, d) {
                        if (t == 0)
                            return b;
                        if (t == d)
                            return b + c;
                        if ((t /= d / 2) < 1)
                            return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
                        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
                    },
                    easeInCirc: function(x, t, b, c, d) {
                        return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
                    },
                    easeOutCirc: function(x, t, b, c, d) {
                        return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
                    },
                    easeInOutCirc: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
                        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
                    },
                    easeInElastic: function(x, t, b, c, d) {
                        var s = 1.70158;
                        var p = 0;
                        var a = c;
                        if (t == 0)
                            return b;
                        if ((t /= d) == 1)
                            return b + c;
                        if (!p)
                            p = d * .3;
                        if (a < Math.abs(c)) {
                            a = c;
                            var s = p / 4;
                        } else
                            var s = p / (2 * Math.PI) * Math.asin(c / a);
                        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
                    },
                    easeOutElastic: function(x, t, b, c, d) {
                        var s = 1.70158;
                        var p = 0;
                        var a = c;
                        if (t == 0)
                            return b;
                        if ((t /= d) == 1)
                            return b + c;
                        if (!p)
                            p = d * .3;
                        if (a < Math.abs(c)) {
                            a = c;
                            var s = p / 4;
                        } else
                            var s = p / (2 * Math.PI) * Math.asin(c / a);
                        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
                    },
                    easeInOutElastic: function(x, t, b, c, d) {
                        var s = 1.70158;
                        var p = 0;
                        var a = c;
                        if (t == 0)
                            return b;
                        if ((t /= d / 2) == 2)
                            return b + c;
                        if (!p)
                            p = d * (.3 * 1.5);
                        if (a < Math.abs(c)) {
                            a = c;
                            var s = p / 4;
                        } else
                            var s = p / (2 * Math.PI) * Math.asin(c / a);
                        if (t < 1)
                            return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
                        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
                    },
                    easeInBack: function(x, t, b, c, d, s) {
                        if (s == undefined)
                            s = 1.70158;
                        return c * (t /= d) * t * ((s + 1) * t - s) + b;
                    },
                    easeOutBack: function(x, t, b, c, d, s) {
                        if (s == undefined)
                            s = 1.70158;
                        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
                    },
                    easeInOutBack: function(x, t, b, c, d, s) {
                        if (s == undefined)
                            s = 1.70158;
                        if ((t /= d / 2) < 1)
                            return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
                        return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
                    },
                    easeInBounce: function(x, t, b, c, d) {
                        return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
                    },
                    easeOutBounce: function(x, t, b, c, d) {
                        if ((t /= d) < (1 / 2.75)) {
                            return c * (7.5625 * t * t) + b;
                        } else if (t < (2 / 2.75)) {
                            return c * (7.5625 * (t -= (1.5 / 2.75)) * t + .75) + b;
                        } else if (t < (2.5 / 2.75)) {
                            return c * (7.5625 * (t -= (2.25 / 2.75)) * t + .9375) + b;
                        } else {
                            return c * (7.5625 * (t -= (2.625 / 2.75)) * t + .984375) + b;
                        }
                    },
                    easeInOutBounce: function(x, t, b, c, d) {
                        if (t < d / 2)
                            return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
                        return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
                    }
                });
            }
        };

        {

            FLIPBOOK.Book = function() {}

            FLIPBOOK.Book.prototype = {

                rightIndex: 0,

                goToPage: function() {
                    debugger
                }
            }

        }

        { /* FLIPBOOK.Lightbox */

            FLIPBOOK.Lightbox = function(context, content, options) {

                var self = this;
                this.context = context;
                this.options = options;
                this.lightboxOpened = false
                context.$elem.bind('tap click', function(e) {
                    self.openLightbox();
                    e.stopPropagation()
                    
                    /*if (self.context.options.lightBoxFullscreen) {
                        self.context.toggleExpand()
                    }*/
                });

                var img = jQuery(context.elem).find('img');

                self.overlay = jQuery(document.createElement('div'))
                    .attr('style', options.lightboxCSS)
                    .addClass('flipbook-overlay')
                    .css('display', 'none')
                    .css('top', self.options.lightboxMarginV)
                    .css('bottom', self.options.lightboxMarginV)
                    .css('left', self.options.lightboxMarginH)
                    .css('right', self.options.lightboxMarginH)
                    // .bind('tap click', function(e) {
                    //     if (jQuery(e.target).hasClass('flipbook-bookLayer') && self.options.lightboxCloseOnClick) {
                    //         self.closeLightbox();
                    //     }
                    // })
                    .appendTo('body')

                    if(self.options.lightboxCloseOnClick){
                        jQuery('body').bind('tap click', function(e){
                            var $target = jQuery(e.target)
                            if (!$target.parents().hasClass('flipbook-overlay') || $target.hasClass('flipbook-bookLayer'))
                                self.closeLightbox();
                        })
                    }

                if (options.lightboxBackground)
                    self.overlay.css('background', options.lightboxBackground)

                jQuery(document).keyup(function(e) {
                    if (e.keyCode == 27) {
                        self.closeLightbox();
                    } // escape key maps to keycode `27`
                });


                self.wrapper = jQuery(document.createElement('div'))
                    .css('height', 'auto')
                    .appendTo(self.overlay)
                // .hide()

                self.wrapper
                    .attr('class', 'flipbook-wrapper-transparent')
                    .css('margin', '0px auto')
                    .css('padding', '0px')
                    .css('height', '100%')
                    .css('width', '100%');

                content
                    .appendTo(self.wrapper);

                // close button
                var $toolbar = jQuery('<div/>')
                    .appendTo(self.wrapper)
                    .addClass('flipbook-lightbox-toolbar');

                var o = options

                var $close = jQuery('<span title="'+o.strings.pressEscToClose+'"/>').appendTo($toolbar)
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.closeLightbox();
                    })
                var $closeIcon = jQuery('<span/>').appendTo($close)
                    .addClass('flipbook-lightbox-close fa fa-times')
                    .css({
                        'font-size': o.closeBtnSize + 'px',
                        'padding': o.closeBtnPadding + 'px ',
                        'margin': o.closeBtnMargin + 'px ',
                        'border-radius': o.closeBtnRadius + 'px ',
                        'text-shadow': o.closeBtnTextShadow,
                        'color': o.closeBtnColor,
                        'background': o.closeBtnBackground,
                        'border': o.closeBtnBorder
                    })



                //    this.overlay.css('display','none');

            };

            FLIPBOOK.Lightbox.prototype = {

                openLightbox: function() {

                    if (this.lightboxOpened)
                        return;
                    this.lightboxOpened = true
                    // var self = this;
                    // this.overlay.css('visibility', 'visible');
                    this.overlay.css('display', 'none');
                    // this.overlay.css('transform','scale(.5)')
                    // this.overlay.css('-webkit-transform','scale(.5)')
                    // this.wrapper.css('display', 'none');
                    this.overlay.fadeIn("slow", function() {
                        // self.wrapper.css('display', 'block')
                        // self.wrapper.css('opacity', '1')
                        //self.context.lightboxStart();
                        // self.lightboxOpened = true
                    });


                    // if(this.context.Book){
                    //     this.context.Book.enable()
                    //     this.context.zoomTo(0,0)
                    //     this.context.zoomTo(this.options.zoomMin,1000)
                    // }
                    // this.wrapper.css('display', 'block')
                    // this.wrapper.css('opacity', '0')
                    jQuery('body').addClass('flipbook-overflow-hidden');
                    jQuery('html').addClass('flipbook-overflow-hidden');
                    // self.context.resize();
                },
                closeLightbox: function() {
                    var self = this;
                    if (self.lightboxOpened != true) return;
                    self.lightboxOpened = false;
                    this.overlay.fadeOut("fast");
                    //        this.overlay.css('visibility','hidden');
                    jQuery('body').removeClass('flipbook-overflow-hidden')
                    jQuery('html').removeClass('flipbook-overflow-hidden');

                    jQuery(this.context.fullscreenElement).removeClass('flipbook-browser-fullscreen');

                    self.context.lightboxEnd();
                },
                resize: function() {
                    var self = this;
                    var jQuerywindow = jQuery(window),
                        ww = jQuerywindow.width(),
                        wh = jQuerywindow.height();

                }
            };
        }

        {
            FLIPBOOK.pdfjsSrc = 'js/pdf.js';
            FLIPBOOK.markSrc = "https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/jquery.mark.min.js"

            FLIPBOOK.scriptsLoaded = {};
            FLIPBOOK.scriptsAdded = {};
        }

        // {/*image loader object*/

        //     FLIPBOOK.ImageLoader = function(){

        //         console.log("new ImageLoader()")

        //         this.images = {}

        //     }

        //     FLIPBOOK.ImageLoader.prototype = {

        //         loadImage : function(src, onComplete){

        //             console.log('load ',src)

        //             // var onComplete = onComplete || function(){}

        //             var images = this.images
                    
        //             if(!images[src]){
        //                 images[src] = document.createElement('img')
        //             }

        //             var img = images[src]

        //             if(img.loaded){
        //                 console.log("already loaded");
        //                 if(onComplete) onComplete(img);
        //                 return;
        //             }

        //             img.onComplete = img.onComplete || []
        //             img.onComplete.push(onComplete)

        //             if(img.loading){
        //                  console.log("loading...")
        //             }else{
        //                 img.onload = function(){
                        
        //                     img.loading = false
        //                     img.loaded = true
        //                     for (var i = 0; i < img.onComplete.length; i ++) {
        //                         var callback = img.onComplete[i]
        //                         if(callback) callback(img)
        //                         img.onComplete[i] = null
        //                     }
        //                 }
        //                 img.src = src
        //                 img.loading = true


        //             }

                    
        //         }

        //     }            

        // }

    })(jQuery, window, document)
}


{ /* screenfull.js */

    /*!
* screenfull
* v3.3.3 - 2018-09-04
* (c) Sindre Sorhus; MIT License
*/

!function(){"use strict";var a="undefined"!=typeof window&&void 0!==window.document?window.document:{},b="undefined"!=typeof module&&module.exports,c="undefined"!=typeof Element&&"ALLOW_KEYBOARD_INPUT"in Element,d=function(){for(var b,c=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],d=0,e=c.length,f={};d<e;d++)if((b=c[d])&&b[1]in a){for(d=0;d<b.length;d++)f[c[0][d]]=b[d];return f}return!1}(),e={change:d.fullscreenchange,error:d.fullscreenerror},f={request:function(b){var e=d.requestFullscreen;b=b||a.documentElement,/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)?b[e]():b[e](c?Element.ALLOW_KEYBOARD_INPUT:{})},exit:function(){a[d.exitFullscreen]()},toggle:function(a){this.isFullscreen?this.exit():this.request(a)},onchange:function(a){this.on("change",a)},onerror:function(a){this.on("error",a)},on:function(b,c){var d=e[b];d&&a.addEventListener(d,c,!1)},off:function(b,c){var d=e[b];d&&a.removeEventListener(d,c,!1)},raw:d};if(!d)return void(b?module.exports=!1:window.screenfull=!1);Object.defineProperties(f,{isFullscreen:{get:function(){return Boolean(a[d.fullscreenElement])}},element:{enumerable:!0,get:function(){return a[d.fullscreenElement]}},enabled:{enumerable:!0,get:function(){return Boolean(a[d.fullscreenEnabled])}}}),b?module.exports=f:window.screenfull=f}();

}

{ /*jQuery.browser.mobile*/
    /**
     * jQuery.browser.mobile (http://detectmobilebrowser.com/)
     *
     * jQuery.browser.mobile will be true if the browser is a mobile device
     *
     **/
    (function(a) {
        (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
    })(navigator.userAgent || navigator.vendor || window.opera);
}
/*!
 * @fileOverview TouchSwipe - jQuery Plugin
 * @version 1.6.18
 *
 * @author Matt Bryson http://www.github.com/mattbryson
 * @see https://github.com/mattbryson/TouchSwipe-Jquery-Plugin
 * @see http://labs.rampinteractive.co.uk/touchSwipe/
 * @see http://plugins.jquery.com/project/touchSwipe
 * @license
 * Copyright (c) 2010-2015 Matt Bryson
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 */
! function(factory) { "function" == typeof define && define.amd && define.amd.jQuery ? define(["jquery"], factory) : factory("undefined" != typeof module && module.exports ? require("jquery") : jQuery) }(function($) {
    "use strict";

    function init(options) {
        return !options || void 0 !== options.allowPageScroll || void 0 === options.swipe && void 0 === options.swipeStatus || (options.allowPageScroll = NONE), void 0 !== options.click && void 0 === options.tap && (options.tap = options.click), options || (options = {}), options = $.extend({}, $.fn.swipe.defaults, options), this.each(function() {
            var $this = $(this),
                plugin = $this.data(PLUGIN_NS);
            plugin || (plugin = new TouchSwipe(this, options), $this.data(PLUGIN_NS, plugin))
        })
    }

    function TouchSwipe(element, options) {
        function touchStart(jqEvent) {
            if (!(getTouchInProgress() || $(jqEvent.target).closest(options.excludedElements, $element).length > 0)) {
                var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
                if (!event.pointerType || "mouse" != event.pointerType || 0 != options.fallbackToMouseEvents) {
                    var ret, touches = event.touches,
                        evt = touches ? touches[0] : event;
                    return phase = PHASE_START, touches ? fingerCount = touches.length : options.preventDefaultEvents !== !1 && jqEvent.preventDefault(), distance = 0, direction = null, currentDirection = null, pinchDirection = null, duration = 0, startTouchesDistance = 0, endTouchesDistance = 0, pinchZoom = 1, pinchDistance = 0, maximumsMap = createMaximumsData(), cancelMultiFingerRelease(), createFingerData(0, evt), !touches || fingerCount === options.fingers || options.fingers === ALL_FINGERS || hasPinches() ? (startTime = getTimeStamp(), 2 == fingerCount && (createFingerData(1, touches[1]), startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start)), (options.swipeStatus || options.pinchStatus) && (ret = triggerHandler(event, phase))) : ret = !1, ret === !1 ? (phase = PHASE_CANCEL, triggerHandler(event, phase), ret) : (options.hold && (holdTimeout = setTimeout($.proxy(function() { $element.trigger("hold", [event.target]), options.hold && (ret = options.hold.call($element, event, event.target)) }, this), options.longTapThreshold)), setTouchInProgress(!0), null)
                }
            }
        }

        function touchMove(jqEvent) {
            var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
            if (phase !== PHASE_END && phase !== PHASE_CANCEL && !inMultiFingerRelease()) {
                var ret, touches = event.touches,
                    evt = touches ? touches[0] : event,
                    currentFinger = updateFingerData(evt);
                if (endTime = getTimeStamp(), touches && (fingerCount = touches.length), options.hold && clearTimeout(holdTimeout), phase = PHASE_MOVE, 2 == fingerCount && (0 == startTouchesDistance ? (createFingerData(1, touches[1]), startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start)) : (updateFingerData(touches[1]), endTouchesDistance = calculateTouchesDistance(fingerData[0].end, fingerData[1].end), pinchDirection = calculatePinchDirection(fingerData[0].end, fingerData[1].end)), pinchZoom = calculatePinchZoom(startTouchesDistance, endTouchesDistance), pinchDistance = Math.abs(startTouchesDistance - endTouchesDistance)), fingerCount === options.fingers || options.fingers === ALL_FINGERS || !touches || hasPinches()) {
                    if (direction = calculateDirection(currentFinger.start, currentFinger.end), currentDirection = calculateDirection(currentFinger.last, currentFinger.end), validateDefaultEvent(jqEvent, currentDirection), distance = calculateDistance(currentFinger.start, currentFinger.end), duration = calculateDuration(), setMaxDistance(direction, distance), ret = triggerHandler(event, phase), !options.triggerOnTouchEnd || options.triggerOnTouchLeave) {
                        var inBounds = !0;
                        if (options.triggerOnTouchLeave) {
                            var bounds = getbounds(this);
                            inBounds = isInBounds(currentFinger.end, bounds)
                        }!options.triggerOnTouchEnd && inBounds ? phase = getNextPhase(PHASE_MOVE) : options.triggerOnTouchLeave && !inBounds && (phase = getNextPhase(PHASE_END)), phase != PHASE_CANCEL && phase != PHASE_END || triggerHandler(event, phase)
                    }
                } else phase = PHASE_CANCEL, triggerHandler(event, phase);
                ret === !1 && (phase = PHASE_CANCEL, triggerHandler(event, phase))
            }
        }

        function touchEnd(jqEvent) {
            var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent,
                touches = event.touches;
            if (touches) { if (touches.length && !inMultiFingerRelease()) return startMultiFingerRelease(event), !0; if (touches.length && inMultiFingerRelease()) return !0 }
            return inMultiFingerRelease() && (fingerCount = fingerCountAtRelease), endTime = getTimeStamp(), duration = calculateDuration(), didSwipeBackToCancel() || !validateSwipeDistance() ? (phase = PHASE_CANCEL, triggerHandler(event, phase)) : options.triggerOnTouchEnd || options.triggerOnTouchEnd === !1 && phase === PHASE_MOVE ? (options.preventDefaultEvents !== !1 && jqEvent.cancelable !== !1 && jqEvent.preventDefault(), phase = PHASE_END, triggerHandler(event, phase)) : !options.triggerOnTouchEnd && hasTap() ? (phase = PHASE_END, triggerHandlerForGesture(event, phase, TAP)) : phase === PHASE_MOVE && (phase = PHASE_CANCEL, triggerHandler(event, phase)), setTouchInProgress(!1), null
        }

        function touchCancel() { fingerCount = 0, endTime = 0, startTime = 0, startTouchesDistance = 0, endTouchesDistance = 0, pinchZoom = 1, cancelMultiFingerRelease(), setTouchInProgress(!1) }

        function touchLeave(jqEvent) {
            var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
            options.triggerOnTouchLeave && (phase = getNextPhase(PHASE_END), triggerHandler(event, phase))
        }

        function removeListeners() { $element.unbind(START_EV, touchStart), $element.unbind(CANCEL_EV, touchCancel), $element.unbind(MOVE_EV, touchMove), $element.unbind(END_EV, touchEnd), LEAVE_EV && $element.unbind(LEAVE_EV, touchLeave), setTouchInProgress(!1) }

        function getNextPhase(currentPhase) {
            var nextPhase = currentPhase,
                validTime = validateSwipeTime(),
                validDistance = validateSwipeDistance(),
                didCancel = didSwipeBackToCancel();
            return !validTime || didCancel ? nextPhase = PHASE_CANCEL : !validDistance || currentPhase != PHASE_MOVE || options.triggerOnTouchEnd && !options.triggerOnTouchLeave ? !validDistance && currentPhase == PHASE_END && options.triggerOnTouchLeave && (nextPhase = PHASE_CANCEL) : nextPhase = PHASE_END, nextPhase
        }

        function triggerHandler(event, phase) { var ret, touches = event.touches; return (didSwipe() || hasSwipes()) && (ret = triggerHandlerForGesture(event, phase, SWIPE)), (didPinch() || hasPinches()) && ret !== !1 && (ret = triggerHandlerForGesture(event, phase, PINCH)), didDoubleTap() && ret !== !1 ? ret = triggerHandlerForGesture(event, phase, DOUBLE_TAP) : didLongTap() && ret !== !1 ? ret = triggerHandlerForGesture(event, phase, LONG_TAP) : didTap() && ret !== !1 && (ret = triggerHandlerForGesture(event, phase, TAP)), phase === PHASE_CANCEL && touchCancel(event), phase === PHASE_END && (touches ? touches.length || touchCancel(event) : touchCancel(event)), ret }

        function triggerHandlerForGesture(event, phase, gesture) {
            var ret;
            if (gesture == SWIPE) {
                if ($element.trigger("swipeStatus", [phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection]), options.swipeStatus && (ret = options.swipeStatus.call($element, event, phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection), ret === !1)) return !1;
                if (phase == PHASE_END && validateSwipe()) {
                    if (clearTimeout(singleTapTimeout), clearTimeout(holdTimeout), $element.trigger("swipe", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipe && (ret = options.swipe.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection), ret === !1)) return !1;
                    switch (direction) {
                        case LEFT:
                            $element.trigger("swipeLeft", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeLeft && (ret = options.swipeLeft.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection));
                            break;
                        case RIGHT:
                            $element.trigger("swipeRight", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeRight && (ret = options.swipeRight.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection));
                            break;
                        case UP:
                            $element.trigger("swipeUp", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeUp && (ret = options.swipeUp.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection));
                            break;
                        case DOWN:
                            $element.trigger("swipeDown", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeDown && (ret = options.swipeDown.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection))
                    }
                }
            }
            if (gesture == PINCH) {
                if ($element.trigger("pinchStatus", [phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]), options.pinchStatus && (ret = options.pinchStatus.call($element, event, phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData), ret === !1)) return !1;
                if (phase == PHASE_END && validatePinch()) switch (pinchDirection) {
                    case IN:
                        $element.trigger("pinchIn", [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]), options.pinchIn && (ret = options.pinchIn.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData));
                        break;
                    case OUT:
                        $element.trigger("pinchOut", [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]), options.pinchOut && (ret = options.pinchOut.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData))
                }
            }
            return gesture == TAP ? phase !== PHASE_CANCEL && phase !== PHASE_END || (clearTimeout(singleTapTimeout), clearTimeout(holdTimeout), hasDoubleTap() && !inDoubleTap() ? (doubleTapStartTime = getTimeStamp(), singleTapTimeout = setTimeout($.proxy(function() { doubleTapStartTime = null, $element.trigger("tap", [event.target]), options.tap && (ret = options.tap.call($element, event, event.target)) }, this), options.doubleTapThreshold)) : (doubleTapStartTime = null, $element.trigger("tap", [event.target]), options.tap && (ret = options.tap.call($element, event, event.target)))) : gesture == DOUBLE_TAP ? phase !== PHASE_CANCEL && phase !== PHASE_END || (clearTimeout(singleTapTimeout), clearTimeout(holdTimeout), doubleTapStartTime = null, $element.trigger("doubletap", [event.target]), options.doubleTap && (ret = options.doubleTap.call($element, event, event.target))) : gesture == LONG_TAP && (phase !== PHASE_CANCEL && phase !== PHASE_END || (clearTimeout(singleTapTimeout), doubleTapStartTime = null, $element.trigger("longtap", [event.target]), options.longTap && (ret = options.longTap.call($element, event, event.target)))), ret
        }

        function validateSwipeDistance() { var valid = !0; return null !== options.threshold && (valid = distance >= options.threshold), valid }

        function didSwipeBackToCancel() { var cancelled = !1; return null !== options.cancelThreshold && null !== direction && (cancelled = getMaxDistance(direction) - distance >= options.cancelThreshold), cancelled }

        function validatePinchDistance() { return null === options.pinchThreshold || pinchDistance >= options.pinchThreshold }

        function validateSwipeTime() { var result; return result = !options.maxTimeThreshold || !(duration >= options.maxTimeThreshold) }

        function validateDefaultEvent(jqEvent, direction) {
            if (options.preventDefaultEvents !== !1)
                if (options.allowPageScroll === NONE) jqEvent.preventDefault();
                else {
                    var auto = options.allowPageScroll === AUTO;
                    switch (direction) {
                        case LEFT:
                            (options.swipeLeft && auto || !auto && options.allowPageScroll != HORIZONTAL) && jqEvent.preventDefault();
                            break;
                        case RIGHT:
                            (options.swipeRight && auto || !auto && options.allowPageScroll != HORIZONTAL) && jqEvent.preventDefault();
                            break;
                        case UP:
                            (options.swipeUp && auto || !auto && options.allowPageScroll != VERTICAL) && jqEvent.preventDefault();
                            break;
                        case DOWN:
                            (options.swipeDown && auto || !auto && options.allowPageScroll != VERTICAL) && jqEvent.preventDefault();
                            break;
                        case NONE:
                    }
                }
        }

        function validatePinch() {
            var hasCorrectFingerCount = validateFingers(),
                hasEndPoint = validateEndPoint(),
                hasCorrectDistance = validatePinchDistance();
            return hasCorrectFingerCount && hasEndPoint && hasCorrectDistance
        }

        function hasPinches() { return !!(options.pinchStatus || options.pinchIn || options.pinchOut) }

        function didPinch() { return !(!validatePinch() || !hasPinches()) }

        function validateSwipe() {
            var hasValidTime = validateSwipeTime(),
                hasValidDistance = validateSwipeDistance(),
                hasCorrectFingerCount = validateFingers(),
                hasEndPoint = validateEndPoint(),
                didCancel = didSwipeBackToCancel(),
                valid = !didCancel && hasEndPoint && hasCorrectFingerCount && hasValidDistance && hasValidTime;
            return valid
        }

        function hasSwipes() { return !!(options.swipe || options.swipeStatus || options.swipeLeft || options.swipeRight || options.swipeUp || options.swipeDown) }

        function didSwipe() { return !(!validateSwipe() || !hasSwipes()) }

        function validateFingers() { return fingerCount === options.fingers || options.fingers === ALL_FINGERS || !SUPPORTS_TOUCH }

        function validateEndPoint() { return 0 !== fingerData[0].end.x }

        function hasTap() { return !!options.tap }

        function hasDoubleTap() { return !!options.doubleTap }

        function hasLongTap() { return !!options.longTap }

        function validateDoubleTap() { if (null == doubleTapStartTime) return !1; var now = getTimeStamp(); return hasDoubleTap() && now - doubleTapStartTime <= options.doubleTapThreshold }

        function inDoubleTap() { return validateDoubleTap() }

        function validateTap() { return (1 === fingerCount || !SUPPORTS_TOUCH) && (isNaN(distance) || distance < options.threshold) }

        function validateLongTap() { return duration > options.longTapThreshold && distance < DOUBLE_TAP_THRESHOLD }

        function didTap() { return !(!validateTap() || !hasTap()) }

        function didDoubleTap() { return !(!validateDoubleTap() || !hasDoubleTap()) }

        function didLongTap() { return !(!validateLongTap() || !hasLongTap()) }

        function startMultiFingerRelease(event) { previousTouchEndTime = getTimeStamp(), fingerCountAtRelease = event.touches.length + 1 }

        function cancelMultiFingerRelease() { previousTouchEndTime = 0, fingerCountAtRelease = 0 }

        function inMultiFingerRelease() {
            var withinThreshold = !1;
            if (previousTouchEndTime) {
                var diff = getTimeStamp() - previousTouchEndTime;
                diff <= options.fingerReleaseThreshold && (withinThreshold = !0)
            }
            return withinThreshold
        }

        function getTouchInProgress() { return !($element.data(PLUGIN_NS + "_intouch") !== !0) }

        function setTouchInProgress(val) { $element && (val === !0 ? ($element.bind(MOVE_EV, touchMove), $element.bind(END_EV, touchEnd), LEAVE_EV && $element.bind(LEAVE_EV, touchLeave)) : ($element.unbind(MOVE_EV, touchMove, !1), $element.unbind(END_EV, touchEnd, !1), LEAVE_EV && $element.unbind(LEAVE_EV, touchLeave, !1)), $element.data(PLUGIN_NS + "_intouch", val === !0)) }

        function createFingerData(id, evt) { var f = { start: { x: 0, y: 0 }, last: { x: 0, y: 0 }, end: { x: 0, y: 0 } }; return f.start.x = f.last.x = f.end.x = evt.pageX || evt.clientX, f.start.y = f.last.y = f.end.y = evt.pageY || evt.clientY, fingerData[id] = f, f }

        function updateFingerData(evt) {
            var id = void 0 !== evt.identifier ? evt.identifier : 0,
                f = getFingerData(id);
            return null === f && (f = createFingerData(id, evt)), f.last.x = f.end.x, f.last.y = f.end.y, f.end.x = evt.pageX || evt.clientX, f.end.y = evt.pageY || evt.clientY, f
        }

        function getFingerData(id) { return fingerData[id] || null }

        function setMaxDistance(direction, distance) { direction != NONE && (distance = Math.max(distance, getMaxDistance(direction)), maximumsMap[direction].distance = distance) }

        function getMaxDistance(direction) { if (maximumsMap[direction]) return maximumsMap[direction].distance }

        function createMaximumsData() { var maxData = {}; return maxData[LEFT] = createMaximumVO(LEFT), maxData[RIGHT] = createMaximumVO(RIGHT), maxData[UP] = createMaximumVO(UP), maxData[DOWN] = createMaximumVO(DOWN), maxData }

        function createMaximumVO(dir) { return { direction: dir, distance: 0 } }

        function calculateDuration() { return endTime - startTime }

        function calculateTouchesDistance(startPoint, endPoint) {
            var diffX = Math.abs(startPoint.x - endPoint.x),
                diffY = Math.abs(startPoint.y - endPoint.y);
            return Math.round(Math.sqrt(diffX * diffX + diffY * diffY))
        }

        function calculatePinchZoom(startDistance, endDistance) { var percent = endDistance / startDistance * 1; return percent.toFixed(2) }

        function calculatePinchDirection() { return pinchZoom < 1 ? OUT : IN }

        function calculateDistance(startPoint, endPoint) { return Math.round(Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2))) }

        function calculateAngle(startPoint, endPoint) {
            var x = startPoint.x - endPoint.x,
                y = endPoint.y - startPoint.y,
                r = Math.atan2(y, x),
                angle = Math.round(180 * r / Math.PI);
            return angle < 0 && (angle = 360 - Math.abs(angle)), angle
        }

        function calculateDirection(startPoint, endPoint) { if (comparePoints(startPoint, endPoint)) return NONE; var angle = calculateAngle(startPoint, endPoint); return angle <= 45 && angle >= 0 ? LEFT : angle <= 360 && angle >= 315 ? LEFT : angle >= 135 && angle <= 225 ? RIGHT : angle > 45 && angle < 135 ? DOWN : UP }

        function getTimeStamp() { var now = new Date; return now.getTime() }

        function getbounds(el) {
            el = $(el);
            var offset = el.offset(),
                bounds = { left: offset.left, right: offset.left + el.outerWidth(), top: offset.top, bottom: offset.top + el.outerHeight() };
            return bounds
        }

        function isInBounds(point, bounds) { return point.x > bounds.left && point.x < bounds.right && point.y > bounds.top && point.y < bounds.bottom }

        function comparePoints(pointA, pointB) { return pointA.x == pointB.x && pointA.y == pointB.y }
        var options = $.extend({}, options),
            useTouchEvents = SUPPORTS_TOUCH || SUPPORTS_POINTER || !options.fallbackToMouseEvents,
            START_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerDown" : "pointerdown" : "touchstart" : "mousedown",
            MOVE_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerMove" : "pointermove" : "touchmove" : "mousemove",
            END_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerUp" : "pointerup" : "touchend" : "mouseup",
            LEAVE_EV = useTouchEvents ? SUPPORTS_POINTER ? "mouseleave" : null : "mouseleave",
            CANCEL_EV = SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerCancel" : "pointercancel" : "touchcancel",
            distance = 0,
            direction = null,
            currentDirection = null,
            duration = 0,
            startTouchesDistance = 0,
            endTouchesDistance = 0,
            pinchZoom = 1,
            pinchDistance = 0,
            pinchDirection = 0,
            maximumsMap = null,
            $element = $(element),
            phase = "start",
            fingerCount = 0,
            fingerData = {},
            startTime = 0,
            endTime = 0,
            previousTouchEndTime = 0,
            fingerCountAtRelease = 0,
            doubleTapStartTime = 0,
            singleTapTimeout = null,
            holdTimeout = null;
        try { $element.bind(START_EV, touchStart), $element.bind(CANCEL_EV, touchCancel) } catch (e) { $.error("events not supported " + START_EV + "," + CANCEL_EV + " on jQuery.swipe") } this.enable = function() { return this.disable(), $element.bind(START_EV, touchStart), $element.bind(CANCEL_EV, touchCancel), $element }, this.disable = function() { return removeListeners(), $element }, this.destroy = function() { removeListeners(), $element.data(PLUGIN_NS, null), $element = null }, this.option = function(property, value) {
            if ("object" == typeof property) options = $.extend(options, property);
            else if (void 0 !== options[property]) {
                if (void 0 === value) return options[property];
                options[property] = value
            } else {
                if (!property) return options;
                $.error("Option " + property + " does not exist on jQuery.swipe.options")
            }
            return null
        }
    }
    var VERSION = "1.6.18",
        LEFT = "left",
        RIGHT = "right",
        UP = "up",
        DOWN = "down",
        IN = "in",
        OUT = "out",
        NONE = "none",
        AUTO = "auto",
        SWIPE = "swipe",
        PINCH = "pinch",
        TAP = "tap",
        DOUBLE_TAP = "doubletap",
        LONG_TAP = "longtap",
        HORIZONTAL = "horizontal",
        VERTICAL = "vertical",
        ALL_FINGERS = "all",
        DOUBLE_TAP_THRESHOLD = 10,
        PHASE_START = "start",
        PHASE_MOVE = "move",
        PHASE_END = "end",
        PHASE_CANCEL = "cancel",
        SUPPORTS_TOUCH = "ontouchstart" in window,
        SUPPORTS_POINTER_IE10 = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled && !SUPPORTS_TOUCH,
        SUPPORTS_POINTER = (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && !SUPPORTS_TOUCH,
        PLUGIN_NS = "TouchSwipe",
        defaults = { fingers: 1, threshold: 75, cancelThreshold: null, pinchThreshold: 20, maxTimeThreshold: null, fingerReleaseThreshold: 250, longTapThreshold: 500, doubleTapThreshold: 200, swipe: null, swipeLeft: null, swipeRight: null, swipeUp: null, swipeDown: null, swipeStatus: null, pinchIn: null, pinchOut: null, pinchStatus: null, click: null, tap: null, doubleTap: null, longTap: null, hold: null, triggerOnTouchEnd: !0, triggerOnTouchLeave: !1, allowPageScroll: "auto", fallbackToMouseEvents: !0, excludedElements: ".noSwipe", preventDefaultEvents: !0 };
    $.fn.swipe = function(method) {
        var $this = $(this),
            plugin = $this.data(PLUGIN_NS);
        if (plugin && "string" == typeof method) {
            if (plugin[method]) return plugin[method].apply(plugin, Array.prototype.slice.call(arguments, 1));
            $.error("Method " + method + " does not exist on jQuery.swipe")
        } else if (plugin && "object" == typeof method) plugin.option.apply(plugin, arguments);
        else if (!(plugin || "object" != typeof method && method)) return init.apply(this, arguments);
        return $this
    }, $.fn.swipe.version = VERSION, $.fn.swipe.defaults = defaults, $.fn.swipe.phases = { PHASE_START: PHASE_START, PHASE_MOVE: PHASE_MOVE, PHASE_END: PHASE_END, PHASE_CANCEL: PHASE_CANCEL }, $.fn.swipe.directions = { LEFT: LEFT, RIGHT: RIGHT, UP: UP, DOWN: DOWN, IN: IN, OUT: OUT }, $.fn.swipe.pageScroll = { NONE: NONE, HORIZONTAL: HORIZONTAL, VERTICAL: VERTICAL, AUTO: AUTO }, $.fn.swipe.fingers = { ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5, ALL: ALL_FINGERS }
});


//share
! function(t) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = t();
    else if ("function" == typeof define && define.amd) define([], t);
    else {
        var e;
        e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, e.Share = t()
    }
}(function() {
    var t;
    "classList" in document.documentElement || !Object.defineProperty || "undefined" == typeof HTMLElement || Object.defineProperty(HTMLElement.prototype, "classList", {
        get: function() {
            var t, e, o;
            return o = function(t) {
                return function(o) {
                    var n, i;
                    n = e.className.split(/\s+/), i = n.indexOf(o), t(n, i, o), e.className = n.join(" ")
                }
            }, e = this, t = {
                add: o(function(t, e, o) {
                    ~
                    e || t.push(o)
                }),
                remove: o(function(t, e) {
                    ~
                    e && t.splice(e, 1)
                }),
                toggle: o(function(t, e, o) {
                    ~
                    e ? t.splice(e, 1) : t.push(o)
                }),
                contains: function(t) {
                    return !!~e.className.split(/\s+/).indexOf(t)
                },
                item: function(t) {
                    return e.className.split(/\s+/)[t] || null
                }
            }, Object.defineProperty(t, "length", {
                get: function() {
                    return e.className.split(/\s+/).length
                }
            }), t
        }
    }), String.prototype.to_rfc3986 = function() {
        var t;
        return t = encodeURIComponent(this), t.replace(/[!'()*]/g, function(t) {
            return "%" + t.charCodeAt(0).toString(16)
        })
    }, t = function() {
        function t() {}
        return t.prototype.extend = function(t, e, o) {
            var n, i;
            for (i in e) n = void 0 !== t[i], n && "object" == typeof e[i] ? this.extend(t[i], e[i], o) : (o || !n) && (t[i] = e[i])
        }, t.prototype.hide = function(t) {
            return t.style.display = "none"
        }, t.prototype.show = function(t) {
            return t.style.display = "block"
        }, t.prototype.has_class = function(t, e) {
            return t.classList.contains(e)
        }, t.prototype.add_class = function(t, e) {
            return t.classList.add(e)
        }, t.prototype.remove_class = function(t, e) {
            return t.classList.remove(e)
        }, t.prototype.is_encoded = function(t) {
            return t = t.to_rfc3986(), decodeURIComponent(t) !== t
        }, t.prototype.encode = function(t) {
            return "undefined" == typeof t || this.is_encoded(t) ? t : t.to_rfc3986()
        }, t.prototype.popup = function(t, e) {
            var o, n, i, r;
            return null == e && (e = {}), n = {
                width: 500,
                height: 350
            }, n.top = screen.height / 2 - n.height / 2, n.left = screen.width / 2 - n.width / 2, i = function() {
                var t;
                t = [];
                for (o in e) r = e[o], t.push(o + "=" + this.encode(r));
                return t
            }.call(this).join("&"), i && (i = "?" + i), window.open(t + i, "targetWindow", "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,left=" + n.left + ",top=" + n.top + ",width=" + n.width + ",height=" + n.height)
        }, t
    }();
    var e, o = function(t, e) {
            function o() {
                this.constructor = t
            }
            for (var i in e) n.call(e, i) && (t[i] = e[i]);
            return o.prototype = e.prototype, t.prototype = new o, t.__super__ = e.prototype, t
        },
        n = {}.hasOwnProperty;
    return e = function(t) {
        function e(t, e) {
            return this.element = t, this.el = {
                head: document.getElementsByTagName("head")[0],
                body: document.getElementsByTagName("body")[0]
            }, this.config = {
                enabled_networks: 0,
                protocol: -1 === ["http", "https"].indexOf(window.location.href.split(":")[0]) ? "https://" : "//",
                url: window.location.href,
                caption: null,
                title: this.default_title(),
                image: this.default_image(),
                description: this.default_description(),
                ui: {
                    flyout: "top center",
                    button_text: "Share",
                    button_font: !0,
                    icon_font: !0
                },
                networks: {
                    google_plus: {
                        enabled: !0,
                        url: null
                    },
                    twitter: {
                        enabled: !0,
                        url: null,
                        description: null
                    },
                    facebook: {
                        enabled: !0,
                        load_sdk: !0,
                        url: null,
                        app_id: null,
                        title: null,
                        caption: null,
                        description: null,
                        image: null
                    },
                    pinterest: {
                        enabled: !0,
                        url: null,
                        image: null,
                        description: null
                    },
                    email: {
                        enabled: !0,
                        title: null,
                        description: null
                    }
                }
            }, this.setup(this.element, e), this
        }
        return o(e, t), e.prototype.setup = function(t, e) {
            var o, n, i, r, s;
            for (r = [t], this.extend(this.config, e, !0), this.set_global_configuration(), this.normalize_network_configuration(), this.config.networks.facebook.enabled && this.config.networks.facebook.load_sdk && this.inject_facebook_sdk(), n = o = 0, s = r.length; s > o; n = ++o) i = r[n], this.setup_instance(t, n)
        }, e.prototype.setup_instance = function(t, e) {
            var o, n, i, r, s, l, c, a, p;
            for (r = t, this.add_class(r, "sharer-" + e), this.inject_html(r), document.getElementById("flipbook-share-facebook").style.display = this.config.networks.facebook.display, document.getElementById("flipbook-share-twitter").style.display = this.config.networks.twitter.display, document.getElementById("flipbook-share-pinterest").style.display = this.config.networks.pinterest.display, document.getElementById("flipbook-share-email").style.display = this.config.networks.email.display, document.getElementById("flipbook-share-google_plus").style.display = this.config.networks.google_plus.display, s = r.getElementsByTagName("label")[0], n = r.getElementsByClassName("social")[0], a = r.getElementsByTagName("li"), this.add_class(n, "networks-" + this.config.enabled_networks), r.addEventListener("click", function(t) {
                    return function() {
                        return t.event_toggle(n)
                    }
                }(this)), o = this, p = [], e = i = 0, l = a.length; l > i; e = ++i) c = a[e], p.push(c.addEventListener("click", function() {
                return o.event_network(r, this), o.event_close(n)
            }));
            return p
        }, e.prototype.event_toggle = function(t) {
            return this.has_class(t, "active") ? this.event_close(t) : this.event_open(t)
        }, e.prototype.event_open = function(t) {
            return this.has_class(t, "load") && this.remove_class(t, "load"), this.add_class(t, "active")
        }, e.prototype.event_close = function(t) {
            return this.remove_class(t, "active")
        }, e.prototype.event_network = function(t, e) {
            var o;
            return o = e.getAttribute("data-network"), this.hook("before", o, t), this["network_" + o](), this.hook("after", o, t)
        }, e.prototype.open = function() {
            return this["public"]("open")
        }, e.prototype.close = function() {
            return this["public"]("close")
        }, e.prototype.toggle = function() {
            return this["public"]("toggle")
        }, e.prototype["public"] = function(t) {
            var e, o, n, i, r, s, l;
            for (s = document.querySelectorAll(this.element), l = [], n = o = 0, r = s.length; r > o; n = ++o) i = s[n], e = i.getElementsByClassName("social")[0], l.push(this["event_" + t](e));
            return l
        }, e.prototype.network_facebook = function() {
            return this.config.networks.facebook.load_sdk ? window.FB ? FB.ui({
                method: "feed",
                name: this.config.networks.facebook.title,
                link: this.config.networks.facebook.url,
                picture: this.config.networks.facebook.image,
                caption: this.config.networks.facebook.caption,
                description: this.config.networks.facebook.description
            }) : console.error("The Facebook JS SDK hasn't loaded yet.") : this.popup("https://www.facebook.com/sharer/sharer.php", {
                u: this.config.networks.facebook.url
            })
        }, e.prototype.network_twitter = function() {
            return this.popup("https://twitter.com/intent/tweet", {
                text: this.config.networks.twitter.description,
                url: this.config.networks.twitter.url
            })
        }, e.prototype.network_google_plus = function() {
            return this.popup("https://plus.google.com/share", {
                url: this.config.networks.google_plus.url
            })
        }, e.prototype.network_pinterest = function() {
            return this.popup("https://www.pinterest.com/pin/create/button", {
                url: this.config.networks.pinterest.url,
                media: this.config.networks.pinterest.image,
                description: this.config.networks.pinterest.description
            })
        }, e.prototype.network_email = function() {
            return this.popup("mailto:", {
                subject: this.config.networks.email.title,
                body: this.config.networks.email.description + '%0D%0A' + this.config.url
            })
        }, e.prototype.inject_stylesheet = function(t) {
            var e;
            return this.el.head.querySelector('link[href="' + t + '"]') ? void 0 : (e = document.createElement("link"), e.setAttribute("rel", "stylesheet"), e.setAttribute("href", t), this.el.head.appendChild(e))
        }, e.prototype.inject_html = function(t) {
            return t.innerHTML = "<div class='social load " + this.config.ui.flyout + "'><ul><li id='flipbook-share-pinterest' class='fab fa-pinterest-p skin-color' data-network='pinterest'></li><li id='flipbook-share-twitter' class='fab fa-twitter skin-color' data-network='twitter'></li><li id='flipbook-share-facebook' class='fab fa-facebook-f skin-color' data-network='facebook'></li><li id='flipbook-share-google_plus' class='fab fa-google-plus-g skin-color' data-network='google_plus'></li><li id='flipbook-share-email' class='fas fa-at skin-color' data-network='email'></li></ul></div>"
        }, e.prototype.inject_facebook_sdk = function() {
            var t, e;
            return window.FB || !this.config.networks.facebook.app_id || this.el.body.querySelector("#fb-root") ? void 0 : (e = document.createElement("script"), e.text = "window.fbAsyncInit=function(){FB.init({appId:'" + this.config.networks.facebook.app_id + "',status:true,xfbml:true})};(function(e,t,n){var r,i=e.getElementsByTagName(t)[0];if(e.getElementById(n)){return}r=e.createElement(t);r.id=n;r.src='" + this.config.protocol + "connect.facebook.net/en_US/all.js';i.parentNode.insertBefore(r,i)})(document,'script','facebook-jssdk')", t = document.createElement("div"), t.id = "fb-root", this.el.body.appendChild(t), this.el.body.appendChild(e))
        }, e.prototype.hook = function(t, e, o) {
            var n, i;
            n = this.config.networks[e][t], "function" == typeof n && (i = n.call(this.config.networks[e], o), void 0 !== i && (i = this.normalize_filter_config_updates(i), this.extend(this.config.networks[e], i, !0), this.normalize_network_configuration()))
        }, e.prototype.default_title = function() {
            var t;
            return (t = document.querySelector('meta[property="og:title"]') || document.querySelector('meta[name="twitter:title"]')) ? t.getAttribute("content") : (t = document.querySelector("title")) ? t.innerText : void 0
        }, e.prototype.default_image = function() {
            var t;
            return (t = document.querySelector('meta[property="og:image"]') || document.querySelector('meta[name="twitter:image"]')) ? t.getAttribute("content") : void 0
        }, e.prototype.default_description = function() {
            var t;
            return (t = document.querySelector('meta[property="og:description"]') || document.querySelector('meta[name="twitter:description"]') || document.querySelector('meta[name="description"]')) ? t.getAttribute("content") : ""
        }, e.prototype.set_global_configuration = function() {
            var t, e, o, n, i, r;
            i = this.config.networks, r = [];
            for (e in i) {
                n = i[e];
                for (o in n) null == this.config.networks[e][o] && (this.config.networks[e][o] = this.config[o]);
                this.config.networks[e].enabled ? (t = "block", this.config.enabled_networks += 1) : t = "none", r.push(this.config.networks[e].display = t)
            }
            return r
        }, e.prototype.normalize_network_configuration = function() {
            return this.config.networks.facebook.app_id || (this.config.networks.facebook.load_sdk = !1), this.is_encoded(this.config.networks.twitter.description) || (this.config.networks.twitter.description = encodeURIComponent(this.config.networks.twitter.description)), "number" == typeof this.config.networks.facebook.app_id ? this.config.networks.facebook.app_id = this.config.networks.facebook.app_id.toString() : void 0
        }, e.prototype.normalize_filter_config_updates = function(t) {
            return this.config.networks.facebook.app_id !== t.app_id && (console.warn("You are unable to change the Facebook app_id after the button has been initialized. Please update your Facebook filters accordingly."), delete t.app_id), this.config.networks.facebook.load_sdk !== t.load_sdk && (console.warn("You are unable to change the Facebook load_sdk option after the button has been initialized. Please update your Facebook filters accordingly."), delete t.app_id), t
        }, e
    }(t)
});


// WEBPACK FOOTER //
// ./src/plugins/swipebook-pdf-viewer/js/flipbook.js